import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import { Modal, message } from "antd";
import maintenanceService from '../maintenance.service';
import {
    EntityTag,
    IApiUser,
    IAuth,
    ICreateApiUser,
    ICreateOrganisationWithApiUser,
    ICreateWaitlistEntry,
    IWaitlistEntry,
    IWaitlistStats,
    ICharterPageConfig,
    ISubmitCharterApplication,
    ICharterApplication,
    ICharterApplicationStats,
    IHypothesisLead,
    IHypothesisLeadPage,
    IHypothesisDomainPolicy,
    IPublicHypothesisConfig,
    IPublicHypothesisRequestResult,
    IPublicHypothesisVerifyResult,
    IPublicHypothesisStatus,
    IPublicHypothesisResult,
    IHypothesisSubjectDetail,
    IOrganisation,
    IUpdateApiUser,
    IBrandEquity,
    IBrand,
    ITrendData,
    IQuestionTemplate,
    IUpdateQuestionTemplate,
    ISurvey,
    ICreateSurveyPayload,
    ISurveyResponse,
    ISurveyResponseSummary,
    ISurveyCohort,
    IQuestionCoverageResponse,
    ICalculateBrandEquityRequest,
    IBrandEquityScoreResponse,
    IApiKey,
    ICreateApiKeyRequest,
    ICreateApiKeyResponse,
    IUpdateApiKeyRequest,
    ISubscription,
    ISubscriptionCreateResponse,
    ICreateSubscriptionRequest,
    IUpdateSubscriptionRequest,
    IPaymentMethod,
    IInvoicesResponse,
    IStripeSetupIntent,
    IAnnualPromotion,
    ISubscriptionFeatures,
    IAIExpert,
    IKnowledgeDocument,
    IDocumentStats,
    IAIConversation,
    IAIMessage,
    ISystemStats,
    IUpdateExpertRequest,
    IChatRequest,
    IChatResponse,
    IImpersonationRequest,
    IImpersonationResponse,
    IImpersonationStopResponse,
    IReturnToAdminResponse,
    IAgencyContextResponse,
    IAgencyReturnResponse,
    IAgencyClient,
    IAgencyPortfolioClient,
    IAgencyClientBrandSummary,
    IAgencyPortfolioSummary,
    IAgencyActivityFeed,
    IAgencyActivityItem,
    IAgencyInviteClientDto,
    IAgencyUserAccess,
    IAgencyPortfolioAnalytics,
    IAgencyBrandTrend,
    IAgencyBrandTrendPoint,
    IAgencyClientScorecard,
    IAgencyBrandBucket,
    IAgencyElementScore,
    IAgencyBenchmarkPosition,
    IAgencySignal,
    IAgencyAnalyticsBrand,
    IAgencyAnalyticsClient,
    IAdminBrandResponse,
    IBrandKnowledgeProfile,
    IHypothesisCard,
    IModelBeliefsRead,
    IModelBeliefsGateSummary,
    IModelBeliefsCell,
    IModelBeliefsStatementRead,
    IModelBeliefsPageMove,
    IModelBeliefsPageMoves,
    IModelBeliefsPageFinding,
    IModelBeliefsPageFindings,
    IModelBeliefsPageReading,
    IModelBeliefsSynthesis,
    IModelBeliefsRecordFix,
    IUpdateBrandKnowledge,
    IBrandKnowledgeInspection,
    IBrandKnowledgeDocument,
    IBrandKnowledgeDocumentText,
    IBrandFieldSuggestions,
    IAdminSurveyResponse,
    IAdminSurveyCohortResponse,
    ITokenUsageSummary,
    IOrganizationTokenUsageByUser,
    IBrandAnalytics,
    IBrandAnalyticsSummary,
    IBrandAnalyticsMetricOption,
    IDashboardAIConfig,
    IUpdateDashboardConfigRequest,
    IDashboardInsightRequest,
    IDashboardInsightResponse,
    IDashboardInsightsResponse,
    IAdviceAIConfig,
    IUpdateAdviceConfigRequest,
    IAdviceInsightResponse,
    IAdviceInsightsResponse,
    IOrbitalAIConfig,
    IUpdateOrbitalConfigRequest,
    IOrbitalItemResult,
    IOrbitalItemsResponse,
    IBuildingBlocksAIConfig,
    IUpdateBuildingBlocksConfigRequest,
    IBuildingBlocksInsightResult,
    IBuildingBlocksInsightsResponse,
    IMessage,
    IMessageType,
    IMessageRecipient,
    IMessagePreference,
    IInboxStats,
    IAdminStats,
    ICreateMessageDto,
    IUpdateMessageStatusDto,
    IBulkUpdateMessageStatusDto,
    IBulkUpdatePreferencesDto,
    IAIQuotaStatus,
    ICustomBrandChart,
    ICreateCustomBrandChartRequest,
    IUpdateCustomBrandChartRequest,
    IReorderCustomBrandChartsRequest,
    IQuestionTemplateType,
    IQuestionTemplateTypeInput,
    IQualificationConfig,
    ITicket,
    ITicketComment,
    ITicketAttachment,
    ITicketCategory,
    ICreateTicketDto,
    IUpdateTicketDto,
    ICreateCommentDto,
    ITicketQueryDto,
    ITicketStatsResponse,
    IFinalQuestion,
    IFinalQuestionsListResponse,
    ICreateFinalQuestionDto,
    IUpdateFinalQuestionDto,
    IBulkApplyFinalQuestionResponse,
    IActiveFinalQuestionsResponse,
    IFinalResponsesListResponse,
    // Subscriptions
    ISubscriptionPlan,
    ICreateSubscriptionPlanDto,
    IUpdateSubscriptionPlanDto,
    IFeatureDefinition,
    ICreateFeatureDto,
    IUpdateFeatureDto,
    IPlanEntitlement,
    ICreatePlanEntitlementDto,
    ValueType,
    IAddonEntitlement,
    ICreateAddonEntitlementDto,
    IOrganisationSubscription,
    IFreeTrialStatus,
    IEntitlementCheckResponse,
    IRestrictedAllowedElements,
    IBenchmarkingAccessResult,
    ITierAccessSummary,
    IUsageRecordDto,
    ICreditBalanceResponse,
    IConsumeCreditsDto,
    IFoundingCohortMember,
    IUpdateFoundingCohortStatusDto,
    IEligibleOrganisation,
    IBulkAddFoundingCohortResult,
    IRewardEarning,
    IRedeemRewardDto,
    IRewardTier,
    ICreateRewardTierDto,
    IUpdateRewardTierDto,
    IGrantRewardDto,
    IRewardRedemption,
    IRewardStats,
    RewardType,
    RewardStatus,
    IStripeSyncResult,
    IStripeBulkSyncResult,
    IStripeRetryResult,
    AddonType,
    IAddon,
    ICreateAddonDto,
    IUpdateAddonDto,
    AddonStatus,
    IOrganisationAddon,
    IAvailableRewardCredit,
    IAddonPurchasePreview,
    ICheckoutResult,
    IPaymentIntentResult,
    IAddonSubscriptionResult,
    IAddonPaymentMethod,
    // Customer Segmentation
    SegmentationFieldType,
    SegmentationFieldSource,
    ISegmentationFieldMetadata,
    ISegmentationField,
    ICreateSegmentationFieldDto,
    IUpdateSegmentationFieldDto,
    ISegmentationValue,
    ICustomer,
    ICreateCustomerDto,
    IUpdateCustomerDto,
    ICustomerListResponse,
    ISegmentationFieldsLimit,
    // Customer Import / Export
    ICustomerImportJob,
    ICustomerImportRow,
    ICustomerImportPreview,
    ISetImportMappingDto,
    // Saved Segments + Cohort Compare
    ISavedSegment,
    ICreateSavedSegmentDto,
    IUpdateSavedSegmentDto,
    ISegmentSurveyCriteria,
    ISegmentLibraryUsage,
    ISegmentCriteriaOptions,
    ISegmentComparisonRequest,
    ISegmentComparisonResponse,
    IEvaluateSegmentResponse,
    ICohortCompareRequest,
    ICohortCompareResult,
    // Customer Integrations
    ICustomerIntegration,
    ICreateIntegrationDto,
    IUpdateIntegrationDto,
    IRotateSecretResponse,
    ISignupFunnelResponse,
    IConciergePack,
    IConciergePackDetail,
    IConciergePackDraft,
    IConciergePackListRow,
    IConciergeOfferContext,
    ISaveConciergeOffer,
    IConciergeLintViolation,
    ICrmCompany,
    ICrmCompanyDetail,
    ICrmContact,
    ICrmActivity,
    ICrmReminder,
    ICrmInboundEmail,
    ICrmInboxSyncResult,
    ICrmTask,
    ICrmPipelineStage,
    ICrmLinkSuggestion,
    ICrmSyncStatus,
    IMailThread,
    IMailThreadSummary,
    IMailSender,
    IMailStagedAttachment,
    IMailSyncStatus,
    IMailRecipient,
    ICrmSyncRun,
    ICrmFunnelResponse,
    ICrmReports,
    ILiveAnalyticsSnapshot,
} from "./types";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const baseQuery = fetchBaseQuery({ 
    baseUrl: apiBaseUrl,
    prepareHeaders: (headers) => {
        // First try to get token directly from localStorage
        let token = localStorage.getItem('token');
        
        // If not found, try to get it from the user object
        if (!token) {
            const user = localStorage.getItem('user');
            if (user) {
                try {
                    // Optional chaining is load-bearing: localStorage can hold
                    // the STRING "null", which is truthy, so JSON.parse returns
                    // null and reading .jwtToken threw. On the public
                    // Hypothesis page — where nobody is logged in and status is
                    // polled every 5s — that logged a console error every five
                    // seconds for the whole run.
                    const userObj = JSON.parse(user);
                    token = userObj?.jwtToken || userObj?.token;
                } catch (e) {
                    console.error('Failed to parse user object:', e);
                }
            }
        }
        
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        
        return headers;
    },
});

const baseQueryWithAuth = async (args: any, api: any, extraOptions: any) => {
    const result = await baseQuery(args, api, extraOptions);
    
    // Don't show session expired modal for login/auth endpoints
    const url = typeof args === 'string' ? args : args.url;
    // SYR-107: /public/hypothesis is in this list because the tool is iframed on
    // brandscience.ai and used by people who have never had an account. The API
    // is written never to answer 401 there, but if one ever escaped, the modal
    // below would tell a stranger their session had expired and throw them at a
    // login form. Belt and braces.
    const isAuthEndpoint = url && (url.includes('/auth/login') || url.includes('/auth/reset-password') || url.includes('/auth/update-password') || url.includes('/auth/change-password') || url.includes('/public/hypothesis') || url.includes('/waitlist/invite/verify'));
    // ^ /waitlist/invite/verify answers 401 for an expired or tampered invite
    //   token, and the holder is an anonymous visitor on /sign-up — a "Session
    //   Expired" modal there would be nonsense (SYR-109).

    // Same reasoning for the rate-limit toast: /status is polled every few
    // seconds from inside the frame, and a global antd toast fired over the
    // marketing site would be baffling.
    const isPublicHypothesis = url && url.includes('/public/hypothesis');
    
    // Handle rate limiting (429)
    if (result.error && result.error.status === 429) {
        if (!isPublicHypothesis) {
            message.error({
                content: 'Too many requests. Please wait a moment and try again.',
                duration: 5,
            });
        }
        return result;
    }

    // Handle maintenance mode (503)
    if (result.error && result.error.status === 503) {
        // Trigger maintenance status check
        maintenanceService.checkStatus();

        // For read-only mode, show a warning but allow reads
        const maintenanceData = result.error.data as any;
        if (maintenanceData?.maintenanceMode === 'READ_ONLY') {
            const method = typeof args === 'object' && args.method ? args.method : 'GET';
            if (method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS') {
                message.warning('System is in read-only mode. Changes cannot be saved at this time.');
            }
        }

        return result;
    }

    if (result.error && result.error.status === 401 && !isAuthEndpoint) {
        Modal.confirm({
            title: 'Session Expired',
            content: 'Your session has expired. Please sign in again.',
            okText: 'Sign In',
            cancelButtonProps: { style: { display: 'none' } },
            onOk: () => {
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                window.location.href = '/sign-in';
            },
        });
    }
    
    return result;
};

/** One committed Action Plan play (SYR-68, Phase 4) — the brand's persisted plays. */
export interface IMarketerActionPlanPlay {
    id: string;
    playId: string;
    /** Snapshot of the recommendation at commit time: { type, title, rationale, objectives }. */
    snapshotJson: Record<string, any>;
    /** Indices (into snapshot.objectives) marked done. */
    doneObjectives: number[] | null;
    /** Set when the plan was "cleared"; groups a completed plan in the history. */
    archivedAt?: string | null;
    createdAt?: string;
    /** User who committed the play from Recommendations. */
    createdByUserId?: number | null;
    /** User the play is assigned to (defaults to the creator, reassignable). */
    assignedToUserId?: number | null;
    /** Server-resolved creator display name (full name, else email). */
    createdByName?: string | null;
    /** Server-resolved assignee display name (full name, else email). */
    assignedToName?: string | null;
}

const api = createApi({
    tagTypes: [
        EntityTag.Organisation,
        EntityTag.Brand,
        EntityTag.BrandEquity,
        EntityTag.QuestionTemplate,
        EntityTag.Survey,
        EntityTag.SurveyCohort,
        EntityTag.AIExperts,
        EntityTag.AIDocuments,
        EntityTag.AIConversations,
        EntityTag.Messages,
        EntityTag.CustomBrandChart,
        EntityTag.TICKETS,
        EntityTag.ADMIN_TICKETS,
        EntityTag.ADMIN_TICKET_STATS,
        EntityTag.TICKET_CATEGORIES,
        'ApiKey',
        'Billing',
        'Admin',
        'Crm',
        'CrmActivities',
        'CrmEmailTemplates',
        'CrmInbox',
        'CrmTasks',
        'CrmReminders',
        'CrmStages',
        'CrmSync',
        'Mail',
        'ModelBeliefs',
        'MarketerActionPlan',
        'ConciergePacks',
        'ConciergeOffer',
        'CharterApplications',
        'HypothesisLeads',
        'HypothesisDomainPolicies',
        'AdminUsers',
        'AdminEvents',
        'NotificationSubscriptions',
        'OrgUsers',
        'Profile',
        'BrandKnowledge',
        'SystemSettings',
        'JobLocks',
        'MockData',
        'ResponseMonitoring',
        'ResponseIntegrity',
        'BenchmarkingPreferences',
        'BenchmarkBusinessTypes',
        'BenchmarkProductTypes',
        'QuestionTemplateTypes',
        'LegalDocuments',
        'LegalAcceptance',
        'AdminLegalDocuments',
        'CookieConsent',
        'SubscriptionPlans',
        'PlanEntitlements',
        'AddonEntitlements',
        'Features',
        'Addons',
        'OrganisationAddons',
        'FoundingCohort',
        'Entitlements',
        'Credits',
        'Rewards',
        'RewardTiers',
        'SegmentationFields',
        'Customers',
        'CustomerImports',
        'SavedSegments',
        'CustomerIntegrations',
        'EditorStatus',
        'DatabaseBackups',
        'Agency',
    ],
    baseQuery: baseQueryWithAuth,
    endpoints: (build) => ({
        login: build.mutation<IAuth & { requires_2fa?: boolean; requires_2fa_setup?: boolean; isAdmin?: boolean }, { email: string, password: string, twoFactorToken?: string, extendedExpiry?: boolean }>({
            query: (params) => ({
                url: `/auth/login`,
                method: 'POST',
                body: { 
                    username: params.email, 
                    password: params.password,
                    ...(params.twoFactorToken && { twoFactorToken: params.twoFactorToken }),
                    ...(params.extendedExpiry && { extendedExpiry: params.extendedExpiry })
                },
            }),
        }),
        resetPassword: build.mutation<void, { email: string }>({
            query: (params) => ({
                url: `/auth/reset-password`,
                method: 'PUT',
                body: { username: params.email },
            }),
        }),
        updatePassword: build.mutation<IApiUser, { token: string, password: string, acceptTerms?: boolean }>({
            query: (params) => ({
                url: `/auth/update-password`,
                method: 'PUT',
                body: { token: params.token, password: params.password, acceptTerms: params.acceptTerms },
            }),
        }),
        changePassword: build.mutation<{ success: boolean }, { jwtToken: string, currentPassword: string, newPassword: string }>({
            query: (params) => ({
                url: `/auth/change-password`,
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: { currentPassword: params.currentPassword, newPassword: params.newPassword },
            }),
        }),
        getProfile: build.mutation<IApiUser, { jwtToken: string }>({
            query: (params) => ({
                url: `/auth/profile`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                },
            }),
        }),
        getUsers: build.query<{data: IApiUser[]}, { jwtToken: string }>({
            query: (params) => ({
                url: `/users/api-users`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                },
            }),
            providesTags: ['OrgUsers'],
        }),
        updateUser: build.mutation<IApiUser, {jwtToken: string, payload: IUpdateApiUser}>({
            query: (params) => ({
                url: `/users/api-user`,
                method: 'PUT',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        createUser: build.mutation<IApiUser, {jwtToken: string, payload: ICreateApiUser}>({
            query: (params) => ({
                url: `/users/api-user`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        createOrganisationWithUser: build.mutation<IApiUser, {payload: ICreateOrganisationWithApiUser}>({
            query: (params) => ({
                url: `/register`,
                method: 'POST',
                body: params.payload,
            }),
        }),
        // Admin endpoints
        getAdminVersion: build.query<{
            version: string;
            name: string;
            surveyVersion?: { version: string; name: string; timestamp: string } | null
            websiteVersion?: { version: string; name: string; timestamp: string } | null
        }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/version`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminSignupFunnel: build.query<ISignupFunnelResponse, { jwtToken: string, since?: string }>({
            query: (params) => ({
                url: `/admin/signup-funnel${params.since ? `?since=${encodeURIComponent(params.since)}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminOrganizations: build.query<{data: IOrganisation[], total: number}, { jwtToken: string, page?: number, limit?: number, search?: string, status?: string }>({
            query: (params) => ({
                url: `/admin/organizations?${new URLSearchParams({
                    page: (params.page || 1).toString(),
                    limit: (params.limit || 10).toString(),
                    ...(params.search && { search: params.search }),
                    ...(params.status && { status: params.status }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),
        
        getAdminOrganizationDetails: build.query<IOrganisation, { jwtToken: string, id: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: (result, error, arg) => [{ type: 'Admin', id: arg.id }],
        }),
        
        updateOrganizationStatus: build.mutation<IOrganisation, { jwtToken: string, id: number, status: string }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}`,
                method: 'PATCH',
                body: { status: params.status },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Admin'],
        }),

        updateOrganizationFeatures: build.mutation<IOrganisation, { jwtToken: string, id: number, aiTokenQuotaMonthly?: number, aiTokenQuotaDaily?: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}/features`,
                method: 'PATCH',
                body: {
                    aiTokenQuotaMonthly: params.aiTokenQuotaMonthly,
                    aiTokenQuotaDaily: params.aiTokenQuotaDaily
                },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Admin'],
        }),

        updateOrganizationBenchmarkStatus: build.mutation<{ message: string }, { jwtToken: string, id: number, benchmarkStatus: 'pending' | 'included' | 'excluded' }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}/benchmark-status`,
                method: 'PATCH',
                body: { benchmarkStatus: params.benchmarkStatus },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Admin'],
        }),

        // Charter Cohort (SYR-106). Its own action, never the generic plan
        // dropdown — changePlan writes planId alone and would leave the seat
        // half-provisioned with a wrong renewal date on the customer's page.
        moveOrganizationToCharter: build.mutation<{ message: string }, { jwtToken: string, id: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}/charter`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Admin'],
        }),

        updateOrganizationSuppressTrialEmails: build.mutation<{ message: string }, { jwtToken: string, id: number, suppressTrialEmails: boolean }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}/suppress-trial-emails`,
                method: 'PATCH',
                body: { suppressTrialEmails: params.suppressTrialEmails },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Admin'],
        }),

        deleteOrganization: build.mutation<{ message: string }, { jwtToken: string, id: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Admin'],
        }),

        createAdminOrganization: build.mutation<IOrganisation, { jwtToken: string, payload: { name: string, billingEmail?: string, templateType?: string, productType?: string, businessTypeId?: number, benchmarkProductTypeId?: number, orgKind?: 'standard' | 'charter' } }>({
            query: (params) => ({
                url: `/admin/organizations`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Admin'],
        }),
        
        getAdminBrands: build.query<{data: IAdminBrandResponse[], total: number}, { jwtToken: string, page?: number, limit?: number, search?: string, organizationId?: number }>({
            query: (params) => ({
                url: `/admin/brands?${new URLSearchParams({
                    page: (params.page || 1).toString(),
                    limit: (params.limit || 10).toString(),
                    ...(params.search && { search: params.search }),
                    // Server-side filter key is organisationId (AdminFilterDto)
                    ...(params.organizationId && { organisationId: params.organizationId.toString() }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),
        
        getAdminSurveys: build.query<{data: IAdminSurveyResponse[], total: number}, { jwtToken: string, limit?: number, offset?: number, search?: string, organisationId?: number, status?: string, sortBy?: string, sortOrder?: string }>({
            query: (params) => ({
                url: `/admin/surveys?${new URLSearchParams({
                    ...(params.limit && { limit: params.limit.toString() }),
                    ...(params.offset && { offset: params.offset.toString() }),
                    ...(params.search && { search: params.search }),
                    ...(params.organisationId && { organisationId: params.organisationId.toString() }),
                    ...(params.status && { status: params.status }),
                    ...(params.sortBy && { sortBy: params.sortBy }),
                    ...(params.sortOrder && { sortOrder: params.sortOrder }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminSurveyCohorts: build.query<IAdminSurveyCohortResponse[], { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/survey-cohorts`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminAnalytics: build.query<{
            totalOrganisations: number,
            activeOrganisations: number,
            totalUsers: number,
            totalSurveys: number,
            activeSurveys: number,
            totalResponses: number,
            responsesLast30Days: number,
            averageResponsesPerSurvey: number,
            organizationGrowthRate: number,
            topOrganisations: any[],
            recentOrganizations: any[],
            recentEvents: any[],
            // Mock data counts (when USE_MOCK_DATA is enabled)
            mockOrganisations?: number,
            mockActiveOrganisations?: number,
            mockUsers?: number,
            mockSurveys?: number,
            mockActiveSurveys?: number,
            mockResponses?: number,
            mockResponsesLast30Days?: number,
            showMockData?: boolean
        }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/analytics/overview`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        // AI Token Usage endpoints
        getAdminTokenUsage: build.query<ITokenUsageSummary, { jwtToken: string, orgId?: number, days?: number }>({
            query: (params) => ({
                url: params.orgId 
                    ? `/admin/token-usage/organisation/${params.orgId}/summary${params.days ? `?days=${params.days}` : ''}`
                    : `/admin/token-usage/platform/summary${params.days ? `?days=${params.days}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminOrganizationTokenUsageByUser: build.query<IOrganizationTokenUsageByUser, { jwtToken: string, orgId: number, days?: number }>({
            query: (params) => ({
                url: `/admin/token-usage/organisation/${params.orgId}/users${params.days ? `?days=${params.days}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),
        
        getAdminOrganizationMonthlyUsage: build.query<any, { jwtToken: string, orgId: number, months?: number }>({
            query: (params) => ({
                url: `/admin/token-usage/organisation/${params.orgId}/monthly${params.months ? `?months=${params.months}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminUsers: build.query<{data: IApiUser[], total: number}, { jwtToken: string, page?: number, limit?: number, search?: string, organisationId?: number }>({
            query: (params) => ({
                url: `/admin/users?${new URLSearchParams({
                    page: (params.page || 1).toString(),
                    limit: (params.limit || 10).toString(),
                    ...(params.search && { search: params.search }),
                    ...(params.organisationId && { organisationId: params.organisationId.toString() }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['AdminUsers'],
        }),
        
        createAdminUser: build.mutation<IApiUser, { jwtToken: string, payload: { email: string, firstName: string, lastName: string, roles: string[], organisationId?: number, suppressInviteEmail?: boolean } }>({
            query: (params) => ({
                url: `/admin/users`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminUsers'],
        }),
        
        updateAdminUser: build.mutation<IApiUser, { jwtToken: string, userId: number, payload: { firstName?: string, lastName?: string, status?: string, roles?: string[], organisationId?: number } }>({
            query: (params) => ({
                url: `/admin/users/${params.userId}`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminUsers'],
        }),
        
        resendAdminUserInvite: build.mutation<{ message: string }, { jwtToken: string, userId: number }>({
            query: (params) => ({
                url: `/admin/users/${params.userId}/resend-invite`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminUsers'],
        }),

        resetAdminUserPassword: build.mutation<{ message: string }, { jwtToken: string, userId: number }>({
            query: (params) => ({
                url: `/admin/users/${params.userId}/reset-password`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminUsers'],
        }),

        getAdminEvents: build.query<{
            events: any[];
            total: number;
            page: number;
            limit: number;
            totalPages: number;
        }, {
            jwtToken: string;
            page?: number;
            limit?: number;
            eventType?: string;
            userId?: number;
            search?: string;
            fromDate?: string;
            toDate?: string;
        }>({
            query: (params) => {
                const queryParams: Record<string, string> = {
                    limit: (params.limit || 100).toString(),
                    offset: (((params.page || 1) - 1) * (params.limit || 100)).toString(),
                };
                
                if (params.eventType) queryParams.eventType = params.eventType;
                if (params.userId) queryParams.userId = params.userId.toString();
                if (params.search) queryParams.search = params.search;
                if (params.fromDate) queryParams.fromDate = params.fromDate;
                if (params.toDate) queryParams.toDate = params.toDate;

                return {
                    url: `/admin/events?${new URLSearchParams(queryParams).toString()}`,
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${params.jwtToken}`,
                    },
                };
            },
            providesTags: ['AdminEvents'],
        }),
        
        getAdminOrganisations: build.query<{data: IOrganisation[]}, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/organisations`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: (result) => [
                ...(result?.data || []).map(organisation => ({
                    type: EntityTag.Organisation,
                    id: organisation.id,
                })),
                {
                    type: EntityTag.Organisation,
                    id: 'LIST',
                },
            ],
        }),
        
        // Brand Equity API endpoints
        getBrands: build.query<IBrand[], { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.Brand],
        }),

        getBrand: build.query<IBrand, { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: (result, error, arg) => [
                { type: EntityTag.Brand, id: arg.brandId }
            ],
        }),

        // SYR-78 — Brand Knowledge Base (org-facing, brand-scoped)
        getBrandKnowledge: build.query<IBrandKnowledgeProfile, { jwtToken: string, brandId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: arg.brandId }
            ],
        }),

        updateBrandKnowledge: build.mutation<IBrandKnowledgeProfile, { jwtToken: string, brandId: number, payload: IUpdateBrandKnowledge }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge`,
                method: 'PUT',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: arg.brandId }
            ],
        }),

        // SYR-78 Phase 2 — documents & scrapes (org-facing)
        getBrandKnowledgeDocuments: build.query<IBrandKnowledgeDocument[], { jwtToken: string, brandId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` }
            ],
        }),

        uploadBrandKnowledgeDocument: build.mutation<IBrandKnowledgeDocument, { jwtToken: string, brandId: number, file: File }>({
            query: (params) => {
                const formData = new FormData();
                formData.append('file', params.file);
                return {
                    url: `/brands/${params.brandId}/brand-knowledge/documents`,
                    method: 'POST',
                    body: formData,
                    headers: { Authorization: `Bearer ${params.jwtToken}` },
                };
            },
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` },
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` },
            ],
        }),

        addBrandKnowledgeScrape: build.mutation<IBrandKnowledgeDocument, { jwtToken: string, brandId: number, url: string }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/scrapes`,
                method: 'POST',
                body: { url: params.url },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` },
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` },
            ],
        }),

        rescrapeBrandKnowledgeDocument: build.mutation<IBrandKnowledgeDocument, { jwtToken: string, brandId: number, documentId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}/rescrape`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` },
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` },
            ],
        }),

        deleteBrandKnowledgeDocument: build.mutation<{ success: boolean }, { jwtToken: string, brandId: number, documentId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` },
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` },
            ],
        }),

        getBrandKnowledgeDocumentDownloadUrl: build.query<{ url: string }, { jwtToken: string, brandId: number, documentId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}/download`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        getBrandKnowledgeDocumentText: build.query<IBrandKnowledgeDocumentText, { jwtToken: string, brandId: number, documentId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `doctext-${arg.documentId}` }
            ],
        }),

        updateBrandKnowledgeDocumentText: build.mutation<IBrandKnowledgeDocument, { jwtToken: string, brandId: number, documentId: number, text: string }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}/text`,
                method: 'PUT',
                body: { text: params.text },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` },
                { type: 'BrandKnowledge', id: `doctext-${arg.documentId}` },
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` },
            ],
        }),

        redistillBrandKnowledgeDocument: build.mutation<IBrandKnowledgeDocument, { jwtToken: string, brandId: number, documentId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}/redistill`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` },
                { type: 'BrandKnowledge', id: `doctext-${arg.documentId}` },
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` },
            ],
        }),

        setBrandKnowledgeDocumentIncludeInContext: build.mutation<IBrandKnowledgeDocument, { jwtToken: string, brandId: number, documentId: number, include: boolean }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}/include-in-context`,
                method: 'PUT',
                body: { include: params.include },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `docs-${arg.brandId}` },
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` },
            ],
        }),

        suggestFieldsFromDocument: build.mutation<IBrandFieldSuggestions, { jwtToken: string, brandId: number, documentId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/documents/${params.documentId}/suggest-fields`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        suggestFieldsFromKnowledge: build.mutation<IBrandFieldSuggestions, { jwtToken: string, brandId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/brand-knowledge/suggest-fields`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        // SYR-78 — admin read-only inspector (cross-org)
        getAdminBrandKnowledge: build.query<IBrandKnowledgeInspection, { jwtToken: string, brandId: number }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandId}/knowledge`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: (result, error, arg) => [
                { type: 'BrandKnowledge', id: `admin-${arg.brandId}` }
            ],
        }),

        getAdminBrandKnowledgeDocumentDownloadUrl: build.query<{ url: string }, { jwtToken: string, brandId: number, documentId: number }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandId}/knowledge/documents/${params.documentId}/download`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        createBrand: build.mutation<IBrand, { jwtToken: string, organisationId: number, payload: { name: string, logoUrl?: string, primaryColor?: string } }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.Brand],
        }),

        updateBrand: build.mutation<IBrand, { jwtToken: string, organisationId: number, brandId: number, payload: { name?: string, logoUrl?: string, primaryColor?: string, templateType?: string } }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.Brand],
        }),

        updateBrandName: build.mutation<{ success: boolean; brand: IBrand }, { jwtToken: string, organisationId: number, brandId: number, name: string }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/name`,
                method: 'PATCH',
                body: { name: params.name },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.Brand],
        }),

        getSurveys: build.query<ISurvey[], { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/surveys`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.Survey],
        }),

        getCohortsByBrand: build.query<ISurveyCohort[], { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/cohorts`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.Survey],
        }),
        
        createSurvey: build.mutation<ISurvey, { jwtToken: string, organisationId: number, payload: ICreateSurveyPayload }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/surveys`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.Survey],
        }),
        
        updateSurvey: build.mutation<ISurvey, { jwtToken: string, surveyId: number, payload: Partial<ICreateSurveyPayload> }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.Survey],
        }),

        updateSurveyStatus: build.mutation<ISurvey, { jwtToken: string, surveyId: number, status: 'draft' | 'active' | 'paused' | 'completed' }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}`,
                method: 'PATCH',
                body: { status: params.status },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.Survey],
        }),

        softDeleteSurvey: build.mutation<void, { jwtToken: string, surveyId: number }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}/soft`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.Survey],
        }),
        
        // Survey Cohort Endpoints
        getSurveyCohorts: build.query<ISurveyCohort[], { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/cohorts`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.SurveyCohort],
        }),
        
        getActiveSurveysForCohort: build.query<ISurvey[], { jwtToken: string, organisationId: number, cohortId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/cohorts/${params.cohortId}/active-surveys`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Brand Cohort CRUD Endpoints
        getBrandCohorts: build.query<ISurveyCohort[], { jwtToken: string, brandId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/cohorts`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.SurveyCohort],
        }),

        createBrandCohort: build.mutation<ISurveyCohort, { jwtToken: string, brandId: number, data: { name: string, displayName: string, description?: string, parentCohortId: number } }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/cohorts`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: params.data,
            }),
            invalidatesTags: [EntityTag.SurveyCohort],
        }),

        updateBrandCohort: build.mutation<ISurveyCohort, { jwtToken: string, brandId: number, cohortId: number, data: { name?: string, displayName?: string, description?: string, isActive?: boolean, parentCohortId?: number } }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/cohorts/${params.cohortId}`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: params.data,
            }),
            invalidatesTags: [EntityTag.SurveyCohort],
        }),

        deactivateBrandCohort: build.mutation<{ message: string }, { jwtToken: string, brandId: number, cohortId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/cohorts/${params.cohortId}/deactivate`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.SurveyCohort],
        }),

        deleteBrandCohort: build.mutation<{ message: string }, { jwtToken: string, brandId: number, cohortId: number }>({
            query: (params) => ({
                url: `/brands/${params.brandId}/cohorts/${params.cohortId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.SurveyCohort],
        }),

        getBrandEquity: build.query<{data: IBrandEquity}, { jwtToken: string, brandHash: string, timeRange?: string }>({
            query: (params) => ({
                url: `/brands/${params.brandHash}/equity${params.timeRange ? `?period=${params.timeRange}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.BrandEquity],
        }),
        
        getBrandEquityTrends: build.query<{data: ITrendData[]}, { jwtToken: string, brandHash: string, period: string }>({
            query: (params) => ({
                url: `/brands/${params.brandHash}/equity/trends?period=${params.period}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        
        getBrandEquityDimensionDetails: build.query<{data: any}, { jwtToken: string, brandHash: string, dimension: string }>({
            query: (params) => ({
                url: `/brands/${params.brandHash}/equity/dimensions/${params.dimension}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        
        exportBrandEquityData: build.mutation<Blob, { jwtToken: string, brandHash: string, format: 'csv' | 'excel' | 'pdf' }>({
            query: (params) => ({
                url: `/brands/${params.brandHash}/equity/export?format=${params.format}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                responseHandler: (response: Response) => response.blob(),
            }),
        }),
        
        // Question Template endpoints
        getQuestionTemplates: build.query<{data: IQuestionTemplate[]}, { jwtToken: string }>({
            query: (params) => ({
                url: `/question-templates`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: (result) => [
                ...(result?.data || []).map(template => ({
                    type: EntityTag.QuestionTemplate,
                    id: template.id,
                })),
                {
                    type: EntityTag.QuestionTemplate,
                    id: 'LIST',
                },
            ],
        }),
        
        getCoreQuestionTemplates: build.query<{data: IQuestionTemplate[]}, { jwtToken: string }>({
            query: (params) => ({
                url: `/question-templates/core`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.QuestionTemplate],
        }),
        
        updateQuestionTemplate: build.mutation<IQuestionTemplate, { jwtToken: string, id: number, payload: IUpdateQuestionTemplate }>({
            query: (params) => ({
                url: `/question-templates/${params.id}`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: EntityTag.QuestionTemplate, id: arg.id },
                { type: EntityTag.QuestionTemplate, id: 'LIST' },
            ],
        }),

        // Statement Template Management endpoints
        getTemplateTypes: build.query<{ data: string[] }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/question-templates/template-types',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: [{ type: EntityTag.QuestionTemplate, id: 'TYPES' }],
        }),

        getTemplatesByType: build.query<
            { data: IQuestionTemplate[]; inUse: boolean; surveyCount: number },
            { jwtToken: string; templateType: string }
        >({
            query: ({ jwtToken, templateType }) => ({
                url: `/question-templates/template-types/${templateType}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: (result, error, arg) => [
                { type: EntityTag.QuestionTemplate, id: `TYPE_${arg.templateType}` },
                { type: EntityTag.QuestionTemplate, id: 'LIST' },
            ],
        }),

        cloneTemplateType: build.mutation<
            { data: IQuestionTemplate[] },
            { jwtToken: string; payload: { sourceTemplateType: string; newTemplateType: string; modifications: Array<{ code: string; text?: string; scoringType?: string; status?: 'active' | 'inactive' }> } }
        >({
            query: ({ jwtToken, payload }) => ({
                url: '/question-templates/clone-template-type',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: [
                { type: EntityTag.QuestionTemplate, id: 'TYPES' },
                { type: EntityTag.QuestionTemplate, id: 'LIST' },
            ],
        }),

        importTemplateType: build.mutation<
            { data: IQuestionTemplate[] },
            {
                jwtToken: string;
                payload: {
                    newTemplateType: string;
                    templates: Array<{
                        code: string;
                        text: string;
                        category: string;
                        questionTypeId: number;
                        scoringType: string;
                        isCore: boolean;
                        isRequired: boolean;
                        status: 'active' | 'inactive';
                        displayOrder: number;
                    }>;
                };
            }
        >({
            query: ({ jwtToken, payload }) => ({
                url: '/question-templates/import-template-type',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: [
                { type: EntityTag.QuestionTemplate, id: 'TYPES' },
                { type: EntityTag.QuestionTemplate, id: 'LIST' },
            ],
        }),

        deleteTemplateType: build.mutation<
            { success: boolean },
            { jwtToken: string; templateType: string }
        >({
            query: ({ jwtToken, templateType }) => ({
                url: `/question-templates/template-types/${templateType}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: [
                { type: EntityTag.QuestionTemplate, id: 'TYPES' },
                { type: EntityTag.QuestionTemplate, id: 'LIST' },
            ],
        }),

        // Survey Response endpoints
        getSurveyResponses: build.query<ISurveyResponse[], { jwtToken: string, surveyId: number }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}/responses`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getSurveyResponseSummary: build.query<ISurveyResponseSummary, { jwtToken: string, surveyId: number }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}/responses/summary`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getSurveyResponseDetails: build.query<ISurveyResponse, { jwtToken: string, responseId: number }>({
            query: (params) => ({
                url: `/survey-responses/${params.responseId}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        deleteSurveyResponse: build.mutation<{ message: string, responseId: string }, { jwtToken: string, surveyId: number, responseId: number }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}/responses/${params.responseId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        deleteSurveyResponses: build.mutation<{ message: string, deletedCount: number }, { jwtToken: string, surveyId: number, responseIds: number[] }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}/responses`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: { responseIds: params.responseIds },
            }),
        }),


        getQuestionCoverage: build.query<IQuestionCoverageResponse, { jwtToken: string, surveyId: number }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}/responses/coverage`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        exportParticipantList: build.mutation<{ blob: Blob; filename: string }, { jwtToken: string, surveyId: number }>({
            query: (params) => ({
                url: `/surveys/${params.surveyId}/export-participants`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                responseHandler: async (response: Response) => {
                    const blob = await response.blob();
                    const contentDisposition = response.headers.get('content-disposition');
                    let filename = `survey_participants_${new Date().toISOString().split('T')[0]}.csv`;
                    
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (filenameMatch) {
                            filename = filenameMatch[1];
                        }
                    }
                    
                    return { blob, filename };
                },
            }),
        }),

        exportAdminParticipantList: build.mutation<{ blob: Blob; filename: string }, { jwtToken: string, surveyId: number }>({
            query: (params) => ({
                url: `/admin/surveys/${params.surveyId}/export-participants`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                responseHandler: async (response: Response) => {
                    const blob = await response.blob();
                    const contentDisposition = response.headers.get('content-disposition');
                    let filename = `survey_participants_${new Date().toISOString().split('T')[0]}.csv`;
                    
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (filenameMatch) {
                            filename = filenameMatch[1];
                        }
                    }
                    
                    return { blob, filename };
                },
            }),
        }),

        // Brand Equity Calculation API endpoints
        calculateBrandEquity: build.mutation<IBrandEquityScoreResponse, { jwtToken: string, organisationId: number, payload: ICalculateBrandEquityRequest }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brand-equity/calculate`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getStaleCachedBrandEquity: build.mutation<IBrandEquityScoreResponse & { isStale?: boolean; expiresAt?: string }, { jwtToken: string, organisationId: number, payload: ICalculateBrandEquityRequest }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brand-equity/stale-cache`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Marketer View — Briefing AI narrative (SYR-68). POST with the same
        // calculate filters; returns only the AI narrative (one_thing/the_fix).
        // A query (not a mutation) so the narrative is cached per brand+scope:
        // returning to The Briefing reads the cache instead of re-fetching and
        // flashing the Hero's "if you only know one thing" skeleton. Held for
        // 10 min so brief tab hops stay instant; server-side result is cached too.
        getMarketerBriefing: build.query<{
            enabled: boolean;
            narrative: {
                one_thing?: { headline?: string; body?: string; ctaPrimary?: string; ctaSecondary?: string };
                the_fix?: { title?: string; redline?: string; move?: string; expectedEffect?: string };
                recommendations?: { recommendations?: Array<Record<string, any>> };
                boosters_summary?: { summary?: string };
            } | null;
            dismissedRecommendationIds?: string[];
        }, { jwtToken: string, organisationId: number, brandId: number, payload: ICalculateBrandEquityRequest }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/marketer-briefing`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            keepUnusedDataFor: 600,
        }),

        // Briefing recommendations — per-card delete + regenerate. Deletions
        // apply to the CURRENT set only; regeneration returns a fresh, complete
        // set. Callers refetch the briefing query after either mutation.
        dismissMarketerRecommendation: build.mutation<{ dismissedRecommendationIds: string[] }, { jwtToken: string, organisationId: number, brandId: number, cardId: string }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/marketer-briefing/recommendations/dismiss`,
                method: 'POST',
                body: { cardId: params.cardId },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        regenerateMarketerRecommendations: build.mutation<{ recommendations: Record<string, any> | null }, { jwtToken: string, organisationId: number, brandId: number, payload: ICalculateBrandEquityRequest }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/marketer-briefing/recommendations/regenerate`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // SYR-90 — The Hypothesis card for The Briefing
        // SYR-111 — what the models believe about this brand. One call carries
        // the whole read: the API decides entitlement and the master switch and
        // answers 200 with a reason, so the page renders a gate state rather
        // than treating "not for you" as an error.
        // Three flags, cheap enough for the nav to ask on every render of the
        // shell. `enabled` carries the platform-admin / impersonation bypass.
        getBrandModelBeliefsAccess: build.query<{ entitled: boolean; enabled: boolean; previewOnly?: boolean }, { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/model-beliefs/access`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            keepUnusedDataFor: 300,
        }),

        getBrandModelBeliefs: build.query<IModelBeliefsRead, { jwtToken: string, organisationId: number, brandId: number, runId?: number, hideSurvey?: boolean }>({
            query: (params) => {
                // runId pins a specific run and hideSurvey drops the customer line; the API honours both only for platform admins and impersonation.
                const flags = [params.runId ? `run=${params.runId}` : '', params.hideSurvey ? 'survey=0' : ''].filter(Boolean);
                return {
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/model-beliefs${flags.length ? `?${flags.join('&')}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                };
            },
            providesTags: ['ModelBeliefs'],
            // A read is a monthly measurement, not live data.
            keepUnusedDataFor: 300,
        }),

        requestBrandModelBeliefs: build.mutation<{ runId: number, status: string }, { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/model-beliefs/run`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['ModelBeliefs'],
        }),

        // Admin and impersonation only (the API refuses otherwise): rewrite a read's synthesis, optionally without customer data.
        resynthesiseBrandModelBeliefs: build.mutation<{ runId: number, withoutSurvey: boolean }, { jwtToken: string, organisationId: number, brandId: number, runId?: number, withoutSurvey?: boolean }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/model-beliefs/synthesise`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: { runId: params.runId, withoutSurvey: !!params.withoutSurvey },
            }),
            invalidatesTags: ['ModelBeliefs'],
        }),

        getBrandHypothesis: build.query<IHypothesisCard, { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/hypothesis`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            keepUnusedDataFor: 300,
        }),

        dismissBrandHypothesis: build.mutation<{ dismissed: boolean }, { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/hypothesis/dismiss`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        reanalyzeElement: build.mutation<{ aiSummary: string, element: string, elementType: string, analyzedAt: string }, {
            jwtToken: string, 
            organisationId: number, 
            elementType: 'measure' | 'latent',
            elementName: string,
            brandEquityData: IBrandEquityScoreResponse
        }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brand-equity/reanalyze-element`,
                method: 'POST',
                body: {
                    elementType: params.elementType,
                    elementName: params.elementName,
                    brandEquityData: params.brandEquityData,
                },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Marketer Action Plan (SYR-68, Phase 4) — committed plays persisted per (org, brand).
        //
        // Tagged since 2026-09-29. Callers used to refetch() their own list after
        // a mutation, which works only while the mutation and the list live on
        // the same page: committing a record fix from The Machines left the
        // Action Plan page holding stale cache until a full reload. The tag
        // makes the invalidation the store's job rather than each caller's, and
        // the existing manual refetches stay harmless.
        getMarketerActionPlan: build.query<IMarketerActionPlanPlay[], { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/action-plan`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['MarketerActionPlan'],
        }),

        getMarketerActionPlanHistory: build.query<IMarketerActionPlanPlay[], { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/action-plan/archived`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        addMarketerActionPlanPlay: build.mutation<IMarketerActionPlanPlay, { jwtToken: string, organisationId: number, brandId: number, playId: string, snapshot: Record<string, any> }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/action-plan/plays/${params.playId}`,
                method: 'PUT',
                body: { snapshot: params.snapshot },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['MarketerActionPlan'],
        }),

        removeMarketerActionPlanPlay: build.mutation<{ success: boolean }, { jwtToken: string, organisationId: number, brandId: number, playId: string }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/action-plan/plays/${params.playId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['MarketerActionPlan'],
        }),

        archiveMarketerActionPlan: build.mutation<{ archived: number }, { jwtToken: string, organisationId: number, brandId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/action-plan/archive`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        setMarketerActionPlanAssignee: build.mutation<IMarketerActionPlanPlay | null, { jwtToken: string, organisationId: number, brandId: number, playId: string, userId: number | null }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/action-plan/plays/${params.playId}/assignee`,
                method: 'PUT',
                body: { userId: params.userId },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        setMarketerActionPlanDone: build.mutation<IMarketerActionPlanPlay | null, { jwtToken: string, organisationId: number, brandId: number, playId: string, done: number[] }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/brands/${params.brandId}/action-plan/plays/${params.playId}/done`,
                method: 'PUT',
                body: { done: params.done },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Admin Brand Equity endpoints
        calculateAdminBrandEquity: build.mutation<IBrandEquityScoreResponse, { jwtToken: string, brandId: number, payload: ICalculateBrandEquityRequest }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandId}/brand-equity/calculate`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        
        getStaleCachedAdminBrandEquity: build.mutation<IBrandEquityScoreResponse & { isStale?: boolean; expiresAt?: string }, { jwtToken: string, brandId: number, payload: ICalculateBrandEquityRequest }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandId}/brand-equity/stale-cache`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        
        // Admin Export endpoints
        exportAdminSurveyResponses: build.mutation<Blob, { jwtToken: string, surveyId: number, format: 'csv' | 'excel' }>({
            query: (params) => ({
                url: `/admin/surveys/${params.surveyId}/export?format=${params.format}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                responseHandler: (response: Response) => response.blob(),
            }),
        }),

        getAdminBrandStatements: build.query<IBrandEquityScoreResponse, { jwtToken: string, brandId: number, filters?: ICalculateBrandEquityRequest }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandId}/analytics/statements?${new URLSearchParams(
                    Object.entries(params.filters || {}).reduce((acc, [key, value]) => {
                        if (value !== undefined && value !== null) {
                            if (Array.isArray(value)) {
                                acc[key] = value.join(',');
                            } else {
                                acc[key] = value.toString();
                            }
                        }
                        return acc;
                    }, {} as Record<string, string>)
                ).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // API Keys endpoints
        getApiKeys: build.query<{ data: IApiKey[] }, { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/api-keys`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['ApiKey'],
        }),

        createApiKey: build.mutation<{ message: string, data: ICreateApiKeyResponse, warning: string }, { jwtToken: string, organisationId: number, payload: ICreateApiKeyRequest }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/api-keys`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['ApiKey'],
        }),

        updateApiKey: build.mutation<{ message: string, data: IApiKey }, { jwtToken: string, organisationId: number, keyId: string, payload: IUpdateApiKeyRequest }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/api-keys/${params.keyId}`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['ApiKey'],
        }),

        revokeApiKey: build.mutation<{ message: string }, { jwtToken: string, organisationId: number, keyId: string }>({
            query: (params) => ({
                url: `/organisations/${params.organisationId}/api-keys/${params.keyId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['ApiKey'],
        }),

        // Billing endpoints
        getSubscriptions: build.query<ISubscription[], { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/billing/subscriptions`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Billing'],
        }),

        createSubscription: build.mutation<ISubscriptionCreateResponse, { jwtToken: string, organisationId: number, payload: ICreateSubscriptionRequest }>({
            query: (params) => ({
                url: `/billing/subscribe`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing', 'Entitlements'],
        }),

        updateSubscription: build.mutation<ISubscription, { jwtToken: string, organisationId: number, subscriptionId: number, payload: IUpdateSubscriptionRequest }>({
            query: (params) => ({
                url: `/billing/subscriptions/${params.subscriptionId}`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing', 'Entitlements'],
        }),

        cancelSubscription: build.mutation<ISubscription, { jwtToken: string, organisationId: number, subscriptionId: number, immediately?: boolean }>({
            query: (params) => ({
                url: `/billing/subscriptions/${params.subscriptionId}?immediately=${params.immediately || false}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing', 'Entitlements'],
        }),

        reactivateSubscription: build.mutation<ISubscription, { jwtToken: string, organisationId: number, subscriptionId: number }>({
            query: (params) => ({
                url: `/billing/subscriptions/${params.subscriptionId}/reactivate`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing', 'Entitlements'],
        }),

        getPaymentMethods: build.query<IPaymentMethod[], { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/billing/payment-methods`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Billing'],
        }),

        syncPaymentMethods: build.mutation<IPaymentMethod[], { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/billing/payment-methods/sync`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing'],
        }),

        syncSubscription: build.mutation<{ status: string; synced: boolean }, { jwtToken: string, organisationId: number }>({
            query: (params) => ({
                url: `/billing/subscription/sync`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing'],
        }),

        getAnnualPromotion: build.query<IAnnualPromotion, { jwtToken: string }>({
            query: (params) => ({
                url: `/billing/annual-promotion`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        createSetupIntent: build.mutation<IStripeSetupIntent, { jwtToken: string, organisationId: number, billingCountry?: string }>({
            query: (params) => ({
                url: `/billing/setup-intent`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: {
                    billingCountry: params.billingCountry,
                },
            }),
        }),

        attachPaymentMethod: build.mutation<IPaymentMethod, { jwtToken: string, organisationId: number, paymentMethodId: string }>({
            query: (params) => ({
                url: `/billing/payment-methods/${params.paymentMethodId}/attach`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing'],
        }),

        detachPaymentMethod: build.mutation<{ message: string }, { jwtToken: string, organisationId: number, paymentMethodId: string }>({
            query: (params) => ({
                url: `/billing/payment-methods/${params.paymentMethodId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing'],
        }),

        setDefaultPaymentMethod: build.mutation<IPaymentMethod, { jwtToken: string, organisationId: number, paymentMethodId: string }>({
            query: (params) => ({
                url: `/billing/payment-methods/${params.paymentMethodId}/default`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['Billing'],
        }),

        getInvoices: build.query<IInvoicesResponse, { jwtToken: string, organisationId: number, limit?: number, cursor?: string }>({
            query: (params) => ({
                url: `/billing/invoices`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                params: {
                    limit: params.limit || 25,
                    ...(params.cursor && { cursor: params.cursor }),
                },
            }),
            providesTags: ['Billing'],
        }),

        downloadInvoice: build.mutation<Blob, { jwtToken: string, organisationId: number, invoiceId: number }>({
            query: (params) => ({
                url: `/billing/invoices/${params.invoiceId}/download`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                responseHandler: (response: Response) => response.blob(),
            }),
        }),

        getBrandSubscriptionFeatures: build.query<ISubscriptionFeatures, { jwtToken: string, brandId: number }>({
            query: (params) => ({
                url: `/billing/brands/${params.brandId}/features`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Billing'],
        }),

        // Organisation details endpoints
        updateOrganisationDetails: build.mutation<IOrganisation, { jwtToken: string, payload: { name?: string, billingEmail?: string } }>({
            query: (params) => ({
                url: `/organisations/details`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // User profile endpoints
        getMyProfile: build.query<IApiUser, { jwtToken: string }>({
            query: (params) => ({
                url: `/users/me/profile`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        updateUserProfile: build.mutation<IApiUser, { jwtToken: string, payload: { firstName?: string, lastName?: string, email?: string, phoneNumber?: string } }>({
            query: (params) => ({
                url: `/users/profile`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        completeOnboarding: build.mutation<{ message: string }, { jwtToken: string }>({
            query: (params) => ({
                url: `/users/onboarding/complete`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // User notification preferences
        getNotificationPreferences: build.query<{ notificationType: 'ntfy' | 'slack', slackWebhookUrl: string | null }, { jwtToken: string }>({
            query: (params) => ({
                url: `/users/notification-preferences`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        updateNotificationPreferences: build.mutation<any, { jwtToken: string, payload: { notificationType?: 'ntfy' | 'slack', slackWebhookUrl?: string } }>({
            query: (params) => ({
                url: `/users/notification-preferences`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Notification subscription endpoints
        getNotificationTopics: build.query<any[], { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/notifications/subscriptions/topics`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['NotificationSubscriptions'],
        }),

        getNotificationSubscriptions: build.query<any[], { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/notifications/subscriptions`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['NotificationSubscriptions'],
        }),

        createNotificationSubscription: build.mutation<any, { jwtToken: string, payload: { topicType: string, notificationSettings?: any } }>({
            query: (params) => ({
                url: `/admin/notifications/subscriptions`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['NotificationSubscriptions'],
        }),

        updateNotificationSubscription: build.mutation<any, { jwtToken: string, topicType: string, payload: { isActive?: boolean, notificationSettings?: any } }>({
            query: (params) => ({
                url: `/admin/notifications/subscriptions/${params.topicType}`,
                method: 'PATCH',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['NotificationSubscriptions'],
        }),

        deleteNotificationSubscription: build.mutation<any, { jwtToken: string, topicType: string }>({
            query: (params) => ({
                url: `/admin/notifications/subscriptions/${params.topicType}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['NotificationSubscriptions'],
        }),

        // AI Experts Admin endpoints
        getAIExpertSystemStats: build.query<ISystemStats, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/stats`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIExperts],
        }),

        getAIExperts: build.query<IAIExpert[], { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/experts`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIExperts],
        }),

        getAIExpertConfig: build.query<IAIExpert, { jwtToken: string, expertType: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/experts/${params.expertType}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIExperts],
        }),

        updateAIExpert: build.mutation<IAIExpert, { jwtToken: string, expertType: string, payload: IUpdateExpertRequest }>({
            query: (params) => ({
                url: `/admin/ai-experts/experts/${params.expertType}`,
                method: 'PUT',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIExperts],
        }),

        toggleAIExpertStatus: build.mutation<{ expertType: string, isActive: boolean }, { jwtToken: string, expertType: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/experts/${params.expertType}/toggle`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIExperts],
        }),

        getKnowledgeDocuments: build.query<{ documents: IKnowledgeDocument[], pagination: { page: number, limit: number, total: number, totalPages: number } }, { jwtToken: string, status?: string, page?: number, limit?: number }>({
            query: (params) => ({
                url: `/admin/ai-experts/documents?${new URLSearchParams({
                    page: (params.page || 1).toString(),
                    limit: (params.limit || 20).toString(),
                    ...(params.status && { status: params.status }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIDocuments],
        }),

        getDocumentStats: build.query<IDocumentStats, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/documents/stats`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIDocuments],
        }),

        uploadKnowledgeDocument: build.mutation<{ id: string, filename: string, fileType: string, fileSize: number, status: string, uploadDate: string }, { jwtToken: string, file: FormData }>({
            query: (params) => ({
                url: `/admin/ai-experts/documents/upload`,
                method: 'POST',
                body: params.file,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIDocuments],
        }),

        reprocessDocument: build.mutation<{ message: string }, { jwtToken: string, documentId: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/documents/${params.documentId}/reprocess`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIDocuments],
        }),

        deleteKnowledgeDocument: build.mutation<void, { jwtToken: string, documentId: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/documents/${params.documentId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIDocuments],
        }),

        getVectorStats: build.query<any, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/ai-experts/vector-stats`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIExperts],
        }),

        // AI Expert User endpoints
        getAvailableExperts: build.query<IAIExpert[], { jwtToken: string; brandId?: number }>({
            query: (params) => ({
                url: `/api/ai-expert/experts${params.brandId ? `?brandId=${params.brandId}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIExperts],
        }),

        getExpertInfo: build.query<IAIExpert, { jwtToken: string, expertType: string }>({
            query: (params) => ({
                url: `/api/ai-expert/experts/${params.expertType}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIExperts],
        }),

        checkExpertAccess: build.mutation<
            { hasAccess: boolean; requiredSubscriptionLevel?: string; currentSubscriptionLevel?: string; message?: string },
            { jwtToken: string; expertType: string; brandId?: number }
        >({
            query: (params) => ({
                url: `/api/ai-expert/experts/${params.expertType}/check-access${params.brandId ? `?brandId=${params.brandId}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIExperts],
        }),

        chatWithExpert: build.mutation<IChatResponse, { jwtToken: string, payload: IChatRequest }>({
            query: (params) => ({
                url: `/api/ai-expert/chat`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIConversations],
        }),

        createAIConversation: build.mutation<{ id: string, expertType: string, createdAt: string, existing?: boolean, messageCount?: number }, { jwtToken: string, payload: { expertType: string, contextKey?: string } }>({
            query: (params) => ({
                url: `/api/ai-expert/conversations`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIConversations],
        }),

        getUserConversations: build.query<IAIConversation[], { jwtToken: string, expertType?: string }>({
            query: (params) => ({
                url: `/api/ai-expert/conversations${params.expertType ? `?expertType=${params.expertType}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIConversations],
        }),

        getAIConversation: build.query<{ conversation: IAIConversation, messages: IAIMessage[] }, { jwtToken: string, conversationId: string }>({
            query: (params) => ({
                url: `/api/ai-expert/conversations/${params.conversationId}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIConversations],
        }),

        deleteAIConversation: build.mutation<void, { jwtToken: string, conversationId: string }>({
            query: (params) => ({
                url: `/api/ai-expert/conversations/${params.conversationId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.AIConversations],
        }),
        // Dashboard AI endpoints
        getDashboardAIConfigs: build.query<IDashboardAIConfig[], { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/dashboard-ai/configs`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        updateDashboardAIConfig: build.mutation<IDashboardAIConfig, { jwtToken: string, expertType: string, payload: IUpdateDashboardConfigRequest }>({
            query: (params) => ({
                url: `/admin/dashboard-ai/configs/${params.expertType}`,
                method: 'PUT',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        generateDashboardInsight: build.mutation<IDashboardInsightResponse, { jwtToken: string, payload: IDashboardInsightRequest }>({
            query: (params) => ({
                url: `/dashboard-ai/generate-insight`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        getAllDashboardInsights: build.query<IDashboardInsightsResponse, { jwtToken: string, forceRefresh?: boolean }>({
            query: (params) => ({
                url: `/dashboard-ai/insights${params.forceRefresh ? '?forceRefresh=true' : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        getAllDashboardInsightsWithData: build.mutation<IDashboardInsightsResponse, { jwtToken: string, brandEquityData: any, forceRefresh?: boolean }>({
            query: (params) => ({
                url: `/dashboard-ai/insights-with-data`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: {
                    brandEquityData: params.brandEquityData,
                    forceRefresh: params.forceRefresh || false,
                },
            }),
        }),
        getSingleDashboardInsightWithData: build.mutation<{ response: string; cached: boolean }, { jwtToken: string, expertType: string, brandEquityData: any, forceRefresh?: boolean }>({
            query: (params) => ({
                url: `/dashboard-ai/single-insight-with-data`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: {
                    expertType: params.expertType,
                    brandEquityData: params.brandEquityData,
                    forceRefresh: params.forceRefresh || false,
                },
            }),
        }),

        // Advice AI customer-facing endpoints. Admin config endpoints
        // (/admin/advice-ai/*) were removed in Phase 6 dead-route cleanup —
        // the AI Hub /admin/ai/advice_ai page now manages config directly
        // via /admin/ai/subsystems/advice_ai/* with full draft/publish.
        getAllAdviceInsightsWithData: build.mutation<IAdviceInsightsResponse, { jwtToken: string, brandEquityData: any, forceRefresh?: boolean }>({
            query: (params) => ({
                url: `/advice-ai/insights-with-data`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: {
                    brandEquityData: params.brandEquityData,
                    forceRefresh: params.forceRefresh || false,
                },
            }),
        }),
        getSingleAdviceInsightWithData: build.mutation<{ response: string; cached: boolean }, { jwtToken: string, expertType: string, brandEquityData: any, forceRefresh?: boolean }>({
            query: (params) => ({
                url: `/advice-ai/single-insight-with-data`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
                body: {
                    expertType: params.expertType,
                    brandEquityData: params.brandEquityData,
                    forceRefresh: params.forceRefresh || false,
                },
            }),
        }),

        // Orbital AI customer-facing endpoints. Admin config endpoints
        // (/admin/orbital-ai/*) were removed in Phase 6 dead-route cleanup —
        // see /admin/ai/orbital_ai for the new admin surface.
        getOrbitalItems: build.query<IOrbitalItemsResponse, { jwtToken: string; period?: string }>({
            query: (params) => ({
                url: `/orbital-ai/items${params.period ? `?period=${params.period}` : ''}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),
        refreshOrbitalItems: build.mutation<IOrbitalItemsResponse, { jwtToken: string, forceRefresh?: boolean }>({
            query: (params) => ({
                url: `/orbital-ai/items`,
                method: 'POST',
                body: { forceRefresh: params.forceRefresh || false },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Building Blocks AI customer-facing endpoint. Admin config endpoints
        // (/admin/building-blocks-ai/*) and the cache-clear endpoints for
        // building-blocks + orbital were removed in Phase 6 dead-route
        // cleanup — the AI Hub Configure tabs handle both via /clear-cache.
        getBuildingBlocksInsights: build.mutation<IBuildingBlocksInsightsResponse, { jwtToken: string, brandEquityData: any, brandId: number, forceRefresh?: boolean }>({
            query: (params) => ({
                url: `/building-blocks-ai/insights`,
                method: 'POST',
                body: { brandEquityData: params.brandEquityData, brandId: params.brandId, forceRefresh: params.forceRefresh || false },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getUsageStats: build.query<any, { jwtToken: string, startDate?: string, endDate?: string }>({
            query: (params) => ({
                url: `/api/ai-expert/usage-stats?${new URLSearchParams({
                    ...(params.startDate && { startDate: params.startDate }),
                    ...(params.endDate && { endDate: params.endDate }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.AIExperts],
        }),

        // Admin Impersonation endpoints
        startImpersonation: build.mutation<IImpersonationResponse, { jwtToken: string, organizationId: number, payload: IImpersonationRequest }>({
            query: (params) => ({
                url: `/admin/organizations/${params.organizationId}/impersonate`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminEvents'],
        }),

        stopImpersonation: build.mutation<IImpersonationStopResponse, { jwtToken: string }>({
            query: (params) => ({
                url: `/auth/impersonation/stop`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminEvents'],
        }),

        returnToAdmin: build.mutation<IReturnToAdminResponse, { jwtToken: string }>({
            query: (params) => ({
                url: `/auth/impersonation/return`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminEvents'],
        }),

        // Admin Agency management endpoints
        getAdminAgencies: build.query<any[], { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/agencies`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        createAdminAgency: build.mutation<any, { jwtToken: string, payload: { name: string; billingEmail?: string; adminEmail: string; adminFirstName: string; adminLastName: string } }>({
            query: (params) => ({
                url: `/admin/agencies`,
                method: 'POST',
                body: params.payload,
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Agency'],
        }),

        assignAdminOrganizationAgency: build.mutation<IOrganisation, { jwtToken: string, id: number, agencyOrganisationId: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}/agency`,
                method: 'POST',
                body: { agencyOrganisationId: params.agencyOrganisationId },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Admin', 'Agency'],
        }),

        removeAdminOrganizationAgency: build.mutation<IOrganisation, { jwtToken: string, id: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.id}/agency`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Admin', 'Agency'],
        }),

        // Agency endpoints
        getAgencyClients: build.query<IAgencyClient[], { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/clients`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        getAgencyMyClients: build.query<IAgencyUserAccess[], { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/my-clients`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        inviteAgencyClient: build.mutation<IAgencyClient, { jwtToken: string, payload: IAgencyInviteClientDto }>({
            query: (params) => ({
                url: `/agency/clients/invite`,
                method: 'POST',
                body: params.payload,
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Agency'],
        }),

        createAgencyClientOrg: build.mutation<any, { jwtToken: string, payload: { organisationName: string; brandName?: string; templateType: string; productType?: string; businessTypeId?: number; benchmarkProductTypeId?: number; websiteUrl?: string; notes?: string; inviteEmail?: string; inviteFirstName?: string; inviteLastName?: string } }>({
            query: (params) => ({
                url: `/agency/clients/create`,
                method: 'POST',
                body: params.payload,
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Agency'],
        }),

        removeAgencyClient: build.mutation<{ message: string }, { jwtToken: string, clientId: number }>({
            query: (params) => ({
                url: `/agency/clients/${params.clientId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Agency'],
        }),

        switchToClientContext: build.mutation<IAgencyContextResponse, { jwtToken: string, clientOrgId: number }>({
            query: (params) => ({
                url: `/agency/clients/${params.clientOrgId}/context`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        returnToAgencyContext: build.mutation<IAgencyReturnResponse, { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/context/return`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        getAgencyPortfolioAnalytics: build.query<IAgencyPortfolioAnalytics, { jwtToken: string, period: string }>({
            query: (params) => ({
                url: `/agency/dashboard/portfolio-analytics?period=${params.period}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        getAgencyBrandTrend: build.query<IAgencyBrandTrend, { jwtToken: string, brandId: number, period: string }>({
            query: (params) => ({
                url: `/agency/dashboard/brands/${params.brandId}/trend?period=${params.period}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        getAgencyClientScorecard: build.query<IAgencyClientScorecard, { jwtToken: string, clientOrgId: number, period: string, brandId?: number }>({
            query: (params) => ({
                url: `/agency/dashboard/clients/${params.clientOrgId}/scorecard?period=${params.period}${params.brandId ? `&brandId=${params.brandId}` : ''}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        getAgencyDashboardActivity: build.query<IAgencyActivityFeed, { jwtToken: string, limit?: number, offset?: number }>({
            query: (params) => ({
                url: `/agency/dashboard/activity`,
                method: 'GET',
                params: { limit: params.limit || 50, offset: params.offset || 0 },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        getAgencyPortfolioSummary: build.query<IAgencyPortfolioSummary, { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/dashboard/portfolio-summary`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        getAgencyAlerts: build.query<IAgencyActivityItem[], { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/dashboard/alerts`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        // Agency billing endpoints
        getAgencyBillingSummary: build.query<any, { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/billing/summary`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        getAgencyPaymentMethods: build.query<any[], { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/billing/payment-methods`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Agency'],
        }),

        assumeAgencyBilling: build.mutation<{ message: string }, { jwtToken: string, clientOrgId: number, paymentMethodId: string }>({
            query: (params) => ({
                url: `/agency/billing/clients/${params.clientOrgId}/assume`,
                method: 'POST',
                body: { paymentMethodId: params.paymentMethodId },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Agency'],
        }),

        releaseAgencyBilling: build.mutation<{ message: string }, { jwtToken: string, clientOrgId: number }>({
            query: (params) => ({
                url: `/agency/billing/clients/${params.clientOrgId}/release`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Agency'],
        }),

        // Agency reference data endpoints
        getAgencyBusinessTypes: build.query<any[], { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/reference/business-types`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        getAgencyProductTypes: build.query<any[], { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/reference/product-types`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        // Client-side agency endpoints
        getMyAgency: build.query<{ agency: IAgencyClient | null, pendingInvitations: IAgencyClient[] }, { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/my-agency`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        acceptAgencyInvitation: build.mutation<IAgencyClient, { jwtToken: string, invitationId: number }>({
            query: (params) => ({
                url: `/agency/invitations/${params.invitationId}/accept`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        declineAgencyInvitation: build.mutation<{ message: string }, { jwtToken: string, invitationId: number }>({
            query: (params) => ({
                url: `/agency/invitations/${params.invitationId}/decline`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        disconnectFromAgency: build.mutation<{ message: string }, { jwtToken: string }>({
            query: (params) => ({
                url: `/agency/my-agency/disconnect`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        // Admin Organization Details endpoints
        getAdminOrganizationBrands: build.query<{ data: IAdminBrandResponse[] }, { jwtToken: string, organizationId: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.organizationId}/brands`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminOrganizationSurveys: build.query<{ data: IAdminSurveyResponse[] }, { jwtToken: string, organizationId: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.organizationId}/surveys`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['Admin'],
        }),

        getAdminOrganizationUsers: build.query<{ data: IApiUser[] }, { jwtToken: string, organizationId: number }>({
            query: (params) => ({
                url: `/admin/organizations/${params.organizationId}/users`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['AdminUsers'],
        }),

        getAdminOrganizationEvents: build.query<{
            events: any[];
            total: number;
            page: number;
            limit: number;
            totalPages: number;
        }, { jwtToken: string, organizationId: number, limit?: number, offset?: number }>({
            query: (params) => {
                const queryParams: Record<string, string> = {
                    limit: (params.limit || 50).toString(),
                    offset: (params.offset || 0).toString(),
                };

                return {
                    url: `/admin/organizations/${params.organizationId}/events?${new URLSearchParams(queryParams).toString()}`,
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${params.jwtToken}`,
                    },
                };
            },
            providesTags: ['AdminEvents'],
        }),

        // Admin: Organization Subscription & Addons
        getAdminOrganizationSubscription: build.query<IOrganisationSubscription, { jwtToken: string; organizationId: number }>({
            query: ({ jwtToken, organizationId }) => ({
                url: `/admin/organisations/${organizationId}/subscription`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Admin'],
        }),

        getAdminOrganizationAddons: build.query<IOrganisationAddon[], { jwtToken: string; organizationId: number }>({
            query: ({ jwtToken, organizationId }) => ({
                url: `/admin/organisations/${organizationId}/subscription/addons`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Admin'],
        }),

        // Database Backup endpoints
        createDatabaseBackup: build.mutation<{
            downloadUrl: string;
            filename: string;
            fileSize: number;
            expiresAt: string;
        }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/database-backups`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminEvents', 'DatabaseBackups'],
        }),

        getDatabaseBackups: build.query<{
            data: Array<{
                id: number;
                filename: string;
                fileSizeMb: number | null;
                status: 'RUNNING' | 'COMPLETED' | 'FAILED';
                triggerType: 'SCHEDULED' | 'MANUAL';
                triggeredBy: number | null;
                durationSeconds: number | null;
                errorMessage: string | null;
                expiresAt: string;
                isDeleted: boolean;
                createdAt: string;
            }>;
            total: number;
            page: number;
            limit: number;
        }, { jwtToken: string; page?: number; limit?: number; status?: string; triggerType?: string }>({
            query: ({ jwtToken, page = 1, limit = 20, status, triggerType }) => {
                const params = new URLSearchParams();
                params.set('page', String(page));
                params.set('limit', String(limit));
                if (status) params.set('status', status);
                if (triggerType) params.set('triggerType', triggerType);
                return {
                    url: `/admin/database-backups?${params.toString()}`,
                    headers: { Authorization: `Bearer ${jwtToken}` },
                };
            },
            providesTags: ['DatabaseBackups'],
        }),

        getDatabaseBackupStatus: build.query<{
            lastBackup: {
                date: string;
                status: 'COMPLETED' | 'FAILED';
                sizeMb: number | null;
                durationSeconds: number | null;
            } | null;
            nextScheduledAt: string | null;
            totalBackups: number;
            totalSizeMb: number;
            oldestBackup: string | null;
            backupEnabled: boolean;
            schedule: string;
            retentionDays: number;
            minRetained: number;
        }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: `/admin/database-backups/status`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['DatabaseBackups'],
        }),

        getDatabaseBackupDownloadUrl: build.mutation<{
            downloadUrl: string;
            expiresAt: string;
        }, { jwtToken: string; backupId: number }>({
            query: ({ jwtToken, backupId }) => ({
                url: `/admin/database-backups/${backupId}/download`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        deleteDatabaseBackup: build.mutation<void, { jwtToken: string; backupId: number }>({
            query: ({ jwtToken, backupId }) => ({
                url: `/admin/database-backups/${backupId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['DatabaseBackups', 'AdminEvents'],
        }),

        // 2FA endpoints
        twoFactorStatus: build.query<{ enabled: boolean; backupCodesRemaining: number; isAdminUser: boolean; setupRequired: boolean }, { jwtToken: string }>({
            query: (params) => ({
                url: `/auth/2fa/status`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        twoFactorSetup: build.mutation<{ qrCodeUrl: string; secret: string; backupCodes: string[] }, { jwtToken: string }>({
            query: (params) => ({
                url: `/auth/2fa/setup`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        twoFactorEnable: build.mutation<{ backupCodes: string[] }, { jwtToken: string; token: string }>({
            query: (params) => ({
                url: `/auth/2fa/enable`,
                method: 'POST',
                body: { token: params.token },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        twoFactorVerify: build.mutation<{ valid: boolean }, { jwtToken: string; token: string }>({
            query: (params) => ({
                url: `/auth/2fa/verify`,
                method: 'POST',
                body: { token: params.token },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        twoFactorDisable: build.mutation<{ message: string }, { jwtToken: string; token: string }>({
            query: (params) => ({
                url: `/auth/2fa/disable`,
                method: 'POST',
                body: { token: params.token },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        twoFactorRegenerateBackupCodes: build.mutation<{ backupCodes: string[] }, { jwtToken: string; token: string }>({
            query: (params) => ({
                url: `/auth/2fa/backup-codes`,
                method: 'POST',
                body: { token: params.token },
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // System Settings endpoints
        getSystemSettings: build.query<any[], { jwtToken: string }>({
            query: (params) => ({
                url: `/system-settings`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['SystemSettings'],
        }),

        getSystemSettingsByCategory: build.query<{
            categories: Array<{
                category: string;
                settings: Array<{
                    name: string;
                    value: string;
                    type: string;
                    description?: string;
                    createdAt?: string;
                    updatedAt?: string;
                }>;
            }>;
        }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/system-settings`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['SystemSettings'],
        }),

        updateSystemSettingsBatch: build.mutation<{ success: boolean; message: string }, {
            jwtToken: string;
            payload: { settings: Array<{ name: string; value: string }> }
        }>({
            query: (params) => ({
                url: `/admin/system-settings`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['SystemSettings', 'JobLocks'],
        }),

        getSystemSetting: build.query<string, { jwtToken: string, settingName: string }>({
            query: (params) => ({
                url: `/system-settings/${params.settingName}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['SystemSettings'],
        }),

        getAiPublishedVersions: build.query<Record<string, number | null>, { jwtToken: string }>({
            query: (params) => ({
                url: `/ai/published-versions`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        createSystemSetting: build.mutation<any, { jwtToken: string, payload: { name: string, value: string, type: string } }>({
            query: (params) => ({
                url: `/system-settings`,
                method: 'POST',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['SystemSettings'],
        }),

        updateSystemSetting: build.mutation<any, { jwtToken: string, settingName: string, payload: { value: string } }>({
            query: (params) => ({
                url: `/system-settings/${params.settingName}`,
                method: 'PUT',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['SystemSettings'],
        }),

        deleteSystemSetting: build.mutation<{ deleted: boolean }, { jwtToken: string, settingName: string }>({
            query: (params) => ({
                url: `/system-settings/${params.settingName}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['SystemSettings'],
        }),

        // Available AI Models endpoint
        getAvailableAIModels: build.query<{
            providers: Array<{
                provider: string;
                label: string;
                models: Array<{ id: string; label: string; contextWindow?: number }>;
            }>;
            embeddingModels: Array<{ id: string; label: string }>;
        }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/ai-system/models`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['SystemSettings'],
        }),

        // AI Quota endpoints
        getAIQuotaStatus: build.query<IAIQuotaStatus, { jwtToken: string }>({
            query: (params) => ({
                url: `/api/ai-quota/status`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getAdminOrganizationQuotaStatus: build.query<IAIQuotaStatus, { jwtToken: string; orgId: number }>({
            query: (params) => ({
                url: `/api/ai-quota/admin/organization/${params.orgId}/status`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Job Locking endpoints
        getJobLocks: build.query<{
            registeredJobs: Array<{
                jobName: string;
                cronExpression: string;
                description?: string;
                defaultTimeoutMs?: number;
                isLocked?: boolean;
                currentLock?: {
                    jobName: string;
                    lockedBy: string;
                    lockedAt: string;
                    expiresAt: string;
                    executionCount: number;
                    lastSuccessfulAt?: string;
                    lastError?: string;
                    lastErrorAt?: string;
                    isExpired?: boolean;
                };
                statistics?: {
                    jobName: string;
                    totalExecutions: number;
                    successRate: number;
                    averageDurationMs: number;
                    lastExecution?: any;
                    recentHistory?: any[];
                };
            }>;
            activeLocks: Array<{
                jobName: string;
                lockedBy: string;
                lockedAt: string;
                expiresAt: string;
                executionCount: number;
                lastSuccessfulAt?: string;
                lastError?: string;
                lastErrorAt?: string;
                isExpired?: boolean;
            }>;
        }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/job-locks`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['JobLocks'],
        }),

        getJobHistory: build.query<Array<{
            id: number;
            jobName: string;
            instanceId: string;
            startedAt: string;
            completedAt?: string;
            status: string;
            errorMessage?: string;
            durationMs?: number;
        }>, { jwtToken: string; jobName?: string; limit?: number }>({
            query: (params) => ({
                url: `/admin/job-locks/history?${new URLSearchParams({
                    ...(params.jobName && { jobName: params.jobName }),
                    ...(params.limit && { limit: params.limit.toString() }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['JobLocks'],
        }),

        getJobStatistics: build.query<{
            jobName: string;
            totalExecutions: number;
            successRate: number;
            averageDurationMs: number;
            lastExecution?: any;
            recentHistory?: any[];
        }, { jwtToken: string; jobName: string }>({
            query: (params) => ({
                url: `/admin/job-locks/${params.jobName}/statistics`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['JobLocks'],
        }),

        forceUnlockJob: build.mutation<{ success: boolean; message: string }, {
            jwtToken: string;
            jobName: string;
        }>({
            query: (params) => ({
                url: `/admin/job-locks/${params.jobName}/unlock`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['JobLocks'],
        }),

        runJobManually: build.mutation<{ success: boolean; message: string }, {
            jwtToken: string;
            jobName: string;
        }>({
            query: (params) => ({
                url: `/admin/job-locks/${params.jobName}/run`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['JobLocks'],
        }),

        updateJobConfig: build.mutation<{ success: boolean; message: string }, {
            jwtToken: string;
            jobName: string;
            payload: {
                lockTimeoutMs?: number;
                enabled?: boolean;
            };
        }>({
            query: (params) => ({
                url: `/admin/job-locks/${params.jobName}/config`,
                method: 'PUT',
                body: params.payload,
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['JobLocks'],
        }),

        // Cache Management
        getCacheStats: build.query<{
            totalEntries: number;
            withAiSummaries: number;
            withoutAiSummaries: number;
            expired: number;
            maxEntries: number;
            settings: {
                cacheDurationWithAiSeconds: number;
                cacheDurationWithoutAiSeconds: number;
                maxEntries: number;
            };
        }, { jwtToken: string }>({
            query: (params) => ({
                url: '/admin/cache/brand-equity/stats',
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: [EntityTag.BrandEquity],
        }),

        invalidateBrandCache: build.mutation<{ message: string, timestamp: string }, { 
            jwtToken: string, 
            brandId: number, 
            orgId: number 
        }>({
            query: (params) => ({
                url: `/admin/cache/brand-equity/brand/${params.brandId}?orgId=${params.orgId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.BrandEquity, 'Admin'],
        }),

        invalidateOrganizationCache: build.mutation<{ message: string, timestamp: string }, { 
            jwtToken: string, 
            orgId: number 
        }>({
            query: (params) => ({
                url: `/admin/cache/brand-equity/organization/${params.orgId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.BrandEquity, 'Admin'],
        }),

        forceRefreshBrandEquityCache: build.mutation<{ message: string, filters: any, timestamp: string }, {
            jwtToken: string;
            brandIds?: number[];
            surveyIds?: number[];
            dateFrom?: string;
            dateTo?: string;
            orgId: number;
        }>({
            query: (params) => {
                const searchParams = new URLSearchParams();
                searchParams.append('orgId', params.orgId.toString());
                if (params.brandIds?.length) {
                    searchParams.append('brandIds', params.brandIds.join(','));
                }
                if (params.surveyIds?.length) {
                    searchParams.append('surveyIds', params.surveyIds.join(','));
                }
                if (params.dateFrom) {
                    searchParams.append('dateFrom', params.dateFrom);
                }
                if (params.dateTo) {
                    searchParams.append('dateTo', params.dateTo);
                }
                
                return {
                    url: `/admin/cache/brand-equity/force-refresh?${searchParams.toString()}`,
                    method: 'DELETE',
                    headers: {
                        Authorization: `Bearer ${params.jwtToken}`,
                    },
                };
            },
            invalidatesTags: [EntityTag.BrandEquity, 'Admin'],
        }),

        // Brand Analytics endpoints
        getAdminBrandsForAnalytics: build.query<IBrandAnalyticsSummary[], { jwtToken: string }>({
            query: (params) => ({
                url: '/admin/brands/analytics',
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getAdminBrandAnalytics: build.query<IBrandAnalytics, { 
            jwtToken: string;
            brandHash: string; 
            period?: string;
        }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandHash}/analytics?period=${params.period || '180_days'}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getAdminBrandAnalyticsMetrics: build.query<IBrandAnalyticsMetricOption[], { 
            jwtToken: string;
            brandHash: string; 
        }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandHash}/analytics/metrics`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getAdminBrandAnalyticsDrillDown: build.query<string[], { 
            jwtToken: string;
            brandHash: string;
            parentMetric: string;
            level: 'measuredElement' | 'statements';
        }>({
            query: (params) => ({
                url: `/admin/brands/${params.brandHash}/analytics/drill-down?parentMetric=${params.parentMetric}&level=${params.level}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Organization Brand Analytics endpoints
        getOrgBrands: build.query<IBrandAnalyticsSummary[], { 
            jwtToken: string;
            orgId: string;
        }>({
            query: (params) => ({
                url: `/organisations/${params.orgId}/brands/analytics`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getOrgBrandAnalytics: build.query<IBrandAnalytics, { 
            jwtToken: string;
            orgId: string;
            brandHash: string; 
            period?: string;
        }>({
            query: (params) => ({
                url: `/organisations/${params.orgId}/brands/${params.brandHash}/analytics?period=${params.period || '180_days'}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getOrgBrandAnalyticsMetrics: build.query<IBrandAnalyticsMetricOption[], { 
            jwtToken: string;
            orgId: string;
            brandHash: string; 
        }>({
            query: (params) => ({
                url: `/organisations/${params.orgId}/brands/${params.brandHash}/analytics/metrics`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getOrgBrandAnalyticsDrillDown: build.query<string[], { 
            jwtToken: string;
            orgId: string;
            brandHash: string;
            parentMetric: string;
            level: 'measuredElement' | 'statements';
        }>({
            query: (params) => ({
                url: `/organisations/${params.orgId}/brands/${params.brandHash}/analytics/drill-down?parentMetric=${params.parentMetric}&level=${params.level}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // Mock Data Management endpoints
        getMockDataStatus: build.query<{
            success: boolean;
            hasData: boolean;
            stats: {
                organisations: number;
                brands: number;
                surveys: number;
                surveyResponses: number;
                questionResponses: number;
            };
        }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/mock-data/status`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            providesTags: ['MockData'],
        }),

        generateTestMockData: build.mutation<{ message: string; success: boolean }, { jwtToken: string; clean?: boolean }>({
            query: (params) => ({
                url: `/admin/mock-data/test${params.clean ? '?clean=true' : ''}`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['MockData'],
        }),

        generateFullMockData: build.mutation<{ message: string; success: boolean }, { 
            jwtToken: string; 
            payload: { 
                clean?: boolean;
                months?: number;
                responsesPerMonth?: number;
            } 
        }>({
            query: (params) => ({
                url: `/admin/mock-data/generate`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                    'Content-Type': 'application/json',
                },
                body: params.payload,
            }),
            invalidatesTags: ['MockData'],
        }),

        cleanMockData: build.mutation<{ message: string; success: boolean }, { jwtToken: string }>({
            query: (params) => ({
                url: `/admin/mock-data/clean`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
            invalidatesTags: ['MockData'],
        }),

        // Messages endpoints
        getInbox: build.query<{
            messages: IMessageRecipient[];
            pagination: { page: number; limit: number; total: number; totalPages: number };
            unreadCount: number;
        }, {
            folder?: string;
            page?: number;
            limit?: number;
            unreadOnly?: boolean;
            messageTypeCode?: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
        }>({
            query: (params) => {
                const queryParams = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        queryParams.append(key, value.toString());
                    }
                });
                return {
                    url: `/messages/inbox?${queryParams}`,
                    method: 'GET',
                };
            },
            providesTags: [EntityTag.Messages],
        }),

        getInboxStats: build.query<IInboxStats, void>({
            query: () => ({
                url: `/messages/inbox/stats`,
                method: 'GET',
            }),
            providesTags: [EntityTag.Messages],
        }),

        getMessage: build.query<IMessage, { hash: string }>({
            query: (params) => ({
                url: `/messages/${params.hash}`,
                method: 'GET',
            }),
            providesTags: [EntityTag.Messages],
        }),

        updateMessageStatus: build.mutation<void, { hash: string; updates: IUpdateMessageStatusDto }>({
            query: (params) => ({
                url: `/messages/${params.hash}/status`,
                method: 'PATCH',
                body: params.updates,
            }),
            invalidatesTags: [EntityTag.Messages],
        }),

        bulkUpdateMessageStatus: build.mutation<void, IBulkUpdateMessageStatusDto>({
            query: (params) => ({
                url: `/messages/bulk/status`,
                method: 'POST',
                body: params,
            }),
            invalidatesTags: [EntityTag.Messages],
        }),

        markAllAsRead: build.mutation<void, void>({
            query: () => ({
                url: `/messages/mark-all-read`,
                method: 'POST',
            }),
            invalidatesTags: [EntityTag.Messages],
        }),
        emptyTrash: build.mutation<void, void>({
            query: () => ({
                url: `/messages/empty-trash`,
                method: 'POST',
            }),
            invalidatesTags: [EntityTag.Messages],
        }),

        getMessagePreferences: build.query<IMessagePreference[], void>({
            query: () => ({
                url: `/messages/preferences`,
                method: 'GET',
            }),
            providesTags: [EntityTag.Messages],
        }),

        updateMessagePreferences: build.mutation<void, IBulkUpdatePreferencesDto>({
            query: (params) => ({
                url: `/messages/preferences`,
                method: 'PUT',
                body: params,
            }),
            invalidatesTags: [EntityTag.Messages],
        }),

        // Admin messages endpoints
        getAllMessages: build.query<{
            messages: IMessage[];
            pagination: { page: number; limit: number; total: number; totalPages: number };
        }, {
            page?: number;
            limit?: number;
            search?: string;
            messageTypeCode?: string;
            organisationId?: number;
            userId?: number;
            status?: string;
            startDate?: string;
            endDate?: string;
            sortBy?: string;
            sortOrder?: string;
        }>({
            query: (params) => {
                const queryParams = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        queryParams.append(key, value.toString());
                    }
                });
                return {
                    url: `/admin/messages?${queryParams}`,
                    method: 'GET',
                };
            },
            providesTags: [EntityTag.Messages],
        }),

        getAdminStats: build.query<IAdminStats, void>({
            query: () => ({
                url: `/admin/messages/stats`,
                method: 'GET',
            }),
            providesTags: [EntityTag.Messages],
        }),

        getMessageTypes: build.query<IMessageType[], void>({
            query: () => ({
                url: `/admin/messages/types`,
                method: 'GET',
            }),
            providesTags: [EntityTag.Messages],
        }),

        getMessageDetails: build.query<IMessage & { stats: any }, { hash: string }>({
            query: (params) => ({
                url: `/admin/messages/${params.hash}`,
                method: 'GET',
            }),
            providesTags: [EntityTag.Messages],
        }),

        sendMessage: build.mutation<{ message: string; data: IMessage }, ICreateMessageDto>({
            query: (params) => ({
                url: `/admin/messages/send`,
                method: 'POST',
                body: params,
            }),
            invalidatesTags: [EntityTag.Messages],
        }),

        scheduleMessage: build.mutation<{ message: string; data: IMessage }, ICreateMessageDto>({
            query: (params) => ({
                url: `/admin/messages/schedule`,
                method: 'POST',
                body: params,
            }),
            invalidatesTags: [EntityTag.Messages],
        }),

        deleteMessage: build.mutation<void, { hash: string }>({
            query: (params) => ({
                url: `/admin/messages/${params.hash}`,
                method: 'DELETE',
            }),
            invalidatesTags: [EntityTag.Messages],
        }),

        // Response Monitoring endpoints
        getPendingResponseMonitoringMessages: build.query<any, { jwtToken: string; page?: number; limit?: number }>({
            query: (params) => ({
                url: `/admin/response-monitoring/messages/pending?page=${params.page || 1}&limit=${params.limit || 10}`,
                method: 'GET',
            }),
            providesTags: ['ResponseMonitoring'],
        }),

        approveResponseMonitoringMessage: build.mutation<any, { jwtToken: string; messageId: number; editedContent?: any }>({
            query: (params) => ({
                url: `/admin/response-monitoring/messages/${params.messageId}/approve`,
                method: 'POST',
                body: { editedContent: params.editedContent },
            }),
            invalidatesTags: ['ResponseMonitoring'],
        }),

        rejectResponseMonitoringMessage: build.mutation<any, { jwtToken: string; messageId: number }>({
            query: (params) => ({
                url: `/admin/response-monitoring/messages/${params.messageId}/reject`,
                method: 'POST',
            }),
            invalidatesTags: ['ResponseMonitoring'],
        }),

        regenerateResponseMonitoringMessage: build.mutation<any, { jwtToken: string; messageId: number }>({
            query: (params) => ({
                url: `/admin/response-monitoring/messages/${params.messageId}/regenerate`,
                method: 'POST',
            }),
            invalidatesTags: ['ResponseMonitoring'],
        }),
        sendTestEmailForResponseMonitoringMessage: build.mutation<any, { jwtToken: string; messageId: number; testEmail: string; testContent?: { subject?: string; bodyHtml?: string; bodyText?: string } }>({
            query: (params) => ({
                url: `/admin/response-monitoring/messages/${params.messageId}/test-email`,
                method: 'POST',
                body: {
                    testEmail: params.testEmail,
                    testContent: params.testContent
                },
            }),
        }),

        getResponseMonitoringStatistics: build.query<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-monitoring/statistics`,
                method: 'GET',
            }),
            providesTags: ['ResponseMonitoring'],
        }),

        getBrandMonitoringHistory: build.query<any, { jwtToken: string; brandId: number }>({
            query: (params) => ({
                url: `/admin/response-monitoring/brands/${params.brandId}/history`,
                method: 'GET',
            }),
            providesTags: ['ResponseMonitoring'],
        }),

        getBrandMonitoringConfig: build.query<any, { jwtToken: string; brandId: number }>({
            query: (params) => ({
                url: `/admin/response-monitoring/brands/${params.brandId}/config`,
                method: 'GET',
            }),
            providesTags: ['ResponseMonitoring'],
        }),

        updateBrandMonitoringConfig: build.mutation<any, { jwtToken: string; brandId: number; config: any }>({
            query: (params) => ({
                url: `/admin/response-monitoring/brands/${params.brandId}/config`,
                method: 'PATCH',
                body: params.config,
            }),
            invalidatesTags: ['ResponseMonitoring'],
        }),

        getResponseMonitoringSchedule: build.query<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-monitoring/schedule`,
                method: 'GET',
            }),
            providesTags: ['ResponseMonitoring'],
        }),

        updateResponseMonitoringSchedule: build.mutation<any, { jwtToken: string; schedule: string }>({
            query: (params) => ({
                url: `/admin/response-monitoring/schedule`,
                method: 'PUT',
                body: { schedule: params.schedule },
            }),
            invalidatesTags: ['ResponseMonitoring'],
        }),

        triggerResponseMonitoringCheck: build.mutation<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-monitoring/trigger`,
                method: 'POST',
            }),
            invalidatesTags: ['ResponseMonitoring'],
        }),

        triggerResponseMonitoringMessageGeneration: build.mutation<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-monitoring/generate-messages`,
                method: 'POST',
            }),
            invalidatesTags: ['ResponseMonitoring'],
        }),

        // Response Integrity (SYR-48 Phase 3) endpoints
        getFlaggedResponses: build.query<any, {
            jwtToken: string;
            surveyId?: number;
            brandId?: number;
            organisationId?: number;
            panelPartner?: string;
            tier?: string;
            rejectionStatus?: string;
            dateFrom?: string;
            dateTo?: string;
            page?: number;
            limit?: number;
        }>({
            query: (params) => {
                const qs = new URLSearchParams();
                if (params.surveyId) qs.set('surveyId', String(params.surveyId));
                if (params.brandId) qs.set('brandId', String(params.brandId));
                if (params.organisationId) qs.set('organisationId', String(params.organisationId));
                if (params.panelPartner) qs.set('panelPartner', params.panelPartner);
                if (params.tier) qs.set('tier', params.tier);
                if (params.rejectionStatus) qs.set('rejectionStatus', params.rejectionStatus);
                if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
                if (params.dateTo) qs.set('dateTo', params.dateTo);
                if (params.page) qs.set('page', String(params.page));
                if (params.limit) qs.set('limit', String(params.limit));
                const query = qs.toString();
                return {
                    url: `/admin/response-integrity/responses${query ? `?${query}` : ''}`,
                    method: 'GET',
                };
            },
            providesTags: ['ResponseIntegrity'],
        }),
        getFlaggedResponseDetail: build.query<any, { jwtToken: string; id: number }>({
            query: (params) => ({
                url: `/admin/response-integrity/responses/${params.id}`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: 'ResponseIntegrity', id: arg.id }],
        }),
        rejectFlaggedResponse: build.mutation<any, { jwtToken: string; id: number; reason: string; notes?: string }>({
            query: (params) => ({
                url: `/admin/response-integrity/responses/${params.id}/reject`,
                method: 'POST',
                body: { reason: params.reason, notes: params.notes },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ResponseIntegrity', id: arg.id },
                'ResponseIntegrity',
            ],
        }),
        confirmCleanFlaggedResponse: build.mutation<any, { jwtToken: string; id: number; notes?: string }>({
            query: (params) => ({
                url: `/admin/response-integrity/responses/${params.id}/confirm-clean`,
                method: 'POST',
                body: { notes: params.notes },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ResponseIntegrity', id: arg.id },
                'ResponseIntegrity',
            ],
        }),
        rescoreFlaggedResponse: build.mutation<any, { jwtToken: string; id: number }>({
            query: (params) => ({
                url: `/admin/response-integrity/responses/${params.id}/rescore`,
                method: 'POST',
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ResponseIntegrity', id: arg.id },
                'ResponseIntegrity',
            ],
        }),
        bulkRejectFlaggedResponses: build.mutation<any, {
            jwtToken: string;
            ids: number[];
            mode?: 'smart' | 'single';
            reason?: string;
            notes?: string;
        }>({
            query: (params) => ({
                url: `/admin/response-integrity/responses/bulk-reject`,
                method: 'POST',
                body: {
                    ids: params.ids,
                    mode: params.mode,
                    reason: params.reason,
                    notes: params.notes,
                },
            }),
            invalidatesTags: ['ResponseIntegrity'],
        }),
        bulkConfirmCleanFlaggedResponses: build.mutation<any, {
            jwtToken: string;
            ids: number[];
            notes?: string;
        }>({
            query: (params) => ({
                url: `/admin/response-integrity/responses/bulk-confirm-clean`,
                method: 'POST',
                body: { ids: params.ids, notes: params.notes },
            }),
            invalidatesTags: ['ResponseIntegrity'],
        }),
        bulkRescoreFlaggedResponses: build.mutation<any, {
            jwtToken: string;
            ids: number[];
        }>({
            query: (params) => ({
                url: `/admin/response-integrity/responses/bulk-rescore`,
                method: 'POST',
                body: { ids: params.ids },
            }),
            invalidatesTags: ['ResponseIntegrity'],
        }),
        getBrandEquityIntegrityComparison: build.query<any, {
            jwtToken: string;
            brandId: number;
            period?: string;
            dateFrom?: string;
            dateTo?: string;
        }>({
            query: (params) => {
                const qs = new URLSearchParams();
                qs.set('brandId', String(params.brandId));
                if (params.period) qs.set('period', params.period);
                if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
                if (params.dateTo) qs.set('dateTo', params.dateTo);
                return {
                    url: `/admin/response-integrity/brand-equity-comparison?${qs.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: ['ResponseIntegrity'],
        }),
        getCohortComparison: build.query<any, {
            jwtToken: string;
            brandId: number;
            period?: string;
            dateFrom?: string;
            dateTo?: string;
        }>({
            query: (params) => {
                const qs = new URLSearchParams();
                qs.set('brandId', String(params.brandId));
                if (params.period) qs.set('period', params.period);
                if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
                if (params.dateTo) qs.set('dateTo', params.dateTo);
                return {
                    url: `/admin/response-integrity/cohort-comparison?${qs.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: ['ResponseIntegrity'],
        }),
        getChargebacks: build.query<any, {
            jwtToken: string;
            panelPartner?: string;
            status?: string;
            surveyId?: number;
            page?: number;
            limit?: number;
        }>({
            query: (params) => {
                const qs = new URLSearchParams();
                if (params.panelPartner) qs.set('panelPartner', params.panelPartner);
                if (params.status) qs.set('status', params.status);
                if (params.surveyId) qs.set('surveyId', String(params.surveyId));
                if (params.page) qs.set('page', String(params.page));
                if (params.limit) qs.set('limit', String(params.limit));
                const q = qs.toString();
                return {
                    url: `/admin/response-integrity/chargebacks${q ? `?${q}` : ''}`,
                    method: 'GET',
                };
            },
            providesTags: ['ResponseIntegrity'],
        }),
        getChargebackDetail: build.query<any, { jwtToken: string; id: number }>({
            query: (params) => ({
                url: `/admin/response-integrity/chargebacks/${params.id}`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [
                { type: 'ResponseIntegrity', id: `chargeback-${arg.id}` },
            ],
        }),
        createChargeback: build.mutation<any, {
            jwtToken: string;
            surveyId: number;
            panelPartner: string;
            responseIds: number[];
            submissionMethod?: string;
        }>({
            query: (params) => ({
                url: `/admin/response-integrity/chargebacks`,
                method: 'POST',
                body: {
                    surveyId: params.surveyId,
                    panelPartner: params.panelPartner,
                    responseIds: params.responseIds,
                    submissionMethod: params.submissionMethod,
                },
            }),
            invalidatesTags: ['ResponseIntegrity'],
        }),
        updateChargebackStatus: build.mutation<any, {
            jwtToken: string;
            id: number;
            status: string;
            resolutionNotes?: string;
            creditAmountUsd?: number;
        }>({
            query: (params) => ({
                url: `/admin/response-integrity/chargebacks/${params.id}/status`,
                method: 'PATCH',
                body: {
                    status: params.status,
                    resolutionNotes: params.resolutionNotes,
                    creditAmountUsd: params.creditAmountUsd,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ResponseIntegrity', id: `chargeback-${arg.id}` },
                'ResponseIntegrity',
            ],
        }),
        getPanelStats: build.query<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-integrity/panel-stats`,
                method: 'GET',
            }),
            providesTags: ['ResponseIntegrity'],
        }),
        getIntegrityDetectors: build.query<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-integrity/detectors`,
                method: 'GET',
            }),
            providesTags: ['ResponseIntegrity'],
        }),
        updateIntegrityDetectorConfig: build.mutation<any, {
            jwtToken: string;
            detectorId: string;
            profileId: string;
            isActive?: boolean;
            weight?: number;
            configJson?: Record<string, unknown> | null;
        }>({
            query: (params) => ({
                url: `/admin/response-integrity/detectors`,
                method: 'PATCH',
                body: {
                    detectorId: params.detectorId,
                    profileId: params.profileId,
                    isActive: params.isActive,
                    weight: params.weight,
                    configJson: params.configJson,
                },
            }),
            invalidatesTags: ['ResponseIntegrity'],
        }),
        getIntegritySettings: build.query<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-integrity/settings`,
                method: 'GET',
            }),
            providesTags: ['ResponseIntegrity'],
        }),
        updateIntegritySettings: build.mutation<any, {
            jwtToken: string;
            cleanMin?: number;
            suspectMin?: number;
            flaggedMin?: number;
            llmBudgetPerSurveyUsd?: number;
            llmAlertRecipients?: string;
            evidenceRetentionDays?: number;
            enabled?: boolean;
        }>({
            query: (params) => {
                const { jwtToken, ...body } = params;
                return {
                    url: `/admin/response-integrity/settings`,
                    method: 'PATCH',
                    body,
                };
            },
            invalidatesTags: ['ResponseIntegrity'],
        }),
        getIntegrityLlmCost: build.query<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/response-integrity/llm-cost`,
                method: 'GET',
            }),
            providesTags: ['ResponseIntegrity'],
        }),
        getDataQualitySummary: build.query<any, {
            jwtToken: string;
            organisationId: number;
            brandHash: string;
            period?: string;
            dateFrom?: string;
            dateTo?: string;
        }>({
            query: (params) => {
                const qs = new URLSearchParams();
                if (params.period) qs.set('period', params.period);
                if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
                if (params.dateTo) qs.set('dateTo', params.dateTo);
                const q = qs.toString();
                return {
                    url: `/organisations/${params.organisationId}/brands/${params.brandHash}/data-quality-summary${q ? `?${q}` : ''}`,
                    method: 'GET',
                };
            },
            providesTags: ['ResponseIntegrity'],
        }),

        // Benchmarking endpoints
        getBrandBenchmarks: build.query<any, { jwtToken: string; brandId: number; query?: any }>({
            query: ({ brandId, query }) => ({
                url: `/admin/benchmarking/brands/${brandId}${query ? `?${new URLSearchParams(query).toString()}` : ''}`,
                method: 'GET',
            }),
        }),

        getOrgBrandBenchmarks: build.query<{
            available: boolean;
            reason?: string;
            data?: any;
            accessLevels?: {
                overall: boolean;
                productType: boolean;
                allLevels: boolean;
            };
        }, { jwtToken: string; brandId: number; query?: any }>({
            query: ({ brandId, query }) => ({
                url: `/benchmarking/brands/${brandId}${query ? `?${new URLSearchParams(query).toString()}` : ''}`,
                method: 'GET',
            }),
        }),

        getAllBenchmarks: build.query<any, { jwtToken: string; query?: any }>({
            query: ({ query }) => ({
                url: `/admin/benchmarking/all${query ? `?${new URLSearchParams(query).toString()}` : ''}`,
                method: 'GET',
            }),
        }),

        calculateBenchmarks: build.mutation<{ message: string }, { jwtToken: string; forceRecalculation?: boolean }>({
            query: ({ forceRecalculation }) => ({
                url: `/admin/benchmarking/calculate`,
                method: 'POST',
                body: { forceRecalculation },
            }),
        }),

        initializeBenchmarkCategories: build.mutation<{ message: string }, { jwtToken: string }>({
            query: () => ({
                url: `/admin/benchmarking/initialize-categories`,
                method: 'POST',
            }),
        }),


        getBenchmarkingPreferences: build.query<any, { jwtToken: string }>({
            query: () => ({
                url: `/admin/benchmarking/preferences`,
                method: 'GET',
            }),
            providesTags: ['BenchmarkingPreferences'],
        }),

        updateBenchmarkingPreferences: build.mutation<any, { jwtToken: string; preferences: any }>({
            query: ({ preferences }) => ({
                url: `/admin/benchmarking/preferences`,
                method: 'PUT',
                body: preferences,
            }),
            invalidatesTags: ['BenchmarkingPreferences'],
        }),

        // Benchmark Business Types (org-facing, active only)
        getBenchmarkBusinessTypes: build.query<any[], { jwtToken: string }>({
            query: () => ({
                url: `/benchmarking/business-types`,
                method: 'GET',
            }),
            providesTags: ['BenchmarkBusinessTypes'],
        }),

        // Benchmark Product Types (org-facing, active only)
        getBenchmarkProductTypes: build.query<any[], { jwtToken: string }>({
            query: () => ({
                url: `/benchmarking/product-types`,
                method: 'GET',
            }),
            providesTags: ['BenchmarkProductTypes'],
        }),

        // Admin Benchmark Business Types CRUD
        getAdminBenchmarkBusinessTypes: build.query<any[], { jwtToken: string }>({
            query: () => ({
                url: `/admin/benchmarking/business-types`,
                method: 'GET',
            }),
            providesTags: ['BenchmarkBusinessTypes'],
        }),

        createBenchmarkBusinessType: build.mutation<any, { jwtToken: string; data: { name: string; slug: string; displayOrder?: number } }>({
            query: ({ data }) => ({
                url: `/admin/benchmarking/business-types`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['BenchmarkBusinessTypes'],
        }),

        updateBenchmarkBusinessType: build.mutation<any, { jwtToken: string; id: number; data: { name?: string; slug?: string; displayOrder?: number; isActive?: boolean } }>({
            query: ({ id, data }) => ({
                url: `/admin/benchmarking/business-types/${id}`,
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: ['BenchmarkBusinessTypes'],
        }),

        deleteBenchmarkBusinessType: build.mutation<{ success: boolean }, { jwtToken: string; id: number }>({
            query: ({ id }) => ({
                url: `/admin/benchmarking/business-types/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['BenchmarkBusinessTypes'],
        }),

        setBusinessTypeProductTypes: build.mutation<any, { jwtToken: string; businessTypeId: number; productTypeIds: number[] }>({
            query: ({ businessTypeId, productTypeIds }) => ({
                url: `/admin/benchmarking/business-types/${businessTypeId}/product-types`,
                method: 'PUT',
                body: { productTypeIds },
            }),
            invalidatesTags: ['BenchmarkBusinessTypes'],
        }),

        // Admin Benchmark Product Types CRUD
        getAdminBenchmarkProductTypes: build.query<any[], { jwtToken: string }>({
            query: () => ({
                url: `/admin/benchmarking/product-types`,
                method: 'GET',
            }),
            providesTags: ['BenchmarkProductTypes'],
        }),

        createBenchmarkProductType: build.mutation<any, { jwtToken: string; data: { name: string; slug: string; displayOrder?: number } }>({
            query: ({ data }) => ({
                url: `/admin/benchmarking/product-types`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['BenchmarkProductTypes'],
        }),

        updateBenchmarkProductType: build.mutation<any, { jwtToken: string; id: number; data: { name?: string; slug?: string; displayOrder?: number; isActive?: boolean } }>({
            query: ({ id, data }) => ({
                url: `/admin/benchmarking/product-types/${id}`,
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: ['BenchmarkProductTypes'],
        }),

        deleteBenchmarkProductType: build.mutation<{ success: boolean }, { jwtToken: string; id: number }>({
            query: ({ id }) => ({
                url: `/admin/benchmarking/product-types/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['BenchmarkProductTypes'],
        }),

        // Question Template Type registry (config-driven template_type wiring)
        getQuestionTemplateTypes: build.query<IQuestionTemplateType[], { jwtToken: string }>({
            query: () => ({
                url: `/question-template-types`,
                method: 'GET',
            }),
            providesTags: ['QuestionTemplateTypes'],
        }),

        getAdminQuestionTemplateTypes: build.query<IQuestionTemplateType[], { jwtToken: string }>({
            query: () => ({
                url: `/question-template-types/admin`,
                method: 'GET',
            }),
            providesTags: ['QuestionTemplateTypes'],
        }),

        createQuestionTemplateType: build.mutation<IQuestionTemplateType, { jwtToken: string; data: IQuestionTemplateTypeInput }>({
            query: ({ data }) => ({
                url: `/question-template-types`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['QuestionTemplateTypes'],
        }),

        updateQuestionTemplateType: build.mutation<IQuestionTemplateType, { jwtToken: string; id: number; data: Partial<IQuestionTemplateTypeInput> }>({
            query: ({ id, data }) => ({
                url: `/question-template-types/${id}`,
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: ['QuestionTemplateTypes'],
        }),

        deleteQuestionTemplateType: build.mutation<{ success: boolean }, { jwtToken: string; id: number }>({
            query: ({ id }) => ({
                url: `/question-template-types/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['QuestionTemplateTypes'],
        }),

        // Custom Brand Charts endpoints
        getCustomBrandCharts: build.query<ICustomBrandChart[], { jwtToken: string; brandHash: string }>({
            query: ({ jwtToken, brandHash }) => ({
                url: `/custom-brand-charts?brandHash=${brandHash}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: (result, error, { brandHash }) =>
                result
                    ? [...result.map(({ id }) => ({ type: EntityTag.CustomBrandChart as const, id })), { type: EntityTag.CustomBrandChart, id: `BRAND_${brandHash}` }]
                    : [{ type: EntityTag.CustomBrandChart, id: `BRAND_${brandHash}` }],
        }),

        createCustomBrandChart: build.mutation<ICustomBrandChart, { jwtToken: string; data: ICreateCustomBrandChartRequest }>({
            query: ({ jwtToken, data }) => ({
                url: `/custom-brand-charts`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: data,
            }),
            invalidatesTags: (result, error, { data }) => [{ type: EntityTag.CustomBrandChart, id: `BRAND_${data.brandHash}` }],
        }),

        updateCustomBrandChart: build.mutation<ICustomBrandChart, { jwtToken: string; id: number; data: IUpdateCustomBrandChartRequest; brandHash: string }>({
            query: ({ jwtToken, id, data }) => ({
                url: `/custom-brand-charts/${id}`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: data,
            }),
            invalidatesTags: (result, error, { id, brandHash }) => [
                { type: EntityTag.CustomBrandChart, id },
                { type: EntityTag.CustomBrandChart, id: `BRAND_${brandHash}` },
            ],
        }),

        deleteCustomBrandChart: build.mutation<{ message: string }, { jwtToken: string; id: number; brandHash: string }>({
            query: ({ jwtToken, id }) => ({
                url: `/custom-brand-charts/${id}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: (result, error, { id, brandHash }) => [
                { type: EntityTag.CustomBrandChart, id },
                { type: EntityTag.CustomBrandChart, id: `BRAND_${brandHash}` },
            ],
        }),

        reorderCustomBrandCharts: build.mutation<ICustomBrandChart[], { jwtToken: string; data: IReorderCustomBrandChartsRequest }>({
            query: ({ jwtToken, data }) => ({
                url: `/custom-brand-charts/reorder/bulk`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: data,
            }),
            invalidatesTags: (result, error, { data }) => [{ type: EntityTag.CustomBrandChart, id: `BRAND_${data.brandHash}` }],
        }),

        // CloudWatch Logs endpoints
        getCloudWatchLogGroups: build.query<Array<{
            logGroupName: string;
            creationTime?: number;
            storedBytes?: number;
            retentionInDays?: number;
        }>, { jwtToken: string; prefix?: string; limit?: number }>({
            query: (params) => ({
                url: `/cloudwatch-logs/log-groups?${new URLSearchParams({
                    ...(params.prefix && { prefix: params.prefix }),
                    ...(params.limit && { limit: params.limit.toString() }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getCloudWatchLogStreams: build.query<Array<{
            logStreamName: string;
            creationTime?: number;
            firstEventTimestamp?: number;
            lastEventTimestamp?: number;
            lastIngestionTime?: number;
        }>, { jwtToken: string; logGroupName: string; orderBy?: string; descending?: boolean; limit?: number }>({
            query: (params) => ({
                url: `/cloudwatch-logs/log-streams/${encodeURIComponent(params.logGroupName)}?${new URLSearchParams({
                    ...(params.orderBy && { orderBy: params.orderBy }),
                    ...(params.descending !== undefined && { descending: params.descending.toString() }),
                    ...(params.limit && { limit: params.limit.toString() }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        getCloudWatchLogEvents: build.query<{
            events: Array<{
                timestamp: number;
                message: string;
                ingestionTime?: number;
            }>;
            nextForwardToken?: string;
            nextBackwardToken?: string;
        }, { jwtToken: string; logGroupName: string; logStreamName: string; startTime?: number; endTime?: number; limit?: number; startFromHead?: boolean }>({
            query: (params) => ({
                url: `/cloudwatch-logs/log-events/${encodeURIComponent(params.logGroupName)}/${encodeURIComponent(params.logStreamName)}?${new URLSearchParams({
                    ...(params.startTime && { startTime: params.startTime.toString() }),
                    ...(params.endTime && { endTime: params.endTime.toString() }),
                    ...(params.limit && { limit: params.limit.toString() }),
                    ...(params.startFromHead !== undefined && { startFromHead: params.startFromHead.toString() }),
                }).toString()}`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params.jwtToken}`,
                },
            }),
        }),

        // ============================================
        // Embedded CRM Endpoints (SYR-84)
        // ============================================

        getCrmCompanies: build.query<{ data: ICrmCompany[]; total: number }, {
            jwtToken: string;
            stageId?: number;
            lifecycleStage?: string;
            ownerUserId?: number;
            source?: string;
            linked?: boolean;
            includeArchived?: boolean;
            q?: string;
            limit?: number;
            offset?: number;
        }>({
            query: ({ jwtToken, ...params }) => ({
                url: '/admin/crm/companies',
                params: Object.fromEntries(
                    Object.entries(params).filter(([, v]) => v !== undefined && v !== ''),
                ),
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['Crm'],
        }),

        getCrmCompany: build.query<ICrmCompanyDetail, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/crm/companies/${id}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['Crm'],
        }),

        createCrmCompany: build.mutation<ICrmCompany, { jwtToken: string; payload: Partial<ICrmCompany> }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/crm/companies',
                method: 'POST',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm'],
        }),

        updateCrmCompany: build.mutation<ICrmCompany, {
            jwtToken: string;
            id: number;
            payload: Record<string, any>;
        }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/crm/companies/${id}`,
                method: 'PATCH',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm', 'CrmActivities'],
        }),

        linkCrmCompany: build.mutation<ICrmCompany, {
            jwtToken: string;
            id: number;
            organisationId: number;
        }>({
            query: ({ jwtToken, id, organisationId }) => ({
                url: `/admin/crm/companies/${id}/link`,
                method: 'POST',
                body: { organisationId },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm', 'CrmActivities'],
        }),

        unlinkCrmCompany: build.mutation<ICrmCompany, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/crm/companies/${id}/link`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm', 'CrmActivities'],
        }),

        getCrmActivities: build.query<{ data: ICrmActivity[]; total: number }, {
            jwtToken: string;
            companyId: number;
            limit?: number;
            offset?: number;
        }>({
            query: ({ jwtToken, companyId, limit, offset }) => ({
                url: `/admin/crm/companies/${companyId}/activities`,
                params: { limit, offset },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmActivities'],
        }),

        createCrmActivity: build.mutation<ICrmActivity, {
            jwtToken: string;
            companyId: number;
            payload: { type: string; body: string; crmContactId?: number };
        }>({
            query: ({ jwtToken, companyId, payload }) => ({
                url: `/admin/crm/companies/${companyId}/activities`,
                method: 'POST',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmActivities', 'Crm'],
        }),

        createCrmContact: build.mutation<ICrmContact, {
            jwtToken: string;
            companyId: number;
            payload: Partial<ICrmContact>;
        }>({
            query: ({ jwtToken, companyId, payload }) => ({
                url: `/admin/crm/companies/${companyId}/contacts`,
                method: 'POST',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm'],
        }),

        updateCrmContact: build.mutation<ICrmContact, {
            jwtToken: string;
            contactId: number;
            payload: Partial<ICrmContact>;
        }>({
            query: ({ jwtToken, contactId, payload }) => ({
                url: `/admin/crm/contacts/${contactId}`,
                method: 'PATCH',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm'],
        }),

        deleteCrmContact: build.mutation<{ success: boolean }, { jwtToken: string; contactId: number }>({
            query: ({ jwtToken, contactId }) => ({
                url: `/admin/crm/contacts/${contactId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm'],
        }),

        getCrmTasks: build.query<ICrmTask[], {
            jwtToken: string;
            assignedToUserId?: number;
            status?: string;
            companyId?: number;
            dueBefore?: string;
        }>({
            query: ({ jwtToken, ...params }) => ({
                url: '/admin/crm/tasks',
                params: Object.fromEntries(
                    Object.entries(params).filter(([, v]) => v !== undefined && v !== ''),
                ),
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmTasks'],
        }),

        createCrmTask: build.mutation<ICrmTask, {
            jwtToken: string;
            payload: {
                crmCompanyId: number;
                title: string;
                details?: string;
                dueAt?: string;
                assignedToUserId?: number;
                reminderEnabled?: boolean;
            };
        }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/crm/tasks',
                method: 'POST',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmTasks', 'Crm', 'CrmActivities', 'CrmReminders'],
        }),

        updateCrmTask: build.mutation<ICrmTask, {
            jwtToken: string;
            id: number;
            payload: Record<string, any>;
        }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/crm/tasks/${id}`,
                method: 'PATCH',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmTasks', 'Crm', 'CrmActivities', 'CrmReminders'],
        }),

        // SYR-95: header-bell payload — my open reminders that are due/overdue.
        getMyCrmReminders: build.query<ICrmReminder[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/reminders/mine',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmReminders'],
        }),

        getCrmPipelineStages: build.query<ICrmPipelineStage[], { jwtToken: string; includeInactive?: boolean }>({
            query: ({ jwtToken, includeInactive }) => ({
                url: `/admin/crm/pipeline-stages${includeInactive ? '?includeInactive=true' : ''}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmStages'],
        }),

        updateCrmPipelineStage: build.mutation<ICrmPipelineStage, {
            jwtToken: string;
            id: number;
            payload: Partial<ICrmPipelineStage>;
        }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/crm/pipeline-stages/${id}`,
                method: 'PATCH',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmStages', 'Crm'],
        }),

        getCrmLinkSuggestions: build.query<ICrmLinkSuggestion[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/link-suggestions',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['Crm'],
        }),

        confirmCrmLinkSuggestion: build.mutation<ICrmCompany, {
            jwtToken: string;
            prospectCompanyId: number;
            signupCompanyId: number;
        }>({
            query: ({ jwtToken, prospectCompanyId, signupCompanyId }) => ({
                url: '/admin/crm/link-suggestions/confirm',
                method: 'POST',
                body: { prospectCompanyId, signupCompanyId },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm', 'CrmActivities'],
        }),

        rejectCrmLinkSuggestion: build.mutation<{ success: boolean }, {
            jwtToken: string;
            prospectCompanyId: number;
            organisationId: number;
        }>({
            query: ({ jwtToken, prospectCompanyId, organisationId }) => ({
                url: '/admin/crm/link-suggestions/reject',
                method: 'POST',
                body: { prospectCompanyId, organisationId },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm'],
        }),

        getCrmSyncStatus: build.query<ICrmSyncStatus, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/sync/status',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmSync'],
        }),

        runCrmSync: build.mutation<ICrmSyncRun, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/sync/run',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmSync', 'Crm', 'CrmActivities'],
        }),

        // ------------------------------------------------------- Platform Mail

        getMailThreads: build.query<{ threads: IMailThreadSummary[]; total: number }, {
            jwtToken: string;
            assignee?: 'me' | 'unassigned' | 'follow-up' | 'archived' | 'all';
            limit?: number;
            offset?: number;
            q?: string;
        }>({
            query: ({ jwtToken, ...params }) => ({
                url: '/admin/mail/threads',
                params,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Mail'],
        }),

        getMailThread: build.query<IMailThread, { jwtToken: string; threadKey: string }>({
            query: ({ jwtToken, threadKey }) => ({
                url: `/admin/mail/threads/${encodeURIComponent(threadKey)}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Mail'],
        }),

        markMailThreadRead: build.mutation<{ threadKey: string }, { jwtToken: string; threadKey: string }>({
            query: ({ jwtToken, threadKey }) => ({
                url: `/admin/mail/threads/${encodeURIComponent(threadKey)}/read`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Mail'],
        }),

        setMailFollowUp: build.mutation<{ threadKey: string; followUp: boolean }, {
            jwtToken: string;
            threadKey: string;
            followUp: boolean;
        }>({
            query: ({ jwtToken, threadKey, followUp }) => ({
                url: `/admin/mail/threads/${encodeURIComponent(threadKey)}/follow-up`,
                method: 'PATCH',
                body: { followUp },
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Mail'],
        }),

        setMailArchived: build.mutation<{ threadKey: string; archived: boolean }, {
            jwtToken: string;
            threadKey: string;
            archived: boolean;
        }>({
            query: ({ jwtToken, threadKey, archived }) => ({
                url: `/admin/mail/threads/${encodeURIComponent(threadKey)}/archive`,
                method: 'PATCH',
                body: { archived },
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Mail'],
        }),

        markAllMailRead: build.mutation<{ markedAt: string }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/mail/read-all',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Mail'],
        }),

        searchMailRecipients: build.query<IMailRecipient[], { jwtToken: string; q: string }>({
            query: ({ jwtToken, q }) => ({
                url: '/admin/mail/recipients',
                params: { q },
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        getMailSyncStatus: build.query<IMailSyncStatus, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/mail/sync/status',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Mail'],
        }),

        runMailSync: build.mutation<ICrmInboxSyncResult, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/mail/sync',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            // CrmInbox too: the same sync feeds the CRM inbox tab and timelines.
            invalidatesTags: ['Mail', 'CrmInbox', 'CrmActivities'],
        }),

        getMailSenders: build.query<IMailSender[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/mail/senders',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        sendMail: build.mutation<{ id: string; threadKey: string; messageId: string }, {
            jwtToken: string;
            senderUserId: number;
            to: string[];
            cc?: string[];
            subject: string;
            bodyHtml: string;
            attachmentIds?: string[];
            inReplyTo?: string;
            references?: string;
            crmCompanyId?: number;
        }>({
            query: ({ jwtToken, ...body }) => ({
                url: '/admin/mail/send',
                method: 'POST',
                body,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            // CrmActivities too: a reply on an account thread lands on its timeline.
            invalidatesTags: ['Mail', 'CrmActivities'],
        }),

        uploadMailAttachment: build.mutation<IMailStagedAttachment, { jwtToken: string; file: File }>({
            query: ({ jwtToken, file }) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: '/admin/mail/attachments',
                    method: 'POST',
                    body: formData,
                    headers: { Authorization: `Bearer ${jwtToken}` },
                };
            },
        }),

        assignMailThread: build.mutation<{ threadKey: string; updated: number }, {
            jwtToken: string;
            threadKey: string;
            userId: number | null;
        }>({
            query: ({ jwtToken, threadKey, userId }) => ({
                url: `/admin/mail/threads/${encodeURIComponent(threadKey)}/assign`,
                method: 'PATCH',
                body: { userId },
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Mail'],
        }),

        backfillMailAssignments: build.mutation<{ scanned: number; assigned: number; unassigned: number }, {
            jwtToken: string;
            limit?: number;
        }>({
            query: ({ jwtToken, limit }) => ({
                url: '/admin/mail/backfill-assignments',
                method: 'POST',
                body: { limit },
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Mail'],
        }),

        runCrmPostHog: build.mutation<{ refreshed: number }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/posthog/run',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm'],
        }),

        getCrmReports: build.query<ICrmReports, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/reports',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['Crm'],
        }),

        getCrmEmailTemplates: build.query<{
            id: number;
            code: string;
            name: string;
            subjectTemplate: string;
            bodyTextTemplate: string;
            bodyHtmlTemplate: string;
        }[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/email-templates',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmEmailTemplates'],
        }),

        createCrmEmailTemplate: build.mutation<{
            id: number;
            code: string;
            name: string;
            subjectTemplate: string;
            bodyTextTemplate: string;
            bodyHtmlTemplate: string;
        }, {
            jwtToken: string;
            payload: { name: string; subjectTemplate: string; bodyHtmlTemplate: string };
        }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/crm/email-templates',
                method: 'POST',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmEmailTemplates'],
        }),

        updateCrmEmailTemplate: build.mutation<{
            id: number;
            code: string;
            name: string;
            subjectTemplate: string;
            bodyTextTemplate: string;
            bodyHtmlTemplate: string;
        }, {
            jwtToken: string;
            id: number;
            payload: { name: string; subjectTemplate: string; bodyHtmlTemplate: string };
        }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/crm/email-templates/${id}`,
                method: 'PATCH',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmEmailTemplates'],
        }),

        deleteCrmEmailTemplate: build.mutation<{ id: number }, {
            jwtToken: string;
            id: number;
        }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/crm/email-templates/${id}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmEmailTemplates'],
        }),

        getOrganizationActivity: build.query<{
            enabled: boolean;
            events: {
                timestamp: string;
                event: string;
                path: string | null;
                elementText: string | null;
                userEmail: string | null;
                source: 'posthog' | 'platform';
                detail?: string | null;
            }[];
        }, { jwtToken: string; organisationId: number; days?: number }>({
            query: ({ jwtToken, organisationId, days }) => ({
                url: `/admin/organizations/${organisationId}/activity${days ? `?days=${days}` : ''}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        getLiveAnalytics: build.query<ILiveAnalyticsSnapshot, { jwtToken: string; minutes?: number }>({
            query: ({ jwtToken, minutes }) => ({
                url: `/admin/live-analytics${minutes ? `?minutes=${minutes}` : ''}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        logCrmReceivedEmail: build.mutation<{ activityId: number }, {
            jwtToken: string;
            companyId: number;
            payload: { subject: string; body: string; receivedAt?: string; fromEmail?: string; crmContactId?: number };
        }>({
            query: ({ jwtToken, companyId, payload }) => ({
                url: `/admin/crm/companies/${companyId}/email-received`,
                method: 'POST',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmActivities', 'Crm'],
        }),

        getCrmEmailSenders: build.query<{
            userId: number;
            name: string;
            firstName: string;
            email: string;
            fromLabel: string;
            address: string;
            usesOwnAddress: boolean;
        }[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/email-senders',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        sendCrmEmail: build.mutation<{ sesMessageId: string; to: string; from: string }, {
            jwtToken: string;
            companyId: number;
            payload: { crmContactId?: number; to?: string | string[]; cc?: string[]; subject: string; body: string; sendAsUserId?: number; branded?: boolean; allowUnfilledPlaceholders?: boolean; attachmentIds?: string[] };
        }>({
            query: ({ jwtToken, companyId, payload }) => ({
                url: `/admin/crm/companies/${companyId}/email`,
                method: 'POST',
                body: payload,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmActivities', 'Crm'],
        }),

        // ------------------------------------------- CRM inbound email (SYR-92)

        getCrmInbox: build.query<ICrmInboundEmail[], { jwtToken: string; status?: string }>({
            query: ({ jwtToken, status }) => ({
                url: '/admin/crm/inbox',
                params: status ? { status } : undefined,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmInbox'],
        }),

        getCrmInboundEmail: build.query<ICrmInboundEmail, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/crm/inbox/${id}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['CrmInbox'],
        }),

        runCrmInboxSync: build.mutation<ICrmInboxSyncResult, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/inbox/sync',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmInbox', 'Crm', 'CrmActivities'],
        }),

        assignCrmInboundEmail: build.mutation<ICrmInboundEmail, { jwtToken: string; id: number; companyId: number }>({
            query: ({ jwtToken, id, companyId }) => ({
                url: `/admin/crm/inbox/${id}/assign`,
                method: 'POST',
                body: { companyId },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmInbox', 'CrmActivities'],
        }),

        ignoreCrmInboundEmail: build.mutation<ICrmInboundEmail, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/crm/inbox/${id}/ignore`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CrmInbox', 'CrmActivities'],
        }),

        uploadCrmEmailImage: build.mutation<{ url: string }, { jwtToken: string; file: File }>({
            query: ({ jwtToken, file }) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: '/admin/crm/email-images',
                    method: 'POST',
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                };
            },
        }),

        getCrmInboundAttachmentUrl: build.query<{ url: string; filename: string }, { jwtToken: string; id: number; index: number }>({
            query: ({ jwtToken, id, index }) => ({
                url: `/admin/crm/inbox/${id}/attachments/${index}/url`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        // Signed link for a file that went out with a CRM email (staged via
        // uploadMailAttachment, so the key is the staged id).
        getCrmSentAttachmentUrl: build.query<{ url: string }, { jwtToken: string; key: string }>({
            query: ({ jwtToken, key }) => ({
                url: `/admin/crm/email-attachments/url`,
                params: { key },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        runCrmHealth: build.mutation<{ scored: number; signals: number }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/health/run',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm', 'CrmActivities'],
        }),

        runCrmLinking: build.mutation<{ created: number; linked: number; lifecyclesRefreshed: number }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/crm/linking/run',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['Crm'],
        }),

        getCrmFunnel: build.query<ICrmFunnelResponse, { jwtToken: string; since?: string }>({
            query: ({ jwtToken, since }) => ({
                url: `/admin/crm/funnel${since ? `?since=${encodeURIComponent(since)}` : ''}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['Crm', 'Admin'],
        }),

        // ============================================
        // Support Tickets Endpoints
        // ============================================

        // Admin: Get all tickets in organization
        getAdminTickets: build.query<{
            tickets: ITicket[];
            total: number;
        }, { jwtToken: string; params?: ITicketQueryDto }>({
            query: ({ jwtToken, params }) => ({
                url: '/admin/tickets',
                params,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: [EntityTag.ADMIN_TICKETS],
        }),

        // Admin: Get ticket statistics
        getAdminTicketStats: build.query<ITicketStatsResponse, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/tickets/stats',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: [EntityTag.ADMIN_TICKET_STATS],
        }),

        // Admin: Get single ticket with all details
        getAdminTicket: build.query<ITicket, { jwtToken: string; hash: string }>({
            query: ({ jwtToken, hash }) => ({
                url: `/admin/tickets/${hash}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: (_result, _error, arg) => [
                { type: EntityTag.ADMIN_TICKETS as const, id: arg.hash },
            ],
        }),

        // Admin: Update ticket
        updateTicket: build.mutation<ITicket, {
            jwtToken: string;
            hash: string;
            data: IUpdateTicketDto;
        }>({
            query: ({ jwtToken, hash, data }) => ({
                url: `/admin/tickets/${hash}`,
                method: 'PATCH',
                body: data,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.ADMIN_TICKETS, EntityTag.ADMIN_TICKET_STATS],
        }),

        // Admin: Add comment to ticket
        addAdminTicketComment: build.mutation<ITicketComment, {
            jwtToken: string;
            hash: string;
            data: ICreateCommentDto;
        }>({
            query: ({ jwtToken, hash, data }) => ({
                url: `/admin/tickets/${hash}/comments`,
                method: 'POST',
                body: data,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: (_result, _error, arg) => [
                { type: EntityTag.ADMIN_TICKETS as const, id: arg.hash },
            ],
        }),

        // Admin: Upload attachment
        uploadAdminTicketAttachment: build.mutation<ITicketAttachment, {
            jwtToken: string;
            hash: string;
            file: File;
        }>({
            query: ({ jwtToken, hash, file }) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: `/admin/tickets/${hash}/attachments`,
                    method: 'POST',
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                };
            },
            invalidatesTags: (_result, _error, arg) => [
                { type: EntityTag.ADMIN_TICKETS as const, id: arg.hash },
            ],
        }),

        // Admin: Delete attachment
        deleteAdminTicketAttachment: build.mutation<{ message: string }, {
            jwtToken: string;
            ticketHash: string;
            attachmentHash: string;
        }>({
            query: ({ jwtToken, ticketHash, attachmentHash }) => ({
                url: `/admin/tickets/${ticketHash}/attachments/${attachmentHash}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: (_result, _error, arg) => [
                { type: EntityTag.ADMIN_TICKETS as const, id: arg.ticketHash },
            ],
        }),

        // Customer: Get my tickets
        getMyTickets: build.query<{
            tickets: ITicket[];
            total: number;
        }, { jwtToken: string; params?: ITicketQueryDto }>({
            query: ({ jwtToken, params }) => ({
                url: '/tickets',
                params,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: [EntityTag.TICKETS],
        }),

        // Customer: Get single ticket
        getTicket: build.query<ITicket, { jwtToken: string; hash: string }>({
            query: ({ jwtToken, hash }) => ({
                url: `/tickets/${hash}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: (_result, _error, arg) => [
                { type: EntityTag.TICKETS as const, id: arg.hash },
            ],
        }),

        // Customer: Create ticket
        createTicket: build.mutation<ITicket, {
            jwtToken: string;
            data: ICreateTicketDto;
        }>({
            query: ({ jwtToken, data }) => ({
                url: '/tickets',
                method: 'POST',
                body: data,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: [EntityTag.TICKETS],
        }),

        // Customer: Add comment to ticket
        addTicketComment: build.mutation<ITicketComment, {
            jwtToken: string;
            hash: string;
            data: ICreateCommentDto;
        }>({
            query: ({ jwtToken, hash, data }) => ({
                url: `/tickets/${hash}/comments`,
                method: 'POST',
                body: data,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: (_result, _error, arg) => [
                { type: EntityTag.TICKETS as const, id: arg.hash },
            ],
        }),

        // Customer: Upload attachment
        uploadTicketAttachment: build.mutation<ITicketAttachment, {
            jwtToken: string;
            hash: string;
            file: File;
        }>({
            query: ({ jwtToken, hash, file }) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: `/tickets/${hash}/attachments`,
                    method: 'POST',
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                };
            },
            invalidatesTags: (_result, _error, arg) => [
                { type: EntityTag.TICKETS as const, id: arg.hash },
            ],
        }),

        // Get ticket categories
        getTicketCategories: build.query<ITicketCategory[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/tickets/categories/list',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: [EntityTag.TICKET_CATEGORIES],
        }),

        // ===== LEGAL DOCUMENTS =====

        // Get current privacy policy (public)
        getPrivacyPolicy: build.query<{
            available: boolean;
            version?: string;
            title?: string;
            content?: string;
            effectiveDate?: string;
        }, void>({
            query: () => '/legal/privacy-policy',
            providesTags: ['LegalDocuments'],
        }),

        // Get current terms of service (public)
        getTermsOfService: build.query<{
            available: boolean;
            version?: string;
            title?: string;
            content?: string;
            effectiveDate?: string;
        }, void>({
            query: () => '/legal/terms-of-service',
            providesTags: ['LegalDocuments'],
        }),

        // Get all current legal documents (public)
        getCurrentLegalDocuments: build.query<Array<{
            id: number;
            documentType: string;
            version: string;
            title: string;
            effectiveDate: string;
        }>, void>({
            query: () => '/legal/documents/current',
            providesTags: ['LegalDocuments'],
        }),

        // Get public signup configuration (public)
        getSignupConfig: build.query<{
            publicSignupEnabled: boolean;
            legalAcceptanceEnabled: boolean;
            cookieConsentEnabled: boolean;
            charterCohortEnabled: boolean;
            // SYR-109 pricing flags. Optional so an older API keeps today's
            // rendered position (Free on offer, trial on offer).
            freeTierSignupEnabled?: boolean;
            freeTrialEnabled?: boolean;
        }, void>({
            query: () => '/public/config/signup',
        }),

        // Public: QUALIFICATION_CONFIG for the signup quiz (Mode A)
        getQualificationConfig: build.query<IQualificationConfig | null, void>({
            query: () => '/auth/qualification-config',
        }),

        // Get public survey configuration
        getSurveyConfig: build.query<{
            fixedStatementsPerResponse: number;
        }, void>({
            query: () => '/public/config/survey',
        }),

        // Get dashboard experience configuration (public) — SYR-79.
        // When marketerViewDefault is true, org users land on the Marketer View
        // shell at /dashboard and the classic dashboard moves to /old-dashboard.
        getDashboardConfig: build.query<{
            marketerViewDefault: boolean;
            apiAccessEnabled: boolean;
        }, void>({
            query: () => '/public/config/dashboard',
        }),

        // Charter Cohort (SYR-106) — public application flow
        getCharterConfig: build.query<ICharterPageConfig, void>({
            query: () => '/public/config/charter',
        }),

        submitCharterApplication: build.mutation<{ received: true }, { payload: ISubmitCharterApplication }>({
            query: (params) => ({
                url: '/charter/applications',
                method: 'POST',
                body: params.payload,
            }),
        }),

        // Proves an emailed waitlist invite is genuine, so it can bypass the
        // Charter redirect while the intake is open.
        verifyWaitlistInvite: build.query<{ valid: boolean; email: string; templateType: string }, { token: string }>({
            query: (params) => `/waitlist/invite/verify?token=${encodeURIComponent(params.token)}`,
        }),

        // Charter Cohort (SYR-106) — admin review
        getCharterApplications: build.query<ICharterApplication[], { jwtToken: string; status?: string }>({
            query: (params) => {
                const searchParams = new URLSearchParams();
                if (params.status) searchParams.set('status', params.status);
                const qs = searchParams.toString();
                return {
                    url: `/admin/charter/applications${qs ? `?${qs}` : ''}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${params.jwtToken}` },
                };
            },
            providesTags: ['CharterApplications'],
        }),

        getCharterApplicationStats: build.query<ICharterApplicationStats, { jwtToken: string }>({
            query: (params) => ({
                url: '/admin/charter/applications/stats',
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['CharterApplications'],
        }),

        reviewCharterApplication: build.mutation<ICharterApplication, {
            jwtToken: string;
            id: number;
            action: 'accept' | 'hold' | 'unsupported' | 'unreview';
            reviewNotes?: string;
        }>({
            query: (params) => ({
                url: `/admin/charter/applications/${params.id}/${params.action}`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
                body: { reviewNotes: params.reviewNotes },
            }),
            invalidatesTags: ['CharterApplications'],
        }),

        // Public Hypothesis lead generator (SYR-107) — the visitor-facing flow.
        //
        // None of these ever return 401: the API answers 200 with a `state`
        // for every failure, precisely so baseQueryWithAuth's "Session
        // Expired" modal can never fire at someone who has no account. See
        // the isAuthEndpoint exclusion above.
        getPublicHypothesisConfig: build.query<IPublicHypothesisConfig, void>({
            query: () => '/public/config/hypothesis',
        }),

        requestPublicHypothesis: build.mutation<IPublicHypothesisRequestResult, {
            url: string;
            email: string;
            companyWebsite?: string;
            // Campaign attribution handed over by the hosting marketing page.
            attribution?: Record<string, string | undefined>;
        }>({
            query: (params) => ({
                url: '/public/hypothesis/request',
                method: 'POST',
                body: params,
            }),
        }),

        resendPublicHypothesisPin: build.mutation<IPublicHypothesisRequestResult, { email: string }>({
            query: (params) => ({
                url: '/public/hypothesis/resend',
                method: 'POST',
                body: params,
            }),
        }),

        verifyPublicHypothesisPin: build.mutation<IPublicHypothesisVerifyResult, {
            email: string;
            pin: string;
        }>({
            query: (params) => ({
                url: '/public/hypothesis/verify',
                method: 'POST',
                body: params,
            }),
        }),

        getPublicHypothesisStatus: build.query<IPublicHypothesisStatus, { token: string }>({
            query: (params) => `/public/hypothesis/status?token=${encodeURIComponent(params.token)}`,
        }),

        getPublicHypothesisResult: build.query<IPublicHypothesisResult, { token: string }>({
            query: (params) => `/public/hypothesis/result?token=${encodeURIComponent(params.token)}`,
        }),

        // Fired just before the browser leaves for the Charter page. The single
        // success metric is a Charter application attributable to a run, and
        // this is the last moment the two halves can be joined.
        recordPublicHypothesisCta: build.mutation<{ ok: boolean }, { token: string }>({
            query: (params) => ({
                url: '/public/hypothesis/cta',
                method: 'POST',
                body: { token: params.token },
            }),
        }),

        // Which element explainers get played. The clearest signal available
        // about which elements readers do not already understand.
        recordPublicHypothesisVideo: build.mutation<{ ok: boolean }, {
            token: string; videoId: string; element: string;
        }>({
            query: (params) => ({
                url: '/public/hypothesis/video',
                method: 'POST',
                body: params,
            }),
        }),

        unsubscribePublicHypothesis: build.query<{ ok: boolean }, { token: string }>({
            query: (params) => `/public/hypothesis/unsubscribe?token=${encodeURIComponent(params.token)}`,
        }),

        // Public Hypothesis lead generator (SYR-107) — admin queue.
        //
        // These live under /admin/public-hypothesis, which is why the API's
        // throttler bucket for the visitor-facing routes is guarded by
        // !path.includes('/admin/'). A bare prefix match once put the Charter
        // review screen into the public 5-per-hour bucket.
        // Server-side paginated: at the daily cap this table passes 300 rows
        // within a fortnight, and a client-side page over a capped fetch hides
        // the overflow without ever saying so.
        getHypothesisLeads: build.query<IHypothesisLeadPage, {
            jwtToken: string; status?: string; page?: number; limit?: number;
        }>({
            query: (params) => {
                const searchParams = new URLSearchParams();
                if (params.status) searchParams.set('status', params.status);
                searchParams.set('page', String(params.page ?? 1));
                searchParams.set('limit', String(params.limit ?? 25));
                return {
                    url: `/admin/public-hypothesis/leads?${searchParams.toString()}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${params.jwtToken}` },
                };
            },
            providesTags: ['HypothesisLeads'],
        }),

        getHypothesisLeadStats: build.query<Record<string, number>, { jwtToken: string }>({
            query: (params) => ({
                url: '/admin/public-hypothesis/leads/stats',
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['HypothesisLeads'],
        }),

        /**
         * Hard delete, as opposed to the `dismiss` action above which keeps the
         * row and its attribution. For entries that should never have counted.
         */
        deleteHypothesisLead: build.mutation<{ deleted: boolean }, {
            jwtToken: string;
            id: number;
        }>({
            query: (params) => ({
                url: `/admin/public-hypothesis/leads/${params.id}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['HypothesisLeads'],
        }),

        reviewHypothesisLead: build.mutation<IHypothesisLead, {
            jwtToken: string;
            id: number;
            action: 'approve' | 'dismiss' | 'to-crm';
            notes?: string;
            // approve only: re-run without re-sending the result email.
            silent?: boolean;
        }>({
            query: (params) => ({
                url: `/admin/public-hypothesis/leads/${params.id}/${params.action}`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
                body: { notes: params.notes, silent: params.silent },
            }),
            invalidatesTags: ['HypothesisLeads'],
        }),

        // Reissues the magic link the customer was emailed. A mutation rather
        // than a query because it mints a token and writes an event server
        // side, and because a cached copy of a link with an expiry is a trap.
        getHypothesisLeadResultLink: build.mutation<{ url: string; expiresInDays: number }, {
            jwtToken: string;
            id: number;
        }>({
            query: (params) => ({
                url: `/admin/public-hypothesis/leads/${params.id}/result-link`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        // Review pages an admin found by hand. Stored on the SUBJECT, because
        // that is what research reads, and one subject can serve many leads.
        // The read-out exactly as the magic link renders it. Same server-side
        // builder as the public endpoint, so a preview cannot drift from the
        // page it is previewing.
        getHypothesisResultPreview: build.query<IPublicHypothesisResult, {
            jwtToken: string;
            subjectId: number;
        }>({
            query: (params) => ({
                url: `/admin/public-hypothesis/result-preview/${params.subjectId}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
        }),

        // Re-form the hypothesis from stored research: no crawl, no review
        // provider, no re-synthesis. The loop for improving the prompt, since
        // holding the evidence constant is what makes a changed read-out
        // attributable to the prompt rather than to a different crawl.
        //
        // Inherently quiet — it never clears resultEmailSentAt, so the
        // delivery sweep skips a lead that has already been emailed and the
        // magic link they hold renders the new read-out.
        reformHypothesisSubject: build.mutation<unknown, {
            jwtToken: string;
            subjectId: number;
        }>({
            query: (params) => ({
                url: `/admin/ai/hypothesis/subjects/${params.subjectId}/trigger`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
                body: { mode: 'reform' },
            }),
            invalidatesTags: ['HypothesisLeads'],
        }),

        // Finish a run parked at AWAITING_REVIEWS with the sources an admin
        // just supplied. One synthesis, not a re-crawl: the site, listings and
        // competitors come from the job's stored snapshot.
        continueHypothesisWithReviews: build.mutation<
            { resumed: boolean; reason?: string; sourcesFound?: number },
            { jwtToken: string; subjectId: number }
        >({
            query: (params) => ({
                url: `/admin/ai/hypothesis/subjects/${params.subjectId}/continue`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['HypothesisLeads'],
        }),

        // SYR-107 — the research record behind a lead: the synthesised prose,
        // the evidence that produced it, and the hypothesis it formed. Read
        // inline in the lead queue, so an admin can judge a read-out against
        // what was actually collected without opening the AI Hub.
        getHypothesisSubjectDetail: build.query<IHypothesisSubjectDetail, {
            jwtToken: string;
            subjectId: number;
        }>({
            query: (params) => ({
                url: `/admin/ai/hypothesis/subjects/${params.subjectId}/detail`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['HypothesisLeads'],
        }),

        getHypothesisReviewSources: build.query<{
            urls: string[];
            pasted: Array<{ label: string; text: string }>;
        }, { jwtToken: string; subjectId: number }>({
            query: (params) => ({
                url: `/admin/ai/hypothesis/subjects/${params.subjectId}/review-sources`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['HypothesisLeads'],
        }),

        setHypothesisReviewSources: build.mutation<unknown, {
            jwtToken: string;
            subjectId: number;
            urls: string[];
            // Page text for platforms we cannot fetch — Trustpilot 403s any
            // non-browser request, so this is the only way its reviews arrive.
            pasted?: Array<{ label: string; text: string }>;
        }>({
            query: (params) => ({
                url: `/admin/ai/hypothesis/subjects/${params.subjectId}/review-sources`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
                body: { urls: params.urls, pasted: params.pasted ?? [] },
            }),
            invalidatesTags: ['HypothesisLeads'],
        }),

        getHypothesisDomainPolicies: build.query<IHypothesisDomainPolicy[], { jwtToken: string }>({
            query: (params) => ({
                url: '/admin/public-hypothesis/domain-policies',
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['HypothesisDomainPolicies'],
        }),

        // Upsert: the domain is the key, so re-adding one means "set it to
        // this", never a duplicate error.
        saveHypothesisDomainPolicy: build.mutation<IHypothesisDomainPolicy, {
            jwtToken: string;
            domain: string;
            policy: 'auto' | 'manual' | 'blocked';
            note?: string;
        }>({
            query: (params) => ({
                url: '/admin/public-hypothesis/domain-policies',
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
                body: { domain: params.domain, policy: params.policy, note: params.note },
            }),
            invalidatesTags: ['HypothesisDomainPolicies'],
        }),

        deleteHypothesisDomainPolicy: build.mutation<{ deleted: boolean }, { jwtToken: string; id: number }>({
            query: (params) => ({
                url: `/admin/public-hypothesis/domain-policies/${params.id}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['HypothesisDomainPolicies'],
        }),

        // Join waitlist (public)
        joinWaitlist: build.mutation<IWaitlistEntry, { payload: ICreateWaitlistEntry }>({
            query: (params) => ({
                url: '/waitlist',
                method: 'POST',
                body: params.payload,
            }),
        }),

        // Admin waitlist endpoints
        getWaitlistEntries: build.query<IWaitlistEntry[], { jwtToken: string; status?: string }>({
            query: (params) => {
                const searchParams = new URLSearchParams();
                if (params.status) searchParams.set('status', params.status);
                const qs = searchParams.toString();
                return {
                    url: `/waitlist${qs ? `?${qs}` : ''}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${params.jwtToken}` },
                };
            },
            providesTags: ['Admin'],
        }),

        getWaitlistStats: build.query<IWaitlistStats[], { jwtToken: string }>({
            query: (params) => ({
                url: '/waitlist/stats',
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['Admin'],
        }),

        updateWaitlistEntryStatus: build.mutation<IWaitlistEntry, { jwtToken: string; id: string; status: string }>({
            query: (params) => ({
                url: `/waitlist/${params.id}/status`,
                method: 'PATCH',
                body: { status: params.status },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Admin'],
        }),

        updateWaitlistEntry: build.mutation<IWaitlistEntry, { jwtToken: string; id: string; productType?: string | null; templateType?: string | null }>({
            query: (params) => ({
                url: `/waitlist/${params.id}`,
                method: 'PATCH',
                body: { productType: params.productType, templateType: params.templateType },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Admin'],
        }),

        inviteWaitlistEntry: build.mutation<IWaitlistEntry, { jwtToken: string; id: string }>({
            query: (params) => ({
                url: `/waitlist/${params.id}/invite`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Admin'],
        }),

        // Get password-set configuration for a specific reset token (public)
        getPasswordSetConfig: build.query<{
            legalAcceptanceEnabled: boolean;
            userHasAccepted: boolean;
        }, { token: string }>({
            query: (params) => `/auth/password-set-config/${params.token}`,
        }),

        // Get user's acceptance status (authenticated)
        getLegalAcceptanceStatus: build.query<{
            enabled: boolean;
            allAccepted: boolean;
            pendingDocuments: string[];
            acceptedDocuments: Array<{
                documentType: string;
                version: string;
                acceptedAt: string;
            }>;
        }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/legal/acceptance/status',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['LegalAcceptance'],
        }),

        // Accept a legal document (authenticated)
        acceptLegalDocument: build.mutation<{ success: boolean; acceptedAt: string }, {
            jwtToken: string;
            documentType: string;
            acceptanceMethod?: string;
        }>({
            query: ({ jwtToken, documentType, acceptanceMethod }) => ({
                url: '/legal/accept',
                method: 'POST',
                body: { documentType, acceptanceMethod },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['LegalAcceptance'],
        }),

        // Accept multiple legal documents (authenticated)
        acceptMultipleLegalDocuments: build.mutation<{
            success: boolean;
            accepted: Array<{ documentId: number; acceptedAt: string }>;
        }, {
            jwtToken: string;
            documentTypes: string[];
            acceptanceMethod?: string;
        }>({
            query: ({ jwtToken, documentTypes, acceptanceMethod }) => ({
                url: '/legal/accept/multiple',
                method: 'POST',
                body: { documentTypes, acceptanceMethod },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['LegalAcceptance'],
        }),

        // Get user's acceptance history (authenticated)
        getLegalAcceptanceHistory: build.query<Array<{
            id: number;
            documentType: string;
            documentVersion: string;
            documentTitle: string;
            acceptedAt: string;
            acceptanceMethod: string;
        }>, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/legal/acceptance/history',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['LegalAcceptance'],
        }),

        // ===== COOKIE CONSENT =====

        // Get cookie consent status (public - works for both authenticated and anonymous)
        getCookieConsent: build.query<{
            hasConsent: boolean;
            analyticsConsent: boolean;
            marketingConsent: boolean;
            consentGivenAt?: string;
        }, { sessionId?: string; jwtToken?: string }>({
            query: ({ sessionId, jwtToken }) => ({
                url: `/cookie-consent${sessionId ? `?sessionId=${sessionId}` : ''}`,
                headers: jwtToken ? {
                    Authorization: `Bearer ${jwtToken}`,
                } : {},
            }),
            providesTags: ['CookieConsent'],
        }),

        // Save cookie consent (public - works for both authenticated and anonymous)
        saveCookieConsent: build.mutation<{
            success: boolean;
            analyticsConsent: boolean;
            marketingConsent: boolean;
            consentGivenAt: string;
        }, {
            analyticsConsent: boolean;
            marketingConsent: boolean;
            sessionId?: string;
            jwtToken?: string;
        }>({
            query: ({ analyticsConsent, marketingConsent, sessionId, jwtToken }) => ({
                url: '/cookie-consent',
                method: 'POST',
                body: { analyticsConsent, marketingConsent, sessionId },
                headers: jwtToken ? {
                    Authorization: `Bearer ${jwtToken}`,
                } : {},
            }),
            invalidatesTags: ['CookieConsent'],
        }),

        // Link anonymous session consent to user after login
        linkCookieConsentSession: build.mutation<{
            success: boolean;
            analyticsConsent?: boolean;
            marketingConsent?: boolean;
            message?: string;
        }, { sessionId: string; jwtToken: string }>({
            query: ({ sessionId, jwtToken }) => ({
                url: '/cookie-consent/link-session',
                method: 'POST',
                body: { sessionId },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['CookieConsent'],
        }),

        // ===== ADMIN LEGAL DOCUMENTS =====

        // Get all legal document versions (admin)
        getAdminLegalDocuments: build.query<{
            privacyPolicy: Array<{
                id: number;
                documentType: string;
                version: string;
                title: string;
                content: string;
                summary: string | null;
                isCurrent: boolean;
                effectiveDate: string;
                createdAt: string;
                createdBy?: { id: number; email: string; firstName: string; lastName: string };
            }>;
            termsOfService: Array<{
                id: number;
                documentType: string;
                version: string;
                title: string;
                content: string;
                summary: string | null;
                isCurrent: boolean;
                effectiveDate: string;
                createdAt: string;
                createdBy?: { id: number; email: string; firstName: string; lastName: string };
            }>;
        }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/legal/admin/documents',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: ['AdminLegalDocuments'],
        }),

        // Get a specific legal document by ID (admin)
        getAdminLegalDocument: build.query<{
            id: number;
            documentType: string;
            version: string;
            title: string;
            content: string;
            summary: string | null;
            isCurrent: boolean;
            effectiveDate: string;
            createdAt: string;
            createdBy?: { id: number; email: string; firstName: string; lastName: string };
        }, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/legal/admin/documents/${id}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            providesTags: (_result, _error, arg) => [{ type: 'AdminLegalDocuments', id: arg.id }],
        }),

        // Create a new legal document version (admin)
        createLegalDocument: build.mutation<{
            id: number;
            documentType: string;
            version: string;
            title: string;
            isCurrent: boolean;
        }, {
            jwtToken: string;
            documentType: string;
            version: string;
            title: string;
            content: string;
            summary?: string;
            effectiveDate: string;
            activateImmediately?: boolean;
        }>({
            query: ({ jwtToken, ...body }) => ({
                url: '/legal/admin/documents',
                method: 'POST',
                body,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminLegalDocuments', 'LegalDocuments'],
        }),

        // Activate a legal document version (admin)
        activateLegalDocument: build.mutation<{
            id: number;
            documentType: string;
            version: string;
            isCurrent: boolean;
        }, {
            jwtToken: string;
            id: number;
            requireReAcceptance?: boolean;
        }>({
            query: ({ jwtToken, id, requireReAcceptance }) => ({
                url: `/legal/admin/documents/${id}/activate`,
                method: 'PATCH',
                body: { requireReAcceptance },
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
            invalidatesTags: ['AdminLegalDocuments', 'LegalDocuments', 'LegalAcceptance'],
        }),

        // Get acceptance statistics for a document (admin)
        getLegalDocumentStats: build.query<{
            totalAcceptances: number;
            acceptancesByMethod: {
                signup: number;
                login_prompt: number;
                settings: number;
                api: number;
            };
        }, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/legal/admin/documents/${id}/stats`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        // ===== FINAL QUESTIONS =====

        // Get all final questions (admin with pagination)
        getAdminFinalQuestions: build.query<IFinalQuestionsListResponse, {
            jwtToken: string;
            page?: number;
            limit?: number;
            includeInactive?: boolean
        }>({
            query: ({ jwtToken, page = 1, limit = 10, includeInactive = false }) => ({
                url: `/admin/final-questions?${new URLSearchParams({
                    page: page.toString(),
                    limit: limit.toString(),
                    includeInactive: includeInactive.toString(),
                }).toString()}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        // Create final question (admin)
        createAdminFinalQuestion: build.mutation<IFinalQuestion, {
            jwtToken: string;
            payload: ICreateFinalQuestionDto
        }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/final-questions',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: payload,
            }),
        }),

        // Update final question (admin)
        updateAdminFinalQuestion: build.mutation<IFinalQuestion, {
            jwtToken: string;
            id: number;
            payload: IUpdateFinalQuestionDto
        }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/final-questions/${id}`,
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: payload,
            }),
        }),

        // Delete final question (admin - soft delete)
        deleteAdminFinalQuestion: build.mutation<{ success: boolean }, {
            jwtToken: string;
            id: number
        }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/final-questions/${id}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        // Bulk apply final question to all surveys without one
        bulkApplyFinalQuestion: build.mutation<IBulkApplyFinalQuestionResponse, {
            jwtToken: string;
            id: number
        }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/final-questions/${id}/apply-to-all`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        // Get active final questions (for survey creation dropdown)
        getActiveFinalQuestions: build.query<IActiveFinalQuestionsResponse, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/final-questions',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        // Get final question responses for a survey (analytics)
        getSurveyFinalResponses: build.query<IFinalResponsesListResponse, {
            jwtToken: string;
            orgId: number;
            surveyId: number;
            page?: number;
            limit?: number
        }>({
            query: ({ jwtToken, orgId, surveyId, page = 1, limit = 20 }) => ({
                url: `/organisations/${orgId}/surveys/${surveyId}/final-responses?${new URLSearchParams({
                    page: page.toString(),
                    limit: limit.toString(),
                }).toString()}`,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            }),
        }),

        // ===== Subscription Endpoints =====

        // Admin: Subscription Plans Management
        getAdminSubscriptionPlans: build.query<ISubscriptionPlan[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/subscription-plans',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['SubscriptionPlans'],
        }),

        createAdminSubscriptionPlan: build.mutation<ISubscriptionPlan, { jwtToken: string; payload: ICreateSubscriptionPlanDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/subscription-plans',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['SubscriptionPlans'],
        }),

        updateAdminSubscriptionPlan: build.mutation<ISubscriptionPlan, { jwtToken: string; id: string; payload: IUpdateSubscriptionPlanDto }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/subscription-plans/${id}`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['SubscriptionPlans'],
        }),

        deleteAdminSubscriptionPlan: build.mutation<void, { jwtToken: string; id: string }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/subscription-plans/${id}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['SubscriptionPlans'],
        }),

        // Admin: Stripe Sync for Subscription Plans
        syncPlanToStripe: build.mutation<IStripeSyncResult, { jwtToken: string; id: string }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/subscription-plans/${id}/sync-stripe`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['SubscriptionPlans'],
        }),

        syncAllPlansToStripe: build.mutation<IStripeBulkSyncResult, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/subscription-plans/sync-stripe/all',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['SubscriptionPlans'],
        }),

        retryFailedStripeSync: build.mutation<IStripeRetryResult, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/subscription-plans/sync-stripe/retry-failed',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['SubscriptionPlans'],
        }),

        // Admin: Addons Management
        getAdminAddons: build.query<IAddon[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/addons',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Addons'],
        }),

        createAdminAddon: build.mutation<IAddon, { jwtToken: string; payload: ICreateAddonDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/addons',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Addons'],
        }),

        updateAdminAddon: build.mutation<IAddon, { jwtToken: string; id: string; payload: IUpdateAddonDto }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/addons/${id}`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Addons'],
        }),

        deleteAdminAddon: build.mutation<void, { jwtToken: string; id: string }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/addons/${id}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Addons'],
        }),

        syncAddonToStripe: build.mutation<IStripeSyncResult, { jwtToken: string; id: string }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/addons/${id}/sync-stripe`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Addons'],
        }),

        syncAllAddonsToStripe: build.mutation<IStripeBulkSyncResult, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/addons/sync-stripe/all',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Addons'],
        }),

        // Admin: Reward Tiers Management
        getAdminRewardTiers: build.query<IRewardTier[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/rewards/tiers',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['RewardTiers'],
        }),

        getAdminRewardTier: build.query<IRewardTier, { jwtToken: string; id: string }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/rewards/tiers/${id}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['RewardTiers'],
        }),

        createAdminRewardTier: build.mutation<IRewardTier, { jwtToken: string; payload: ICreateRewardTierDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/rewards/tiers',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['RewardTiers'],
        }),

        updateAdminRewardTier: build.mutation<IRewardTier, { jwtToken: string; id: string; payload: IUpdateRewardTierDto }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/rewards/tiers/${id}`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['RewardTiers'],
        }),

        deleteAdminRewardTier: build.mutation<void, { jwtToken: string; id: string }>({
            query: ({ jwtToken, id }) => ({
                url: `/admin/rewards/tiers/${id}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['RewardTiers'],
        }),

        // Admin: Reward Earnings & Redemptions
        getAdminRewardEarnings: build.query<IRewardEarning[], { jwtToken: string; organisationId?: number; status?: RewardStatus }>({
            query: ({ jwtToken, organisationId, status }) => {
                const params = new URLSearchParams();
                if (organisationId) params.append('organisationId', organisationId.toString());
                if (status) params.append('status', status);
                const queryString = params.toString();
                return {
                    url: `/admin/rewards/earnings${queryString ? `?${queryString}` : ''}`,
                    headers: { Authorization: `Bearer ${jwtToken}` },
                };
            },
            providesTags: ['Rewards'],
        }),

        getAdminRewardRedemptions: build.query<IRewardRedemption[], { jwtToken: string; organisationId?: number }>({
            query: ({ jwtToken, organisationId }) => {
                const params = new URLSearchParams();
                if (organisationId) params.append('organisationId', organisationId.toString());
                const queryString = params.toString();
                return {
                    url: `/admin/rewards/redemptions${queryString ? `?${queryString}` : ''}`,
                    headers: { Authorization: `Bearer ${jwtToken}` },
                };
            },
            providesTags: ['Rewards'],
        }),

        getAdminRewardStats: build.query<IRewardStats, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/rewards/stats',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Rewards', 'RewardTiers'],
        }),

        grantAdminReward: build.mutation<IRewardEarning, { jwtToken: string; payload: IGrantRewardDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/rewards/grant',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Rewards'],
        }),

        // Organisation: Addon Purchasing
        getAvailableAddons: build.query<IAddon[], { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/addons/available`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['OrganisationAddons'],
        }),

        getPurchasedAddons: build.query<IOrganisationAddon[], { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/addons`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['OrganisationAddons'],
        }),

        getActiveAddons: build.query<IOrganisationAddon[], { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/addons/active`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['OrganisationAddons'],
        }),

        getAvailableCreditsForAddons: build.query<{ credits: IAvailableRewardCredit[]; totalCents: number }, { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/addons/credits`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        previewAddonPurchase: build.query<IAddonPurchasePreview, { jwtToken: string; orgId: number; addonId: string }>({
            query: ({ jwtToken, orgId, addonId }) => ({
                url: `/organisations/${orgId}/addons/${addonId}/preview`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        createAddonCheckout: build.mutation<ICheckoutResult, { jwtToken: string; orgId: number; addonId: string; applyCredits?: boolean }>({
            query: ({ jwtToken, orgId, addonId, applyCredits = true }) => ({
                url: `/organisations/${orgId}/addons/${addonId}/checkout`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: { applyCredits },
            }),
        }),

        // On-platform checkout with Payment Element
        createAddonPaymentIntent: build.mutation<IPaymentIntentResult, { jwtToken: string; orgId: number; addonId: string; applyCredits?: boolean; billingCountry?: string }>({
            query: ({ jwtToken, orgId, addonId, applyCredits = true, billingCountry }) => ({
                url: `/organisations/${orgId}/addons/${addonId}/payment-intent`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: { applyCredits, billingCountry },
            }),
        }),

        createAddonSubscription: build.mutation<IAddonSubscriptionResult, { jwtToken: string; orgId: number; addonId: string; paymentMethodId: string; applyCredits?: boolean }>({
            query: ({ jwtToken, orgId, addonId, paymentMethodId, applyCredits = true }) => ({
                url: `/organisations/${orgId}/addons/${addonId}/subscribe`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: { paymentMethodId, applyCredits },
            }),
        }),

        getAddonPaymentMethods: build.query<IAddonPaymentMethod[], { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/addons/payment-methods`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        confirmAddonPayment: build.mutation<{ success: boolean; organisationAddonId?: string; message: string }, { jwtToken: string; orgId: number; paymentIntentId: string }>({
            query: ({ jwtToken, orgId, paymentIntentId }) => ({
                url: `/organisations/${orgId}/addons/confirm-payment`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: { paymentIntentId },
            }),
            invalidatesTags: ['OrganisationAddons'],
        }),

        cancelOrganisationAddon: build.mutation<IOrganisationAddon, { jwtToken: string; orgId: number; organisationAddonId: string }>({
            query: ({ jwtToken, orgId, organisationAddonId }) => ({
                url: `/organisations/${orgId}/addons/${organisationAddonId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['OrganisationAddons'],
        }),

        checkHasAddon: build.query<{ hasAddon: boolean }, { jwtToken: string; orgId: number; addonCode: string }>({
            query: ({ jwtToken, orgId, addonCode }) => ({
                url: `/organisations/${orgId}/addons/has/${addonCode}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        // Admin: Features Management
        getAdminFeatures: build.query<IFeatureDefinition[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/features',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Features'],
        }),

        createAdminFeature: build.mutation<IFeatureDefinition, { jwtToken: string; payload: ICreateFeatureDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/admin/features',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Features'],
        }),

        updateAdminFeature: build.mutation<IFeatureDefinition, { jwtToken: string; id: string; payload: IUpdateFeatureDto }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/admin/features/${id}`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Features'],
        }),

        // Admin: Plan Entitlements Management
        getAdminPlanEntitlements: build.query<IPlanEntitlement[], { jwtToken: string; planId: string }>({
            query: ({ jwtToken, planId }) => ({
                url: `/admin/subscription-plans/${planId}/entitlements`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['PlanEntitlements'],
        }),

        createAdminPlanEntitlement: build.mutation<IPlanEntitlement, { jwtToken: string; planId: string; payload: { featureId: string; value: string } }>({
            query: ({ jwtToken, planId, payload }) => ({
                url: `/admin/subscription-plans/${planId}/entitlements`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['PlanEntitlements'],
        }),

        updateAdminPlanEntitlement: build.mutation<IPlanEntitlement, { jwtToken: string; planId: string; entitlementId: string; payload: { value: string } }>({
            query: ({ jwtToken, planId, entitlementId, payload }) => ({
                url: `/admin/subscription-plans/${planId}/entitlements/${entitlementId}`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['PlanEntitlements'],
        }),

        deleteAdminPlanEntitlement: build.mutation<{ success: boolean }, { jwtToken: string; planId: string; entitlementId: string }>({
            query: ({ jwtToken, planId, entitlementId }) => ({
                url: `/admin/subscription-plans/${planId}/entitlements/${entitlementId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['PlanEntitlements'],
        }),

        // Admin: Addon Entitlements Management
        getAdminAddonEntitlements: build.query<IAddonEntitlement[], { jwtToken: string; addonId: string }>({
            query: ({ jwtToken, addonId }) => ({
                url: `/admin/addons/${addonId}/entitlements`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['AddonEntitlements'],
        }),

        createAdminAddonEntitlement: build.mutation<IAddonEntitlement, { jwtToken: string; addonId: string; payload: ICreateAddonEntitlementDto }>({
            query: ({ jwtToken, addonId, payload }) => ({
                url: `/admin/addons/${addonId}/entitlements`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['AddonEntitlements'],
        }),

        updateAdminAddonEntitlement: build.mutation<IAddonEntitlement, { jwtToken: string; addonId: string; entitlementId: string; payload: { value?: string; valueType?: ValueType } }>({
            query: ({ jwtToken, addonId, entitlementId, payload }) => ({
                url: `/admin/addons/${addonId}/entitlements/${entitlementId}`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['AddonEntitlements'],
        }),

        deleteAdminAddonEntitlement: build.mutation<{ success: boolean }, { jwtToken: string; addonId: string; entitlementId: string }>({
            query: ({ jwtToken, addonId, entitlementId }) => ({
                url: `/admin/addons/${addonId}/entitlements/${entitlementId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['AddonEntitlements'],
        }),

        // Admin: Founding Cohort Management
        getAdminFoundingCohort: build.query<IFoundingCohortMember[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/admin/founding-cohort',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['FoundingCohort'],
        }),

        updateAdminFoundingCohortStatus: build.mutation<IFoundingCohortMember, { jwtToken: string; orgId: string; payload: IUpdateFoundingCohortStatusDto }>({
            query: ({ jwtToken, orgId, payload }) => ({
                url: `/admin/founding-cohort/${orgId}/status`,
                method: 'PATCH',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['FoundingCohort'],
        }),

        getAdminEligibleOrganisations: build.query<IEligibleOrganisation[], { jwtToken: string; includeMock?: boolean }>({
            query: ({ jwtToken, includeMock }) => ({
                url: `/admin/founding-cohort/eligible${includeMock ? '?includeMock=true' : ''}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['FoundingCohort'],
        }),

        bulkAddFoundingCohortMembers: build.mutation<IBulkAddFoundingCohortResult, { jwtToken: string; organisationIds: number[] }>({
            query: ({ jwtToken, organisationIds }) => ({
                url: '/admin/founding-cohort/bulk',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: { organisationIds },
            }),
            invalidatesTags: ['FoundingCohort'],
        }),

        // Admin: Change Organization Plan
        changeAdminOrganisationPlan: build.mutation<IOrganisationSubscription, { jwtToken: string; orgId: string; payload: { planId: string; graduateFromFoundingCohort?: boolean } }>({
            query: ({ jwtToken, orgId, payload }) => ({
                url: `/admin/organisations/${orgId}/subscription/change-plan`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['FoundingCohort'],
        }),

        // Admin: Start Free Trial for Organization
        startAdminFreeTrial: build.mutation<IOrganisationSubscription, { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/admin/organisations/${orgId}/subscription/start-trial`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Admin'],
        }),

        // Response volume by calendar month. Aggregate counts only — no
        // participant or answer data is returned by this endpoint.
        getMonthlyResponseCounts: build.query<{
            months: Array<{ month: string; total: number; bySurvey: Array<{ surveyId: number; surveyName: string; count: number }> }>;
            surveys: Array<{ surveyId: number; surveyName: string; cohortName: string | null; countryCode: string | null }>;
            total: number;
        }, {
            jwtToken: string;
            organisationId: number;
            brandId?: number;
            // 'YYYY-MM' bounds — matched against the same expression the rows
            // are grouped by, so no timezone skew can leak a part-month in.
            fromMonth?: string;
            toMonth?: string;
            cohortIds?: number[];
            countryCodes?: string[];
        }>({
            query: ({ jwtToken, organisationId, brandId, fromMonth, toMonth, cohortIds, countryCodes }) => {
                const qs = new URLSearchParams();
                if (brandId) qs.append('brandId', String(brandId));
                if (fromMonth) qs.append('fromMonth', fromMonth);
                if (toMonth) qs.append('toMonth', toMonth);
                if (cohortIds?.length) qs.append('cohortIds', cohortIds.join(','));
                if (countryCodes?.length) qs.append('countryCodes', countryCodes.join(','));
                const suffix = qs.toString() ? `?${qs.toString()}` : '';
                return {
                    url: `/organisations/${organisationId}/surveys/response-counts/monthly${suffix}`,
                    headers: { Authorization: `Bearer ${jwtToken}` },
                };
            },
            providesTags: [EntityTag.Survey],
        }),

        // Admin: Free-trial progress for an org (null when not on a trial)
        getAdminTrialStatus: build.query<IFreeTrialStatus | null, { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/admin/organisations/${orgId}/subscription/trial-status`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Admin'],
        }),

        // Admin: Reset a running Free Trial back to day 0
        resetAdminFreeTrial: build.mutation<IOrganisationSubscription, { jwtToken: string; orgId: number }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/admin/organisations/${orgId}/subscription/reset-trial`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Admin'],
        }),

        // Organization: Subscription (returns null if no subscription exists)
        getOrganisationSubscription: build.query<IOrganisationSubscription | null, { jwtToken: string; orgId: string }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/subscription`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Billing'],
        }),

        // Organization: Free Trial Status
        getTrialStatus: build.query<IFreeTrialStatus | null, { jwtToken: string; orgId: string }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/subscription/trial-status`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Billing'],
        }),

        // Organization: Entitlements
        getOrganisationEntitlements: build.query<IEntitlementCheckResponse[], { jwtToken: string; orgId: string }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/entitlements`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Entitlements'],
        }),

        getOrganisationEntitlement: build.query<IEntitlementCheckResponse, { jwtToken: string; orgId: string; featureCode: string }>({
            query: ({ jwtToken, orgId, featureCode }) => ({
                url: `/organisations/${orgId}/entitlements/${featureCode}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Entitlements'],
        }),

        // Organization: Tier Access Summary
        getOrganisationTierAccessSummary: build.query<ITierAccessSummary, { jwtToken: string; orgId: string }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/entitlements/tier-summary`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Entitlements'],
        }),

        // Organization: Usage
        recordOrganisationUsage: build.mutation<void, { jwtToken: string; orgId: string; payload: IUsageRecordDto }>({
            query: ({ jwtToken, orgId, payload }) => ({
                url: `/organisations/${orgId}/usage/record`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Entitlements'],
        }),

        getOrganisationUsage: build.query<IEntitlementCheckResponse, { jwtToken: string; orgId: string; featureCode: string }>({
            query: ({ jwtToken, orgId, featureCode }) => ({
                url: `/organisations/${orgId}/usage/${featureCode}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        // Organization: Credits
        getOrganisationCreditsBalance: build.query<ICreditBalanceResponse, { jwtToken: string; orgId: string }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/credits/balance`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Credits'],
        }),

        // Organization: Rewards
        getOrganisationRewards: build.query<IRewardEarning[], { jwtToken: string; orgId: string }>({
            query: ({ jwtToken, orgId }) => ({
                url: `/organisations/${orgId}/rewards/available`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Rewards'],
        }),

        redeemOrganisationReward: build.mutation<void, { jwtToken: string; orgId: string; payload: IRedeemRewardDto }>({
            query: ({ jwtToken, orgId, payload }) => ({
                url: `/organisations/${orgId}/rewards/redeem`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Rewards', 'Credits'],
        }),

        // ===== Customer Segmentation =====

        // Segmentation Fields
        getSegmentationFieldsLimit: build.query<ISegmentationFieldsLimit, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/customer-segmentation/fields/limit',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['SegmentationFields'],
        }),

        getSegmentationFields: build.query<ISegmentationField[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/customer-segmentation/fields',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['SegmentationFields'],
        }),

        getActiveSegmentationFields: build.query<ISegmentationField[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/customer-segmentation/fields/active',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['SegmentationFields'],
        }),

        createSegmentationField: build.mutation<ISegmentationField, { jwtToken: string; payload: ICreateSegmentationFieldDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/customer-segmentation/fields',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['SegmentationFields'],
        }),

        updateSegmentationField: build.mutation<ISegmentationField, { jwtToken: string; fieldId: number; payload: IUpdateSegmentationFieldDto }>({
            query: ({ jwtToken, fieldId, payload }) => ({
                url: `/customer-segmentation/fields/${fieldId}`,
                method: 'PUT',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['SegmentationFields'],
        }),

        deleteSegmentationField: build.mutation<{ success: boolean }, { jwtToken: string; fieldId: number }>({
            query: ({ jwtToken, fieldId }) => ({
                url: `/customer-segmentation/fields/${fieldId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['SegmentationFields'],
        }),

        // Customers
        getCustomers: build.query<ICustomerListResponse, { jwtToken: string; search?: string; limit?: number; offset?: number; includeInactive?: boolean }>({
            query: ({ jwtToken, search, limit, offset, includeInactive }) => ({
                url: '/customer-segmentation/customers',
                headers: { Authorization: `Bearer ${jwtToken}` },
                params: { search, limit, offset, includeInactive },
            }),
            providesTags: ['Customers'],
        }),

        getCustomer: build.query<ICustomer, { jwtToken: string; customerId: number }>({
            query: ({ jwtToken, customerId }) => ({
                url: `/customer-segmentation/customers/${customerId}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['Customers'],
        }),

        createCustomer: build.mutation<ICustomer, { jwtToken: string; payload: ICreateCustomerDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/customer-segmentation/customers',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Customers'],
        }),

        updateCustomer: build.mutation<ICustomer, { jwtToken: string; customerId: number; payload: IUpdateCustomerDto }>({
            query: ({ jwtToken, customerId, payload }) => ({
                url: `/customer-segmentation/customers/${customerId}`,
                method: 'PUT',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['Customers'],
        }),

        deleteCustomer: build.mutation<{ success: boolean }, { jwtToken: string; customerId: number }>({
            query: ({ jwtToken, customerId }) => ({
                url: `/customer-segmentation/customers/${customerId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['Customers'],
        }),

        bulkImportCustomers: build.mutation<{ imported: number; errors: string[] }, { jwtToken: string; customers: ICreateCustomerDto[] }>({
            query: ({ jwtToken, customers }) => ({
                url: '/customer-segmentation/customers/bulk-import',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: { customers },
            }),
            invalidatesTags: ['Customers'],
        }),

        // ===== Customer CSV/Excel Export (SYR-41 Phase 2) =====
        exportCustomers: build.query<
            { blob: Blob; filename: string },
            { jwtToken: string; format: 'csv' | 'xlsx' }
        >({
            query: ({ jwtToken, format }) => ({
                url: '/customer-segmentation/export/customers',
                headers: { Authorization: `Bearer ${jwtToken}` },
                params: { format },
                responseHandler: async (response: Response) => {
                    const blob = await response.blob();
                    const cd = response.headers.get('Content-Disposition') || '';
                    const m = cd.match(/filename="([^"]+)"/);
                    const filename = m ? m[1] : `customers.${format}`;
                    return { blob, filename };
                },
                cache: 'no-cache',
            }),
        }),

        // ===== Customer CSV/Excel Import (SYR-41 Phase 2) =====
        uploadImportFile: build.mutation<ICustomerImportJob, { jwtToken: string; file: File }>({
            query: ({ jwtToken, file }) => {
                const body = new FormData();
                body.append('file', file);
                return {
                    url: '/customer-segmentation/import/upload',
                    method: 'POST',
                    headers: { Authorization: `Bearer ${jwtToken}` },
                    body,
                };
            },
            invalidatesTags: ['CustomerImports'],
        }),

        getImportJob: build.query<ICustomerImportJob, { jwtToken: string; jobId: number }>({
            query: ({ jwtToken, jobId }) => ({
                url: `/customer-segmentation/import/${jobId}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: (_result, _err, { jobId }) => [{ type: 'CustomerImports', id: jobId }],
        }),

        listImportJobs: build.query<ICustomerImportJob[], { jwtToken: string; limit?: number }>({
            query: ({ jwtToken, limit }) => ({
                url: '/customer-segmentation/import',
                headers: { Authorization: `Bearer ${jwtToken}` },
                params: { limit },
            }),
            providesTags: ['CustomerImports'],
        }),

        setImportMapping: build.mutation<ICustomerImportJob, { jwtToken: string; jobId: number; payload: ISetImportMappingDto }>({
            query: ({ jwtToken, jobId, payload }) => ({
                url: `/customer-segmentation/import/${jobId}/mapping`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: (_r, _e, { jobId }) => [{ type: 'CustomerImports', id: jobId }, 'CustomerImports'],
        }),

        getImportPreview: build.query<ICustomerImportPreview, { jwtToken: string; jobId: number; limit?: number; offset?: number; onlyInvalid?: boolean }>({
            query: ({ jwtToken, jobId, limit, offset, onlyInvalid }) => ({
                url: `/customer-segmentation/import/${jobId}/preview`,
                headers: { Authorization: `Bearer ${jwtToken}` },
                params: { limit, offset, onlyInvalid },
            }),
            providesTags: (_r, _e, { jobId }) => [{ type: 'CustomerImports', id: jobId }],
        }),

        commitImport: build.mutation<ICustomerImportJob, { jwtToken: string; jobId: number }>({
            query: ({ jwtToken, jobId }) => ({
                url: `/customer-segmentation/import/${jobId}/commit`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: (_r, _e, { jobId }) => [
                { type: 'CustomerImports', id: jobId },
                'CustomerImports',
                'Customers',
            ],
        }),

        cancelImport: build.mutation<ICustomerImportJob, { jwtToken: string; jobId: number }>({
            query: ({ jwtToken, jobId }) => ({
                url: `/customer-segmentation/import/${jobId}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: (_r, _e, { jobId }) => [{ type: 'CustomerImports', id: jobId }, 'CustomerImports'],
        }),

        // ===== Saved Segments + Cohort Compare (SYR-41 Phase 3) =====
        getSavedSegments: build.query<ISavedSegment[], { jwtToken: string; brandId?: number | null }>({
            query: ({ jwtToken, brandId }) => ({
                url: '/customer-segmentation/saved-segments',
                headers: { Authorization: `Bearer ${jwtToken}` },
                params: brandId !== undefined ? { brandId: brandId === null ? 'null' : String(brandId) } : undefined,
            }),
            providesTags: ['SavedSegments'],
        }),

        // SYR-55 — library usage counter (used + limit + unlimited)
        getSegmentLibraryUsage: build.query<ISegmentLibraryUsage, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/customer-segmentation/saved-segments/library-usage',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['SavedSegments'],
        }),

        // SYR-55 — survey-criteria pickable options for the segment editor
        getSegmentCriteriaOptions: build.query<ISegmentCriteriaOptions, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/customer-segmentation/saved-segments/criteria-options',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
        }),

        getSavedSegment: build.query<ISavedSegment, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/customer-segmentation/saved-segments/${id}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: (_r, _e, { id }) => [{ type: 'SavedSegments', id }],
        }),

        createSavedSegment: build.mutation<ISavedSegment, { jwtToken: string; payload: ICreateSavedSegmentDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/customer-segmentation/saved-segments',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['SavedSegments'],
        }),

        updateSavedSegment: build.mutation<ISavedSegment, { jwtToken: string; id: number; payload: IUpdateSavedSegmentDto }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/customer-segmentation/saved-segments/${id}`,
                method: 'PUT',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: (_r, _e, { id }) => [{ type: 'SavedSegments', id }, 'SavedSegments'],
        }),

        deleteSavedSegment: build.mutation<{ success: boolean }, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/customer-segmentation/saved-segments/${id}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['SavedSegments'],
        }),

        evaluateSavedSegment: build.mutation<IEvaluateSegmentResponse, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/customer-segmentation/saved-segments/${id}/evaluate`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: (_r, _e, { id }) => [{ type: 'SavedSegments', id }, 'SavedSegments'],
        }),

        cohortCompare: build.mutation<ICohortCompareResult, { jwtToken: string; brandHash: string; payload: ICohortCompareRequest }>({
            query: ({ jwtToken, brandHash, payload }) => ({
                url: `/brands/${brandHash}/equity/cohort-compare`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
        }),

        // SYR-55 — Segment Comparison on Trends (multi-segment time series)
        segmentComparisonTimeseries: build.mutation<ISegmentComparisonResponse, { jwtToken: string; brandHash: string; payload: ISegmentComparisonRequest }>({
            query: ({ jwtToken, brandHash, payload }) => ({
                url: `/brands/${brandHash}/segment-comparison/timeseries`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
        }),

        // ===== Customer Integrations (SYR-41 Phase 4) =====
        getCustomerIntegrations: build.query<ICustomerIntegration[], { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/customer-segmentation/integrations',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['CustomerIntegrations'],
        }),

        getCustomerIntegration: build.query<ICustomerIntegration, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/customer-segmentation/integrations/${id}`,
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: (_r, _e, { id }) => [{ type: 'CustomerIntegrations', id }],
        }),

        createCustomerIntegration: build.mutation<ICustomerIntegration, { jwtToken: string; payload: ICreateIntegrationDto }>({
            query: ({ jwtToken, payload }) => ({
                url: '/customer-segmentation/integrations',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['CustomerIntegrations'],
        }),

        updateCustomerIntegration: build.mutation<ICustomerIntegration, { jwtToken: string; id: number; payload: IUpdateIntegrationDto }>({
            query: ({ jwtToken, id, payload }) => ({
                url: `/customer-segmentation/integrations/${id}`,
                method: 'PUT',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: (_r, _e, { id }) => [{ type: 'CustomerIntegrations', id }, 'CustomerIntegrations'],
        }),

        deleteCustomerIntegration: build.mutation<{ success: boolean }, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/customer-segmentation/integrations/${id}`,
                method: 'DELETE',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['CustomerIntegrations'],
        }),

        rotateIntegrationSecret: build.mutation<IRotateSecretResponse, { jwtToken: string; id: number }>({
            query: ({ jwtToken, id }) => ({
                url: `/customer-segmentation/integrations/${id}/rotate-secret`,
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: (_r, _e, { id }) => [{ type: 'CustomerIntegrations', id }, 'CustomerIntegrations'],
        }),

        // SYR-41 Phase 5: kick off the Shopify OAuth install. Returns the
        // authorize URL the SPA should navigate the user to.
        startShopifyInstall: build.query<{ authorizeUrl: string }, { jwtToken: string; shop: string }>({
            query: ({ jwtToken, shop }) => ({
                url: '/integrations/shopify/install',
                headers: { Authorization: `Bearer ${jwtToken}` },
                params: { shop },
            }),
        }),

        // Corporate Site Editor
        editorChat: build.mutation<{
            assistantMessage: string;
            summary: string;
            editsApplied: string[];
            conversationHistory: Array<{ role: string; content: string }>;
        }, { jwtToken: string; payload: { message: string; conversationHistory?: Array<{ role: string; content: string }> } }>({
            query: ({ jwtToken, payload }) => ({
                url: '/editor/chat',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['EditorStatus'],
        }),

        editorDiscard: build.mutation<{
            message: string;
        }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/editor/discard',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['EditorStatus'],
        }),

        editorRevert: build.mutation<{
            commitSha: string;
            message: string;
        }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/editor/revert',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            invalidatesTags: ['EditorStatus'],
        }),

        editorPublish: build.mutation<{
            commitSha: string;
            message: string;
        }, { jwtToken: string; payload: { summary?: string } }>({
            query: ({ jwtToken, payload }) => ({
                url: '/editor/publish',
                method: 'POST',
                headers: { Authorization: `Bearer ${jwtToken}` },
                body: payload,
            }),
            invalidatesTags: ['EditorStatus'],
        }),

        getEditorStatus: build.query<{
            modified: string[];
            added: string[];
            deleted: string[];
            lastCommit: string;
        }, { jwtToken: string }>({
            query: ({ jwtToken }) => ({
                url: '/editor/status',
                method: 'GET',
                headers: { Authorization: `Bearer ${jwtToken}` },
            }),
            providesTags: ['EditorStatus'],
        }),

        // ---- SYR-105 Auto-Concierge (platform admin) --------------------
        getConciergePacks: build.query<IConciergePackListRow[], { jwtToken: string, status?: string }>({
            query: (params) => ({
                url: `/admin/concierge/packs${params.status ? `?status=${params.status}` : ''}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['ConciergePacks'],
        }),

        getConciergePack: build.query<IConciergePackDetail, { jwtToken: string, packId: number }>({
            query: (params) => ({
                url: `/admin/concierge/packs/${params.packId}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['ConciergePacks'],
        }),

        triggerConciergePack: build.mutation<IConciergePack, { jwtToken: string, organisationId: number, allowAfterSent?: boolean }>({
            query: (params) => ({
                url: `/admin/concierge/organisations/${params.organisationId}/trigger`,
                method: 'POST',
                body: { allowAfterSent: params.allowAfterSent ?? false },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergePacks'],
        }),

        updateConciergeDraft: build.mutation<{ lint: IConciergeLintViolation[] }, {
            jwtToken: string, packId: number, patch: Partial<IConciergePackDraft>
        }>({
            query: (params) => ({
                url: `/admin/concierge/packs/${params.packId}/draft`,
                method: 'PATCH',
                body: { patch: params.patch },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergePacks'],
        }),

        approveConciergePack: build.mutation<{ sent: boolean, to: string }, {
            jwtToken: string, packId: number, overrideLint?: boolean
        }>({
            query: (params) => ({
                url: `/admin/concierge/packs/${params.packId}/approve`,
                method: 'POST',
                body: { overrideLint: params.overrideLint ?? false },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergePacks'],
        }),

        killConciergePack: build.mutation<IConciergePack, { jwtToken: string, packId: number, reason?: string }>({
            query: (params) => ({
                url: `/admin/concierge/packs/${params.packId}/kill`,
                method: 'POST',
                body: { reason: params.reason },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergePacks'],
        }),

        retryConciergePack: build.mutation<IConciergePack, { jwtToken: string, packId: number }>({
            query: (params) => ({
                url: `/admin/concierge/packs/${params.packId}/retry`,
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergePacks'],
        }),

        runConciergeTick: build.mutation<{ ran: boolean }, { jwtToken: string }>({
            query: (params) => ({
                url: '/admin/concierge/run-tick',
                method: 'POST',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergePacks'],
        }),

        // SYR-105 phase 2 — the brand's own offer screen, reached from the pack
        // email. The token points at the destination; auth is still required.
        getConciergeOffer: build.query<IConciergeOfferContext, { jwtToken: string; token: string }>({
            query: (params) => ({
                url: `/survey-offer?token=${encodeURIComponent(params.token)}`,
                method: 'GET',
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            providesTags: ['ConciergeOffer'],
        }),

        saveConciergeOffer: build.mutation<
            { surveysUpdated: number; message: string },
            { jwtToken: string; token: string; payload: ISaveConciergeOffer }
        >({
            query: (params) => ({
                url: `/survey-offer?token=${encodeURIComponent(params.token)}`,
                method: 'POST',
                body: params.payload,
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergeOffer'],
        }),

        // SYR-105 — websiteUrl was previously only settable at registration, so
        // every admin-created org had it null and research silently no-opped.
        updateAdminOrganizationWebsiteUrl: build.mutation<
            { websiteUrl: string | null; message: string },
            { jwtToken: string; organizationId: number; websiteUrl: string | null }
        >({
            query: (params) => ({
                url: `/admin/organizations/${params.organizationId}/website-url`,
                method: 'PATCH',
                body: { websiteUrl: params.websiteUrl },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['Admin', 'ConciergePacks'],
        }),

        setConciergeIdentityVerification: build.mutation<{
            identityVerificationStatus: string,
            identityVerifiedAt: string | null,
            identityVerificationNotes: string | null,
        }, { jwtToken: string, organisationId: number, status: 'unverified' | 'verified' | 'rejected', notes?: string }>({
            query: (params) => ({
                url: `/admin/concierge/organisations/${params.organisationId}/identity-verification`,
                method: 'PATCH',
                body: { status: params.status, notes: params.notes },
                headers: { Authorization: `Bearer ${params.jwtToken}` },
            }),
            invalidatesTags: ['ConciergePacks'],
        }),

    }),
});

export const {
    useLoginMutation,
    useResetPasswordMutation,
    useUpdatePasswordMutation,
    useChangePasswordMutation,
    useGetProfileMutation,
    useGetUsersQuery,
    useUpdateUserMutation,
    useCreateUserMutation,
    useCreateOrganisationWithUserMutation,
    useGetAdminOrganisationsQuery,
    // Admin hooks
    useGetAdminVersionQuery,
    useGetAdminOrganizationsQuery,
    useGetAdminSignupFunnelQuery,
    useGetAdminOrganizationDetailsQuery,
    useUpdateOrganizationStatusMutation,
    useUpdateOrganizationFeaturesMutation,
    useUpdateOrganizationBenchmarkStatusMutation,
    useUpdateOrganizationSuppressTrialEmailsMutation,
    useDeleteOrganizationMutation,
    useCreateAdminOrganizationMutation,
    useGetAdminBrandsQuery,
    useGetAdminSurveysQuery,
    useGetAdminSurveyCohortsQuery,
    useGetAdminAnalyticsQuery,
    useGetAdminTokenUsageQuery,
    useGetAdminOrganizationTokenUsageByUserQuery,
    useGetAdminOrganizationMonthlyUsageQuery,
    useGetAdminUsersQuery,
    useCreateAdminUserMutation,
    useUpdateAdminUserMutation,
    useResendAdminUserInviteMutation,
    useResetAdminUserPasswordMutation,
    useGetAdminEventsQuery,
    useGetAdminOrganizationBrandsQuery,
    useGetAdminOrganizationSurveysQuery,
    useGetAdminOrganizationUsersQuery,
    useGetAdminOrganizationEventsQuery,
    useGetAdminOrganizationSubscriptionQuery,
    useGetAdminOrganizationAddonsQuery,
    useCreateDatabaseBackupMutation,
    useGetDatabaseBackupsQuery,
    useGetDatabaseBackupStatusQuery,
    useGetDatabaseBackupDownloadUrlMutation,
    useDeleteDatabaseBackupMutation,
    // Regular hooks
    useGetBrandsQuery,
    useGetBrandQuery,
    useGetBrandKnowledgeQuery,
    useUpdateBrandKnowledgeMutation,
    useGetBrandKnowledgeDocumentsQuery,
    useUploadBrandKnowledgeDocumentMutation,
    useAddBrandKnowledgeScrapeMutation,
    useRescrapeBrandKnowledgeDocumentMutation,
    useDeleteBrandKnowledgeDocumentMutation,
    useLazyGetBrandKnowledgeDocumentDownloadUrlQuery,
    useLazyGetBrandKnowledgeDocumentTextQuery,
    useUpdateBrandKnowledgeDocumentTextMutation,
    useRedistillBrandKnowledgeDocumentMutation,
    useSetBrandKnowledgeDocumentIncludeInContextMutation,
    useSuggestFieldsFromDocumentMutation,
    useSuggestFieldsFromKnowledgeMutation,
    useGetAdminBrandKnowledgeQuery,
    useLazyGetAdminBrandKnowledgeDocumentDownloadUrlQuery,
    useCreateBrandMutation,
    useUpdateBrandMutation,
    useUpdateBrandNameMutation,
    useGetSurveysQuery,
    useGetCohortsByBrandQuery,
    useCreateSurveyMutation,
    useUpdateSurveyMutation,
    useUpdateSurveyStatusMutation,
    useSoftDeleteSurveyMutation,
    useGetSurveyCohortsQuery,
    useGetActiveSurveysForCohortQuery,
    useGetBrandCohortsQuery,
    useCreateBrandCohortMutation,
    useUpdateBrandCohortMutation,
    useDeactivateBrandCohortMutation,
    useDeleteBrandCohortMutation,
    useGetBrandEquityQuery,
    useGetBrandEquityTrendsQuery,
    useGetBrandEquityDimensionDetailsQuery,
    useExportBrandEquityDataMutation,
    useGetQuestionTemplatesQuery,
    useGetCoreQuestionTemplatesQuery,
    useUpdateQuestionTemplateMutation,
    // Statement Template Management hooks
    useGetTemplateTypesQuery,
    useGetTemplatesByTypeQuery,
    useCloneTemplateTypeMutation,
    useImportTemplateTypeMutation,
    useDeleteTemplateTypeMutation,
    useGetSurveyResponsesQuery,
    useGetSurveyResponseSummaryQuery,
    useGetSurveyResponseDetailsQuery,
    useDeleteSurveyResponseMutation,
    useDeleteSurveyResponsesMutation,
    useExportAdminSurveyResponsesMutation,
    useExportParticipantListMutation,
    useExportAdminParticipantListMutation,
    useGetQuestionCoverageQuery,
    useCalculateBrandEquityMutation,
    useGetStaleCachedBrandEquityMutation,
    useGetMarketerBriefingQuery,
    useDismissMarketerRecommendationMutation,
    useRegenerateMarketerRecommendationsMutation,
    useGetConciergePacksQuery,
    useGetConciergePackQuery,
    useTriggerConciergePackMutation,
    useUpdateConciergeDraftMutation,
    useApproveConciergePackMutation,
    useKillConciergePackMutation,
    useRetryConciergePackMutation,
    useRunConciergeTickMutation,
    useSetConciergeIdentityVerificationMutation,
    useUpdateAdminOrganizationWebsiteUrlMutation,
    useGetConciergeOfferQuery,
    useSaveConciergeOfferMutation,
    useGetBrandHypothesisQuery,
    useGetBrandModelBeliefsQuery,
    useGetBrandModelBeliefsAccessQuery,
    useRequestBrandModelBeliefsMutation,
    useResynthesiseBrandModelBeliefsMutation,
    useDismissBrandHypothesisMutation,
    useGetMarketerActionPlanQuery,
    useGetMarketerActionPlanHistoryQuery,
    useAddMarketerActionPlanPlayMutation,
    useRemoveMarketerActionPlanPlayMutation,
    useArchiveMarketerActionPlanMutation,
    useSetMarketerActionPlanAssigneeMutation,
    useSetMarketerActionPlanDoneMutation,
    useReanalyzeElementMutation,
    useCalculateAdminBrandEquityMutation,
    useGetStaleCachedAdminBrandEquityMutation,
    useGetAdminBrandStatementsQuery,
    useGetApiKeysQuery,
    useCreateApiKeyMutation,
    useUpdateApiKeyMutation,
    useRevokeApiKeyMutation,
    useGetSubscriptionsQuery,
    useCreateSubscriptionMutation,
    useUpdateSubscriptionMutation,
    useCancelSubscriptionMutation,
    useReactivateSubscriptionMutation,
    useGetPaymentMethodsQuery,
    useSyncPaymentMethodsMutation,
    useSyncSubscriptionMutation,
    useGetAnnualPromotionQuery,
    useCreateSetupIntentMutation,
    useAttachPaymentMethodMutation,
    useDetachPaymentMethodMutation,
    useSetDefaultPaymentMethodMutation,
    useGetInvoicesQuery,
    useLazyGetInvoicesQuery,
    useDownloadInvoiceMutation,
    useGetBrandSubscriptionFeaturesQuery,
    useUpdateOrganisationDetailsMutation,
    useGetMyProfileQuery,
    useUpdateUserProfileMutation,
    useCompleteOnboardingMutation,
    useGetNotificationPreferencesQuery,
    useUpdateNotificationPreferencesMutation,
    // Notification subscription hooks
    useGetNotificationTopicsQuery,
    useGetNotificationSubscriptionsQuery,
    useCreateNotificationSubscriptionMutation,
    useUpdateNotificationSubscriptionMutation,
    useDeleteNotificationSubscriptionMutation,
    // AI Experts Admin hooks
    useGetAIExpertSystemStatsQuery,
    useGetAIExpertsQuery,
    useGetAIExpertConfigQuery,
    useUpdateAIExpertMutation,
    useToggleAIExpertStatusMutation,
    useGetKnowledgeDocumentsQuery,
    useGetDocumentStatsQuery,
    useUploadKnowledgeDocumentMutation,
    useReprocessDocumentMutation,
    useDeleteKnowledgeDocumentMutation,
    useGetVectorStatsQuery,
    // AI Expert User hooks
    useGetAvailableExpertsQuery,
    useGetExpertInfoQuery,
    useCheckExpertAccessMutation,
    useChatWithExpertMutation,
    useCreateAIConversationMutation,
    useGetUserConversationsQuery,
    useGetAIConversationQuery,
    useDeleteAIConversationMutation,
    useGetUsageStatsQuery,
    // Dashboard AI hooks
    useGetDashboardAIConfigsQuery,
    useUpdateDashboardAIConfigMutation,
    useGenerateDashboardInsightMutation,
    useGetAllDashboardInsightsQuery,
    useGetAllDashboardInsightsWithDataMutation,
    useGetSingleDashboardInsightWithDataMutation,
    // Advice AI hooks (customer-facing only — admin config went to /admin/ai)
    useGetAllAdviceInsightsWithDataMutation,
    useGetSingleAdviceInsightWithDataMutation,
    // Orbital AI hooks (customer-facing only — admin config went to /admin/ai)
    useGetOrbitalItemsQuery,
    useRefreshOrbitalItemsMutation,
    // Building Blocks AI hooks (customer-facing only — admin config went to /admin/ai)
    useGetBuildingBlocksInsightsMutation,
    // Impersonation hooks
    useStartImpersonationMutation,
    useStopImpersonationMutation,
    useReturnToAdminMutation,
    // Admin Agency hooks
    useGetAdminAgenciesQuery,
    useCreateAdminAgencyMutation,
    useAssignAdminOrganizationAgencyMutation,
    useRemoveAdminOrganizationAgencyMutation,
    // Agency hooks
    useGetAgencyPortfolioAnalyticsQuery,
    useGetAgencyBrandTrendQuery,
    useGetAgencyClientScorecardQuery,
    useGetAgencyClientsQuery,
    useGetAgencyMyClientsQuery,
    useCreateAgencyClientOrgMutation,
    useInviteAgencyClientMutation,
    useRemoveAgencyClientMutation,
    useSwitchToClientContextMutation,
    useReturnToAgencyContextMutation,
    useGetAgencyDashboardActivityQuery,
    useGetAgencyPortfolioSummaryQuery,
    useGetAgencyAlertsQuery,
    useGetAgencyBusinessTypesQuery,
    useGetAgencyProductTypesQuery,
    useGetAgencyBillingSummaryQuery,
    useGetAgencyPaymentMethodsQuery,
    useAssumeAgencyBillingMutation,
    useReleaseAgencyBillingMutation,
    useGetMyAgencyQuery,
    useAcceptAgencyInvitationMutation,
    useDeclineAgencyInvitationMutation,
    useDisconnectFromAgencyMutation,
    // 2FA hooks
    useTwoFactorStatusQuery,
    useTwoFactorSetupMutation,
    useTwoFactorEnableMutation,
    useTwoFactorVerifyMutation,
    useTwoFactorDisableMutation,
    useTwoFactorRegenerateBackupCodesMutation,
    // System Settings hooks
    useGetSystemSettingsQuery,
    useGetSystemSettingsByCategoryQuery,
    useUpdateSystemSettingsBatchMutation,
    useGetSystemSettingQuery,
    useGetAiPublishedVersionsQuery,
    useCreateSystemSettingMutation,
    useUpdateSystemSettingMutation,
    useDeleteSystemSettingMutation,
    // Available AI Models
    useGetAvailableAIModelsQuery,
    // Job Locking hooks
    useGetJobLocksQuery,
    useGetJobHistoryQuery,
    useGetJobStatisticsQuery,
    useForceUnlockJobMutation,
    useRunJobManuallyMutation,
    useUpdateJobConfigMutation,
    // Cache Management hooks
    useGetCacheStatsQuery,
    useInvalidateBrandCacheMutation,
    useInvalidateOrganizationCacheMutation,
    useForceRefreshBrandEquityCacheMutation,
    // Brand Analytics hooks
    useGetAdminBrandsForAnalyticsQuery,
    useGetAdminBrandAnalyticsQuery,
    useGetAdminBrandAnalyticsMetricsQuery,
    useGetAdminBrandAnalyticsDrillDownQuery,
    useGetOrgBrandsQuery,
    useGetOrgBrandAnalyticsQuery,
    useGetOrgBrandAnalyticsMetricsQuery,
    useGetOrgBrandAnalyticsDrillDownQuery,
    // Mock Data hooks
    useGetMockDataStatusQuery,
    useGenerateTestMockDataMutation,
    useGenerateFullMockDataMutation,
    useCleanMockDataMutation,
    // Messages hooks
    useGetInboxQuery,
    useGetInboxStatsQuery,
    useGetMessageQuery,
    useUpdateMessageStatusMutation,
    useBulkUpdateMessageStatusMutation,
    useMarkAllAsReadMutation,
    useEmptyTrashMutation,
    useGetMessagePreferencesQuery,
    useUpdateMessagePreferencesMutation,
    useGetAdminStatsQuery,
    useGetAllMessagesQuery,
    useGetMessageTypesQuery,
    useGetMessageDetailsQuery,
    useSendMessageMutation,
    useScheduleMessageMutation,
    useDeleteMessageMutation,
    // Response Monitoring hooks
    useGetPendingResponseMonitoringMessagesQuery,
    useApproveResponseMonitoringMessageMutation,
    useRejectResponseMonitoringMessageMutation,
    useRegenerateResponseMonitoringMessageMutation,
    useSendTestEmailForResponseMonitoringMessageMutation,
    useGetResponseMonitoringStatisticsQuery,
    useGetBrandMonitoringHistoryQuery,
    useGetBrandMonitoringConfigQuery,
    useUpdateBrandMonitoringConfigMutation,
    useGetResponseMonitoringScheduleQuery,
    useUpdateResponseMonitoringScheduleMutation,
    useTriggerResponseMonitoringCheckMutation,
    useTriggerResponseMonitoringMessageGenerationMutation,
    // Response Integrity hooks (SYR-48 Phase 3)
    useGetFlaggedResponsesQuery,
    useGetFlaggedResponseDetailQuery,
    useRejectFlaggedResponseMutation,
    useConfirmCleanFlaggedResponseMutation,
    useRescoreFlaggedResponseMutation,
    useBulkRejectFlaggedResponsesMutation,
    useBulkConfirmCleanFlaggedResponsesMutation,
    useBulkRescoreFlaggedResponsesMutation,
    useGetBrandEquityIntegrityComparisonQuery,
    useGetCohortComparisonQuery,
    useGetChargebacksQuery,
    useGetChargebackDetailQuery,
    useCreateChargebackMutation,
    useUpdateChargebackStatusMutation,
    useGetPanelStatsQuery,
    useGetIntegrityDetectorsQuery,
    useUpdateIntegrityDetectorConfigMutation,
    useGetIntegritySettingsQuery,
    useUpdateIntegritySettingsMutation,
    useGetIntegrityLlmCostQuery,
    useGetDataQualitySummaryQuery,
    // AI Quota hooks
    useGetAIQuotaStatusQuery,
    useGetAdminOrganizationQuotaStatusQuery,
    // Benchmarking hooks
    useGetBrandBenchmarksQuery,
    useGetOrgBrandBenchmarksQuery,
    useGetAllBenchmarksQuery,
    useCalculateBenchmarksMutation,
    useInitializeBenchmarkCategoriesMutation,
    useGetBenchmarkingPreferencesQuery,
    useUpdateBenchmarkingPreferencesMutation,
    // Benchmark group hooks
    useGetBenchmarkBusinessTypesQuery,
    useGetBenchmarkProductTypesQuery,
    useGetAdminBenchmarkBusinessTypesQuery,
    useCreateBenchmarkBusinessTypeMutation,
    useUpdateBenchmarkBusinessTypeMutation,
    useDeleteBenchmarkBusinessTypeMutation,
    useSetBusinessTypeProductTypesMutation,
    useGetAdminBenchmarkProductTypesQuery,
    useCreateBenchmarkProductTypeMutation,
    useUpdateBenchmarkProductTypeMutation,
    useDeleteBenchmarkProductTypeMutation,
    useGetQuestionTemplateTypesQuery,
    useGetAdminQuestionTemplateTypesQuery,
    useCreateQuestionTemplateTypeMutation,
    useUpdateQuestionTemplateTypeMutation,
    useDeleteQuestionTemplateTypeMutation,
    // Custom Brand Charts hooks
    useGetCustomBrandChartsQuery,
    useCreateCustomBrandChartMutation,
    useUpdateCustomBrandChartMutation,
    useDeleteCustomBrandChartMutation,
    useReorderCustomBrandChartsMutation,
    // CloudWatch Logs hooks
    useGetCloudWatchLogGroupsQuery,
    useGetCloudWatchLogStreamsQuery,
    useGetCloudWatchLogEventsQuery,
    // Embedded CRM hooks (SYR-84)
    useGetCrmCompaniesQuery,
    useGetCrmCompanyQuery,
    useCreateCrmCompanyMutation,
    useUpdateCrmCompanyMutation,
    useLinkCrmCompanyMutation,
    useUnlinkCrmCompanyMutation,
    useGetCrmActivitiesQuery,
    useCreateCrmActivityMutation,
    useCreateCrmContactMutation,
    useUpdateCrmContactMutation,
    useDeleteCrmContactMutation,
    useGetCrmTasksQuery,
    useCreateCrmTaskMutation,
    useUpdateCrmTaskMutation,
    useGetMyCrmRemindersQuery,
    useGetCrmPipelineStagesQuery,
    useUpdateCrmPipelineStageMutation,
    useGetCrmLinkSuggestionsQuery,
    useConfirmCrmLinkSuggestionMutation,
    useRejectCrmLinkSuggestionMutation,
    useGetCrmSyncStatusQuery,
    useGetMailThreadsQuery,
    useGetMailThreadQuery,
    useGetMailSendersQuery,
    useGetMailSyncStatusQuery,
    useMarkMailThreadReadMutation,
    useSetMailFollowUpMutation,
    useSetMailArchivedMutation,
    useMarkAllMailReadMutation,
    useLazySearchMailRecipientsQuery,
    useRunMailSyncMutation,
    useSendMailMutation,
    useUploadMailAttachmentMutation,
    useAssignMailThreadMutation,
    useBackfillMailAssignmentsMutation,
    useRunCrmSyncMutation,
    useRunCrmLinkingMutation,
    useRunCrmHealthMutation,
    useGetCrmEmailTemplatesQuery,
    useCreateCrmEmailTemplateMutation,
    useUpdateCrmEmailTemplateMutation,
    useDeleteCrmEmailTemplateMutation,
    useGetCrmEmailSendersQuery,
    useLogCrmReceivedEmailMutation,
    useGetOrganizationActivityQuery,
    useGetLiveAnalyticsQuery,
    useGetCrmReportsQuery,
    useRunCrmPostHogMutation,
    useSendCrmEmailMutation,
    useGetCrmInboxQuery,
    useGetCrmInboundEmailQuery,
    useLazyGetCrmInboundEmailQuery,
    useRunCrmInboxSyncMutation,
    useAssignCrmInboundEmailMutation,
    useIgnoreCrmInboundEmailMutation,
    useLazyGetCrmInboundAttachmentUrlQuery,
    useLazyGetCrmSentAttachmentUrlQuery,
    useUploadCrmEmailImageMutation,
    useGetCrmFunnelQuery,
    // Support Tickets hooks
    useGetAdminTicketsQuery,
    useGetAdminTicketStatsQuery,
    useGetAdminTicketQuery,
    useUpdateTicketMutation,
    useAddAdminTicketCommentMutation,
    useUploadAdminTicketAttachmentMutation,
    useDeleteAdminTicketAttachmentMutation,
    useGetMyTicketsQuery,
    useGetTicketQuery,
    useCreateTicketMutation,
    useAddTicketCommentMutation,
    useUploadTicketAttachmentMutation,
    useGetTicketCategoriesQuery,
    // Legal Documents hooks
    useGetPrivacyPolicyQuery,
    useGetTermsOfServiceQuery,
    useGetCurrentLegalDocumentsQuery,
    // Public config hooks
    useGetSignupConfigQuery,
    useGetQualificationConfigQuery,
    useGetSurveyConfigQuery,
    useGetDashboardConfigQuery,
    // Charter Cohort hooks (SYR-106)
    useGetCharterConfigQuery,
    useMoveOrganizationToCharterMutation,
    useSubmitCharterApplicationMutation,
    useVerifyWaitlistInviteQuery,
    useGetCharterApplicationsQuery,
    useGetCharterApplicationStatsQuery,
    useReviewCharterApplicationMutation,
    // Public Hypothesis lead generator hooks (SYR-107)
    useGetPublicHypothesisConfigQuery,
    useRequestPublicHypothesisMutation,
    useResendPublicHypothesisPinMutation,
    useVerifyPublicHypothesisPinMutation,
    useGetPublicHypothesisStatusQuery,
    useGetPublicHypothesisResultQuery,
    useRecordPublicHypothesisCtaMutation,
    useRecordPublicHypothesisVideoMutation,
    useUnsubscribePublicHypothesisQuery,
    useGetHypothesisLeadsQuery,
    useGetHypothesisLeadStatsQuery,
    useGetHypothesisLeadResultLinkMutation,
    useReviewHypothesisLeadMutation,
    useDeleteHypothesisLeadMutation,
    useSetHypothesisReviewSourcesMutation,
    useLazyGetHypothesisReviewSourcesQuery,
    useGetHypothesisResultPreviewQuery,
    useGetHypothesisSubjectDetailQuery,
    useReformHypothesisSubjectMutation,
    useContinueHypothesisWithReviewsMutation,
    useGetHypothesisDomainPoliciesQuery,
    useSaveHypothesisDomainPolicyMutation,
    useDeleteHypothesisDomainPolicyMutation,
    // Waitlist hooks
    useJoinWaitlistMutation,
    useGetWaitlistEntriesQuery,
    useGetWaitlistStatsQuery,
    useUpdateWaitlistEntryStatusMutation,
    useUpdateWaitlistEntryMutation,
    useInviteWaitlistEntryMutation,
    useGetPasswordSetConfigQuery,
    useGetLegalAcceptanceStatusQuery,
    useAcceptLegalDocumentMutation,
    useAcceptMultipleLegalDocumentsMutation,
    useGetLegalAcceptanceHistoryQuery,
    // Cookie Consent hooks
    useGetCookieConsentQuery,
    useSaveCookieConsentMutation,
    useLinkCookieConsentSessionMutation,
    // Admin Legal Documents hooks
    useGetAdminLegalDocumentsQuery,
    useGetAdminLegalDocumentQuery,
    useCreateLegalDocumentMutation,
    useActivateLegalDocumentMutation,
    useGetLegalDocumentStatsQuery,
    // Final Questions hooks
    useGetAdminFinalQuestionsQuery,
    useCreateAdminFinalQuestionMutation,
    useUpdateAdminFinalQuestionMutation,
    useDeleteAdminFinalQuestionMutation,
    useBulkApplyFinalQuestionMutation,
    useGetActiveFinalQuestionsQuery,
    useGetSurveyFinalResponsesQuery,
    // Subscription hooks - Admin
    useGetAdminSubscriptionPlansQuery,
    useCreateAdminSubscriptionPlanMutation,
    useUpdateAdminSubscriptionPlanMutation,
    useDeleteAdminSubscriptionPlanMutation,
    useSyncPlanToStripeMutation,
    useSyncAllPlansToStripeMutation,
    useRetryFailedStripeSyncMutation,
    useGetAdminAddonsQuery,
    useCreateAdminAddonMutation,
    useUpdateAdminAddonMutation,
    useDeleteAdminAddonMutation,
    useSyncAddonToStripeMutation,
    useSyncAllAddonsToStripeMutation,
    // Organisation Addon hooks
    useGetAvailableAddonsQuery,
    useGetPurchasedAddonsQuery,
    useGetActiveAddonsQuery,
    useGetAvailableCreditsForAddonsQuery,
    usePreviewAddonPurchaseQuery,
    useCreateAddonCheckoutMutation,
    useCreateAddonPaymentIntentMutation,
    useCreateAddonSubscriptionMutation,
    useGetAddonPaymentMethodsQuery,
    useConfirmAddonPaymentMutation,
    useCancelOrganisationAddonMutation,
    useCheckHasAddonQuery,
    useGetAdminFeaturesQuery,
    useCreateAdminFeatureMutation,
    useUpdateAdminFeatureMutation,
    useGetAdminPlanEntitlementsQuery,
    useCreateAdminPlanEntitlementMutation,
    useUpdateAdminPlanEntitlementMutation,
    useDeleteAdminPlanEntitlementMutation,
    useGetAdminAddonEntitlementsQuery,
    useCreateAdminAddonEntitlementMutation,
    useUpdateAdminAddonEntitlementMutation,
    useDeleteAdminAddonEntitlementMutation,
    useGetAdminFoundingCohortQuery,
    useUpdateAdminFoundingCohortStatusMutation,
    useGetAdminEligibleOrganisationsQuery,
    useBulkAddFoundingCohortMembersMutation,
    useChangeAdminOrganisationPlanMutation,
    useStartAdminFreeTrialMutation,
    useResetAdminFreeTrialMutation,
    useGetAdminTrialStatusQuery,
    useGetMonthlyResponseCountsQuery,
    // Subscription hooks - Organization
    useGetOrganisationSubscriptionQuery,
    useGetTrialStatusQuery,
    useGetOrganisationEntitlementsQuery,
    useGetOrganisationEntitlementQuery,
    useGetOrganisationTierAccessSummaryQuery,
    useRecordOrganisationUsageMutation,
    useGetOrganisationUsageQuery,
    useGetOrganisationCreditsBalanceQuery,
    useGetOrganisationRewardsQuery,
    useRedeemOrganisationRewardMutation,
    // Admin Reward Tiers hooks
    useGetAdminRewardTiersQuery,
    useGetAdminRewardTierQuery,
    useCreateAdminRewardTierMutation,
    useUpdateAdminRewardTierMutation,
    useDeleteAdminRewardTierMutation,
    useGetAdminRewardEarningsQuery,
    useGetAdminRewardRedemptionsQuery,
    useGetAdminRewardStatsQuery,
    useGrantAdminRewardMutation,
    // Customer Segmentation - Fields
    useGetSegmentationFieldsLimitQuery,
    useGetSegmentationFieldsQuery,
    useGetActiveSegmentationFieldsQuery,
    useCreateSegmentationFieldMutation,
    useUpdateSegmentationFieldMutation,
    useDeleteSegmentationFieldMutation,
    // Customer Segmentation - Customers
    useGetCustomersQuery,
    useGetCustomerQuery,
    useCreateCustomerMutation,
    useUpdateCustomerMutation,
    useDeleteCustomerMutation,
    useBulkImportCustomersMutation,
    // Customer Segmentation - Import / Export (Phase 2)
    useLazyExportCustomersQuery,
    useUploadImportFileMutation,
    useGetImportJobQuery,
    useListImportJobsQuery,
    useSetImportMappingMutation,
    useGetImportPreviewQuery,
    useCommitImportMutation,
    useCancelImportMutation,
    // Customer Segmentation - Saved Segments + Cohort Compare (Phase 3)
    useGetSavedSegmentsQuery,
    useGetSavedSegmentQuery,
    useGetSegmentLibraryUsageQuery,
    useGetSegmentCriteriaOptionsQuery,
    useCreateSavedSegmentMutation,
    useUpdateSavedSegmentMutation,
    useDeleteSavedSegmentMutation,
    useEvaluateSavedSegmentMutation,
    useCohortCompareMutation,
    useSegmentComparisonTimeseriesMutation,
    // Customer Segmentation - Integrations (Phase 4)
    useGetCustomerIntegrationsQuery,
    useGetCustomerIntegrationQuery,
    useCreateCustomerIntegrationMutation,
    useUpdateCustomerIntegrationMutation,
    useDeleteCustomerIntegrationMutation,
    useRotateIntegrationSecretMutation,
    useLazyStartShopifyInstallQuery,
    // Corporate Site Editor hooks
    useEditorChatMutation,
    useEditorDiscardMutation,
    useEditorRevertMutation,
    useEditorPublishMutation,
    useGetEditorStatusQuery,
    } = api;

export { EntityTag } from "./types";
export type {
    IApiUser,
    IAIExpert,
    IKnowledgeDocument,
    IDocumentStats,
    IAIConversation,
    IAIMessage,
    IExpertSummary,
    ISystemStats,
    IUpdateExpertRequest,
    IChatRequest,
    IChatResponse,
    IImpersonationRequest,
    IImpersonationResponse,
    IImpersonationStopResponse,
    IReturnToAdminResponse,
    IAgencyContextResponse,
    IAgencyReturnResponse,
    IAgencyClient,
    IAgencyPortfolioClient,
    IAgencyClientBrandSummary,
    IAgencyPortfolioSummary,
    IAgencyActivityFeed,
    IAgencyActivityItem,
    IAgencyInviteClientDto,
    IAgencyUserAccess,
    IAgencyPortfolioAnalytics,
    IAgencyBrandTrend,
    IAgencyBrandTrendPoint,
    IAgencyClientScorecard,
    IAgencyBrandBucket,
    IAgencyElementScore,
    IAgencyBenchmarkPosition,
    IAgencySignal,
    IAgencyAnalyticsBrand,
    IAgencyAnalyticsClient,
    IAdminBrandResponse,
    IBrandKnowledgeProfile,
    IHypothesisCard,
    IModelBeliefsRead,
    IModelBeliefsGateSummary,
    IModelBeliefsCell,
    IModelBeliefsStatementRead,
    IModelBeliefsPageMove,
    IModelBeliefsPageMoves,
    IModelBeliefsPageFinding,
    IModelBeliefsPageFindings,
    IModelBeliefsPageReading,
    IModelBeliefsSynthesis,
    IModelBeliefsRecordFix,
    IUpdateBrandKnowledge,
    IBrandKnowledgeInspection,
    IBrandKnowledgeDocument,
    IBrandKnowledgeDocumentText,
    IBrandFieldSuggestions,
    IAdminSurveyResponse,
    IAdminSurveyCohortResponse,
    ITokenUsageSummary,
    IUserTokenUsage,
    IOrganizationTokenUsageByUser,
    IBrandAnalytics,
    IBrandAnalyticsSummary,
    IBrandAnalyticsMonthlyData,
    IBrandAnalyticsLatentElementScore,
    IBrandAnalyticsMeasuredElementScore,
    IBrandAnalyticsMetricOption,
    IBrandEquityScoreResponse,
    IDashboardAIConfig,
    IUpdateDashboardConfigRequest,
    IDashboardInsightRequest,
    IDashboardInsightResponse,
    IDashboardInsightsResponse,
    IAdviceAIConfig,
    IUpdateAdviceConfigRequest,
    IAdviceInsightResponse,
    IAdviceInsightsResponse,
    IOrbitalAIConfig,
    IUpdateOrbitalConfigRequest,
    IOrbitalItemResult,
    IOrbitalItemsResponse,
    IBuildingBlocksAIConfig,
    IUpdateBuildingBlocksConfigRequest,
    IBuildingBlocksInsightResult,
    IBuildingBlocksInsightsResponse,
    IMessage,
    IMessageType,
    IMessageRecipient,
    IMessagePreference,
    IInboxStats,
    IAdminStats,
    ICreateMessageDto,
    IUpdateMessageStatusDto,
    IBulkUpdateMessageStatusDto,
    IBulkUpdatePreferencesDto,
    ICustomBrandChart,
    ICreateCustomBrandChartRequest,
    IUpdateCustomBrandChartRequest,
    IReorderCustomBrandChartsRequest,
    IQuestionTemplateType,
    IQuestionTemplateTypeInput,
    IQualificationConfig,
    ISubscriptionPlan,
    ICreateSubscriptionPlanDto,
    IUpdateSubscriptionPlanDto,
    IFeatureDefinition,
    ICreateFeatureDto,
    IUpdateFeatureDto,
    IPlanEntitlement,
    ICreatePlanEntitlementDto,
    ValueType,
    IAddonEntitlement,
    ICreateAddonEntitlementDto,
    IOrganisationSubscription,
    IFreeTrialStatus,
    IEntitlementCheckResponse,
    IRestrictedAllowedElements,
    IBenchmarkingAccessResult,
    ITierAccessSummary,
    IUsageRecordDto,
    ICreditBalanceResponse,
    IConsumeCreditsDto,
    IFoundingCohortMember,
    IUpdateFoundingCohortStatusDto,
    IEligibleOrganisation,
    IBulkAddFoundingCohortResult,
    IRewardEarning,
    IRedeemRewardDto,
    IRewardTier,
    ICreateRewardTierDto,
    IUpdateRewardTierDto,
    IGrantRewardDto,
    IRewardRedemption,
    IRewardStats,
    RewardType,
    RewardStatus,
    IStripeSyncResult,
    IStripeBulkSyncResult,
    IStripeRetryResult,
    AddonType,
    IAddon,
    ICreateAddonDto,
    IUpdateAddonDto,
    AddonStatus,
    IOrganisationAddon,
    IAvailableRewardCredit,
    IAddonPurchasePreview,
    ICheckoutResult,
    IPaymentIntentResult,
    IAddonSubscriptionResult,
    IAddonPaymentMethod,
    // Customer Segmentation
    SegmentationFieldType,
    SegmentationFieldSource,
    ISegmentationFieldMetadata,
    ISegmentationField,
    ICreateSegmentationFieldDto,
    IUpdateSegmentationFieldDto,
    ISegmentationValue,
    ICustomer,
    ICreateCustomerDto,
    IUpdateCustomerDto,
    ICustomerListResponse,
    ISegmentationFieldsLimit,
    // Customer Import / Export
    ImportFileType,
    ImportState,
    ImportMatchStrategy,
    ImportConflictPolicy,
    ImportCoreSlot,
    ColumnMappingTarget,
    ImportColumnMapping,
    IImportErrorSample,
    ICustomerImportJob,
    ICustomerImportRow,
    ICustomerImportPreview,
    ISetImportMappingDto,
    // Saved Segments + Cohort Compare
    SegmentOperator,
    MatchLogic,
    ISegmentFilterCriterion,
    ISegmentSurveyCriteria,
    ISavedSegment,
    ICreateSavedSegmentDto,
    IUpdateSavedSegmentDto,
    ISegmentLibraryUsage,
    ISegmentCriteriaOptions,
    ISegmentComparisonSpec,
    ISegmentComparisonDateRange,
    ISegmentComparisonPeriod,
    ISegmentComparisonRequest,
    ISegmentComparisonBucket,
    ISegmentComparisonSeries,
    ISegmentComparisonResponse,
    IEvaluateSegmentResponse,
    ISurveyCohort,
    ICohortDefinition,
    ICohortCompareRequest,
    ICohortDeltas,
    SampleSizeWarningCode,
    ISampleSizeWarning,
    ICohortCompareResult,
    // Customer Integrations
    IntegrationType,
    IntegrationStatus,
    IntegrationCoreSlot,
    IntegrationColumnMappingTarget,
    IntegrationColumnMapping,
    IIntegrationConfig,
    ICustomerIntegration,
    ICreateIntegrationDto,
    IUpdateIntegrationDto,
    IRotateSecretResponse,
    ISignupFunnelResponse,
    IConciergePack,
    IConciergePackDetail,
    IConciergePackDraft,
    IConciergePackListRow,
    IConciergeOfferContext,
    ISaveConciergeOffer,
    IConciergeLintViolation,
} from "./types";

export type { IQuestionTemplate };
export { api };
export default api;
